[
  {
    "id": 341,
    "uuid": "c65321d3-ed6a-49f8-b386-18ebdc17faa1",
    "hitokoto": "只有破碎的心才有伤人的棱角。",
    "type": "e",
    "from": "岁碎叶",
    "from_who": null,
    "creator": "岁碎叶",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949350",
    "length": 14
  },
  {
    "id": 342,
    "uuid": "0618de84-9545-43d5-980f-046cc217c722",
    "hitokoto": "如果你是我该多好，那你就会知道我有多难过，多喜欢你。",
    "type": "e",
    "from": "魔法师baby乖",
    "from_who": null,
    "creator": "魔法师baby乖",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949351",
    "length": 26
  },
  {
    "id": 343,
    "uuid": "a1da853a-a981-4e9a-a5ec-7aacc153e88f",
    "hitokoto": "就算你已经不在，就算你身边的人已经不再是我，我也会坚强的活下去，为了你。",
    "type": "e",
    "from": "十六夜暁",
    "from_who": null,
    "creator": "十六夜暁",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949351",
    "length": 36
  },
  {
    "id": 344,
    "uuid": "f9c47630-6c8e-47af-81bf-bb6c92f8d083",
    "hitokoto": "今天的早餐是：早苗的面包、秋子的果酱和观铃的果汁~",
    "type": "e",
    "from": "Mion",
    "from_who": null,
    "creator": "Mion",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949351",
    "length": 25
  },
  {
    "id": 345,
    "uuid": "94c3db12-ef22-4528-8899-2763a88686c3",
    "hitokoto": "如果没什么好事发生的话，就把没有发生坏事的每一天当作好事吧。",
    "type": "e",
    "from": "万事屋神乐酱",
    "from_who": null,
    "creator": "万事屋神乐酱",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949351",
    "length": 30
  },
  {
    "id": 346,
    "uuid": "ef2de807-d9b3-416d-8fe9-89e9bf15f7b6",
    "hitokoto": "“你没车没房没卡,拿什么和我谈恋爱？”“......我有高达......”",
    "type": "e",
    "from": "gundam",
    "from_who": null,
    "creator": "弄它",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949351",
    "length": 37
  },
  {
    "id": 347,
    "uuid": "37ff6b82-7a4c-4eab-8371-d5178f052c0d",
    "hitokoto": "既然我无法停留，那么就飞到我再也不能飞的那一天吧。",
    "type": "e",
    "from": "シ舀シ舀",
    "from_who": null,
    "creator": "シ舀シ舀",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949352",
    "length": 25
  },
  {
    "id": 348,
    "uuid": "f8149463-bb65-47bd-ae69-32fe32c1b907",
    "hitokoto": "宅，是一种生活状态；死宅，是一种人生境界……",
    "type": "e",
    "from": "朝颜留空",
    "from_who": null,
    "creator": "朝颜留空",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949352",
    "length": 22
  },
  {
    "id": 349,
    "uuid": "cd11e7e1-45cd-4852-9064-1da5b67aad79",
    "hitokoto": "自己永远是孤单的，但你可以让其他人变得不孤单。",
    "type": "e",
    "from": "Rokileng",
    "from_who": null,
    "creator": "Rokileng",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949353",
    "length": 23
  },
  {
    "id": 350,
    "uuid": "e45f1367-30de-47b4-bd9f-b92318c43ecf",
    "hitokoto": "繁花落尽，明月映着谁老去……",
    "type": "e",
    "from": "滿城煙花落",
    "from_who": null,
    "creator": "滿城煙花落",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949353",
    "length": 14
  },
  {
    "id": 351,
    "uuid": "875ba7b3-7469-4c4d-ba69-0668a20cd88a",
    "hitokoto": "你是我的，那是曾经。我是你的，直到现在。",
    "type": "e",
    "from": "时静",
    "from_who": null,
    "creator": "时静",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949353",
    "length": 20
  },
  {
    "id": 352,
    "uuid": "d5a24e2f-4961-42fd-9d9b-d0edcd08e970",
    "hitokoto": "也许我们都没有长大，只是世界变小了。",
    "type": "e",
    "from": "cukecora",
    "from_who": null,
    "creator": "cukecora",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949354",
    "length": 18
  },
  {
    "id": 353,
    "uuid": "ddeb0f15-0c16-433b-bbc1-29277cf5973c",
    "hitokoto": "苦到头未必是甜的，而甜到头一定是苦的 。",
    "type": "e",
    "from": "LastFairy",
    "from_who": null,
    "creator": "LastFairy",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949354",
    "length": 20
  },
  {
    "id": 354,
    "uuid": "1540b41e-44c3-47c0-94af-233b744e3193",
    "hitokoto": "请不要忘记，那给你带来感动的，名为二次元的理想乡。",
    "type": "e",
    "from": "hsk",
    "from_who": null,
    "creator": "hsk",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949355",
    "length": 25
  },
  {
    "id": 355,
    "uuid": "b09f553e-9178-43ef-8db5-4f95a825883f",
    "hitokoto": "此时此刻一切都是静寂的，只剩下我与你的世界，这就是爱？",
    "type": "e",
    "from": "DgBoo",
    "from_who": null,
    "creator": "DgBoo",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949355",
    "length": 27
  },
  {
    "id": 356,
    "uuid": "06f8eaf8-bbc8-44f2-bdff-e8666120d088",
    "hitokoto": "我愿意给你自己所有的快乐，你愿意分担我一半的难过吗？",
    "type": "e",
    "from": "getweb",
    "from_who": null,
    "creator": "getweb",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949355",
    "length": 26
  },
  {
    "id": 357,
    "uuid": "c30a331a-6997-4da9-a0d4-bf70cf1c9b0a",
    "hitokoto": "再强的敌人在最后一集的主角面前也是渣渣。",
    "type": "e",
    "from": "無い",
    "from_who": null,
    "creator": "無い",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949355",
    "length": 20
  },
  {
    "id": 358,
    "uuid": "17eb22be-0151-4141-8772-26c25e9a9c80",
    "hitokoto": "神曲的存在并不是为了享受音乐，而是品味那段最珍贵的回忆。",
    "type": "e",
    "from": "D君",
    "from_who": null,
    "creator": "D君",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949356",
    "length": 28
  },
  {
    "id": 359,
    "uuid": "a713047d-ee9c-4313-8379-2169341eaaad",
    "hitokoto": "小孩子看了根本把持不住！",
    "type": "e",
    "from": "李狗蛋儿",
    "from_who": null,
    "creator": "李狗蛋儿",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949357",
    "length": 12
  },
  {
    "id": 360,
    "uuid": "700c7081-aa9c-43af-8708-c4f7440077f0",
    "hitokoto": "一句话，不足以讲述一个故事，却可以让我们回味那些个动人的瞬间。",
    "type": "e",
    "from": "Sai",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949360",
    "length": 31
  },
  {
    "id": 361,
    "uuid": "e5f59f93-80be-4bec-9a03-964d7bd426fa",
    "hitokoto": "那双紧握不放的手……抓住的是希望……亦或是绝望……",
    "type": "e",
    "from": "sseeyyou",
    "from_who": null,
    "creator": "sseeyyou",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949361",
    "length": 25
  },
  {
    "id": 362,
    "uuid": "2098be08-b271-4fdd-aa19-c5fce0d77b75",
    "hitokoto": "我不会接受我不要的未来，哪怕是命中注定。",
    "type": "e",
    "from": "lzgsimerly",
    "from_who": null,
    "creator": "lzgsimerly",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949361",
    "length": 20
  },
  {
    "id": 363,
    "uuid": "0466f217-54b7-467f-b34c-7ef4bbd72265",
    "hitokoto": "每个凉宫都会遇到属于她的John Smith。",
    "type": "e",
    "from": "gmouse",
    "from_who": null,
    "creator": "gmouse",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949361",
    "length": 23
  },
  {
    "id": 364,
    "uuid": "fc5e60d6-bc17-4dab-9713-07adcce00eed",
    "hitokoto": "不要把你所遭遇的苦难看得太大，更不要把你所拥有的幸福看得太少。",
    "type": "e",
    "from": "月咏亚斗",
    "from_who": null,
    "creator": "月咏亚斗",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949362",
    "length": 31
  },
  {
    "id": 365,
    "uuid": "71439f99-f8aa-4477-b695-4a9449813f5e",
    "hitokoto": "姑娘们啊，要在该认真的地方全力认真，当你不想认真的时候不妨笑笑。",
    "type": "e",
    "from": "凌诺影",
    "from_who": null,
    "creator": "凌诺影",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949362",
    "length": 32
  },
  {
    "id": 366,
    "uuid": "57f7a4f2-24d7-4374-8a80-8a960a62e79f",
    "hitokoto": "你会梦游，我会磨牙，我们晚上一起去吓人吧！",
    "type": "e",
    "from": "一萍敌敌畏",
    "from_who": null,
    "creator": "一萍敌敌畏",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949363",
    "length": 21
  },
  {
    "id": 367,
    "uuid": "7694adf2-a5b0-4003-809d-e55329713ba9",
    "hitokoto": "梦+想=梦想，这个等式是不成立的。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "明九",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949363",
    "length": 17
  },
  {
    "id": 368,
    "uuid": "1bec05d6-1bc5-40ab-bc32-758d7c82b9e4",
    "hitokoto": "万书皆下品，唯有萌最高！",
    "type": "e",
    "from": "wy6510166",
    "from_who": null,
    "creator": "wy6510166",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949367",
    "length": 12
  },
  {
    "id": 370,
    "uuid": "a2f2a423-4d2e-4f44-878e-0a3c6fb79181",
    "hitokoto": "为错误停驻是件可悲的事。",
    "type": "e",
    "from": "LastFairy",
    "from_who": null,
    "creator": "LastFairy",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949369",
    "length": 12
  },
  {
    "id": 371,
    "uuid": "5ecb7c7a-d999-45d5-8998-b6815569b9af",
    "hitokoto": "为毛我的眼里常含泪水，因为我老是中枪。",
    "type": "e",
    "from": "不管外表怎样强悍我都是受",
    "from_who": null,
    "creator": "不管外表怎样强悍我都是受",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949371",
    "length": 19
  },
  {
    "id": 372,
    "uuid": "c88bcf5d-5e74-42d5-89e8-e37152ddc51f",
    "hitokoto": "在回忆里留下微笑是为了不让你哭泣...",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "萌萌“萌乃兮",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949373",
    "length": 19
  },
  {
    "id": 373,
    "uuid": "708e593b-806e-4e6e-b3f7-64780822e79f",
    "hitokoto": "你在颓废的时候别人都在努力哦~♪",
    "type": "e",
    "from": "椎名奈緒",
    "from_who": null,
    "creator": "椎名奈緒",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949380",
    "length": 16
  },
  {
    "id": 374,
    "uuid": "0337f7d0-7ab0-459f-af05-14dc41b8a9ad",
    "hitokoto": "每当对这个世界感到绝望的时候，买一包泡面，然后告诉自己：我们的泡面是有酱包的。",
    "type": "e",
    "from": "以风之名",
    "from_who": null,
    "creator": "以风之名",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949381",
    "length": 39
  },
  {
    "id": 375,
    "uuid": "2da10ca0-ba36-428e-8cdb-0b1fecbefd36",
    "hitokoto": "彼此相互推卸不幸是没有结果的。",
    "type": "e",
    "from": "凋零",
    "from_who": null,
    "creator": "凋零",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949386",
    "length": 15
  },
  {
    "id": 376,
    "uuid": "c7a9597a-c681-4179-8c63-a8a2af1810fa",
    "hitokoto": "没有动漫的世界，就是没有的光明的大地！",
    "type": "e",
    "from": "617969448",
    "from_who": null,
    "creator": "617969448",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949398",
    "length": 19
  },
  {
    "id": 377,
    "uuid": "e04fd009-68b5-421d-bb6c-3758a4d065fd",
    "hitokoto": "问君能有几多愁？恰似一部新番没看头。",
    "type": "e",
    "from": "竹田花落",
    "from_who": null,
    "creator": "yudezhuixun",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949411",
    "length": 18
  },
  {
    "id": 378,
    "uuid": "936b6691-874d-4b26-835e-3f4e10b5da2f",
    "hitokoto": "哼！悔改吧，你们这群死宅，人家可是身价四千万的大小姐。",
    "type": "e",
    "from": "Sai",
    "from_who": null,
    "creator": "Sai",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949420",
    "length": 27
  },
  {
    "id": 379,
    "uuid": "ec142817-3442-40c5-8779-9eccc2d5555d",
    "hitokoto": "天下哪有真情在？只要够萌咱都爱！",
    "type": "e",
    "from": "魔王丨丶Sama灬",
    "from_who": null,
    "creator": "魔王丨丶Sama灬",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1468949442",
    "length": 16
  },
  {
    "id": 648,
    "uuid": "90a1ba14-70d1-4c39-a6f0-3a6f11addf21",
    "hitokoto": "世界上没有鸟黑，只有鸟厨和丧心病狂的鸟厨！",
    "type": "e",
    "from": "树形图设计者",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475072749",
    "length": 21
  },
  {
    "id": 649,
    "uuid": "73d9e152-8062-4ba8-9c20-988979bb5214",
    "hitokoto": "中国教育的优秀在于，小时候要求老实听话，抄袭模仿；而长大后要求独立自主，开拓创新",
    "type": "e",
    "from": "树形图设计者",
    "from_who": null,
    "creator": "树形图设计者",
    "creator_uid": 55,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1475072327",
    "length": 40
  },
  {
    "id": 715,
    "uuid": "bd5de4e7-3b10-4411-b13e-ce449c12d557",
    "hitokoto": "枯燥的太阳因你而变的温暖，脆弱的心灵因你而变的坚强。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 26
  },
  {
    "id": 725,
    "uuid": "2cf2d7b2-9587-402e-943a-17f22b3e7846",
    "hitokoto": "谢谢你喜欢我，对不起爱，我伤不起了",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 738,
    "uuid": "49c1bed7-20de-4905-b63d-e3aace63b175",
    "hitokoto": "我们都很擅长口是心非，但又希望对方能有所察觉。",
    "type": "e",
    "from": "九ちのセカィ",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 23
  },
  {
    "id": 745,
    "uuid": "07b83c20-0e4f-4d4f-bd95-02630124f594",
    "hitokoto": "你在颓废的时候别人都在努力哦~?",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 759,
    "uuid": "15fdecee-d0f5-4128-bf7e-55b07add4155",
    "hitokoto": "那双紧握不放的手…抓住的是希望…亦或是绝望…",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 22
  },
  {
    "id": 766,
    "uuid": "4c59ecca-3a72-43af-8bb2-9e9aed73e311",
    "hitokoto": "加油！和你们在一起！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 10
  },
  {
    "id": 770,
    "uuid": "d92c36eb-9532-4813-9b78-090aeb2001c9",
    "hitokoto": "你说过等我的······",
    "type": "e",
    "from": "Seek/追寻城堡色",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 12
  },
  {
    "id": 781,
    "uuid": "93587aca-1f85-4e37-8aaf-2505af82f221",
    "hitokoto": "时间就是一个饥饿的怪物，稍有不慎便会被它吃掉。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 23
  },
  {
    "id": 785,
    "uuid": "0a1f08ab-faae-4e52-ad9d-bc07db02395c",
    "hitokoto": "相互间的抚慰根本没必要只要你还存在着就足够",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 21
  },
  {
    "id": 786,
    "uuid": "7cd41827-6a2d-476e-ac37-da894c71d513",
    "hitokoto": "十年过去了，时间没长大，我却变了。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 17
  },
  {
    "id": 809,
    "uuid": "a451a25b-2baa-488b-b4e0-81ccc6b41023",
    "hitokoto": "大力出奇迹，穹妹即正义。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 12
  },
  {
    "id": 823,
    "uuid": "0ab62300-e324-467c-bef0-ca80f49f249f",
    "hitokoto": "走路太骚必摔跤，得瑟过劲会闪腰。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 16
  },
  {
    "id": 830,
    "uuid": "687adf63-2c1c-4bd9-a301-d15362de2083",
    "hitokoto": "每一个人都应该明确自己的方向和位置。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 18
  },
  {
    "id": 837,
    "uuid": "2016ac6e-246c-4bb1-9087-81e2659ec0be",
    "hitokoto": "不相信命运却屈服于现实，拒绝眼泪却抑制不住悲伤......",
    "type": "e",
    "from": "Cacti",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 29
  },
  {
    "id": 849,
    "uuid": "cb8ed03a-fbe3-4eec-b675-71949fca87c1",
    "hitokoto": "眼泪能够诠释最开心，却无法尽展最悲伤。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 19
  },
  {
    "id": 860,
    "uuid": "fcdf1ecf-9a08-428c-9bfd-773ae95312c1",
    "hitokoto": "有一些情感，没办法辜负它。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 13
  },
  {
    "id": 876,
    "uuid": "10288b4d-02de-4393-9421-5f6274d56aad",
    "hitokoto": "就要死皮赖脸的喜欢你",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 10
  },
  {
    "id": 910,
    "uuid": "dcc031ca-e7bc-481b-a9b9-5f9660df246f",
    "hitokoto": "The world is so immense that there must be a you. The world is so immense that I might never run into you.",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 106
  },
  {
    "id": 914,
    "uuid": "b96dd23a-59fc-400e-b48e-bab554f7f43f",
    "hitokoto": "若挥袖作别，流云万千，可有人千万流连。 若今昔一别，一别永年，苍山负雪，浮生尽歇。",
    "type": "e",
    "from": "浮生未歇",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 41
  },
  {
    "id": 919,
    "uuid": "eb925174-928a-4ba0-9de5-36856447e04e",
    "hitokoto": "即使认真做 有些事还是做不到啊",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 15
  },
  {
    "id": 922,
    "uuid": "ac04af69-8dc9-419a-9c75-ddbfa3171b77",
    "hitokoto": "我们无法回到过去，前进的方向，只有未来。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 20
  },
  {
    "id": 929,
    "uuid": "1ca6adfe-deec-4203-873d-949a7738378c",
    "hitokoto": "愿：汝之烦恼痛苦心不在焉，汝之快乐幸福全神贯注。",
    "type": "e",
    "from": "CANICRY",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 24
  },
  {
    "id": 936,
    "uuid": "93464c63-5f17-4d7e-88be-de2e42859a33",
    "hitokoto": "你的电脑，我的权限；你的命运，由我做主。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 20
  },
  {
    "id": 944,
    "uuid": "e571c630-93fb-4d06-a991-6ae61e6838eb",
    "hitokoto": "炎炎夏季，暴雨连连，心如荒漠，人如飘絮，形如枯槁，骨如细柴。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "hitokoto",
    "creator_uid": 1775,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1478787580",
    "length": 30
  },
  {
    "id": 986,
    "uuid": "78430997-5ba7-4121-abc0-d0fa58dca494",
    "hitokoto": "人心是件奇妙的东西，大部分的时候，总是愉快而又平静的生活着。",
    "type": "e",
    "from": "网络",
    "from_who": null,
    "creator": "1310517752",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 30
  },
  {
    "id": 1009,
    "uuid": "7dd49e69-9a04-4ad4-b5b0-411d55c740ef",
    "hitokoto": "人们要是没有回忆就活不下去，但是只有回忆的话也活不下去。梦总是有会醒来的时候，不会醒的梦总有一天会变成悲伤。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "942903628",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 54
  },
  {
    "id": 1078,
    "uuid": "a603b66b-baca-49d9-a956-7356efe2c88f",
    "hitokoto": "把自己当傻瓜，不懂就问，你会学的更多",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "2021823134",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 18
  },
  {
    "id": 1079,
    "uuid": "73619006-c9fe-4e8e-9fcb-b9b460ea49cb",
    "hitokoto": "自由的目的是为了为他人创造自由",
    "type": "e",
    "from": "马拉默德",
    "from_who": "马拉默德",
    "creator": "1102058350",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1481086547",
    "length": 15
  },
  {
    "id": 1094,
    "uuid": "8971a54e-7ed5-428f-9aed-d7af05a8036d",
    "hitokoto": "那些青春期的脆弱自尊，轻易不得触碰，那极有有可能成为对他或她一生的打扰。我们都曾经历那样纯粹、易碎的青春，只是时光的磨砺已让我们懂得逃避与忍气吞声然后慢慢遗忘自己曾经的青春。",
    "type": "e",
    "from": "原创",
    "from_who": "东野圭吾",
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 87
  },
  {
    "id": 1102,
    "uuid": "2bf4e4d8-c2a4-4e23-a6db-9d6fbac7af73",
    "hitokoto": "为什么我明明什么坏事都没有做，却要被那样看待？",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "1015964489",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 23
  },
  {
    "id": 1117,
    "uuid": "c1cd299e-02bc-4a7b-be44-e81b50de29d3",
    "hitokoto": "天予不取，必遭天谴。",
    "type": "e",
    "from": "易经",
    "from_who": null,
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 10
  },
  {
    "id": 1119,
    "uuid": "e3fb6114-c3a9-4206-9e56-3e3e6cc34c6f",
    "hitokoto": "我讨厌一会充满希望一会变成绝望，我们已经受够了期待落空了。",
    "type": "e",
    "from": "流星之绊",
    "from_who": "东野圭吾",
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 29
  },
  {
    "id": 1121,
    "uuid": "ffbf8cf7-bbd0-4496-9fff-1974cb22c73f",
    "hitokoto": "夫君子之行，静以修身，俭以养德，非淡泊无以明志，非宁静无以致远",
    "type": "e",
    "from": "诫子书",
    "from_who": "诸葛亮",
    "creator": "505622287",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "",
    "length": 31
  },
  {
    "id": 1125,
    "uuid": "e748e31c-45e8-4802-8adf-333d4cd903fe",
    "hitokoto": "没有什么是一个滑稽解决不了的，如果有，那就两个！",
    "type": "e",
    "from": "Alxtit",
    "from_who": null,
    "creator": "Alxtit",
    "creator_uid": 195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1483816898",
    "length": 24
  },
  {
    "id": 1132,
    "uuid": "cb322d58-b148-4e1b-92e6-e7ab65a666cb",
    "hitokoto": "何其有幸，我们相遇。",
    "type": "e",
    "from": "朽猫",
    "from_who": null,
    "creator": "朽猫",
    "creator_uid": 214,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1485289916",
    "length": 10
  },
  {
    "id": 1136,
    "uuid": "445c8c4b-535e-46a4-a6b3-d0677edef9f4",
    "hitokoto": "我的梦想就是站在万人仰慕的高度，俯视曾经看低我的人。",
    "type": "e",
    "from": "流年博客",
    "from_who": null,
    "creator": "流年博客",
    "creator_uid": 203,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1484055401",
    "length": 26
  },
  {
    "id": 1139,
    "uuid": "b53d3b94-2080-4ecf-a165-4d81b67ec05a",
    "hitokoto": "父母是你的一把粗糙的伞，可是它为你遮风挡雨——而我们应该做的，是感激他们，并不是舍弃他们、捅破他们。",
    "type": "e",
    "from": "龙猫 沧笙踏歌",
    "from_who": null,
    "creator": "龙猫〆沧笙踏歌",
    "creator_uid": 224,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1486213620",
    "length": 50
  },
  {
    "id": 1144,
    "uuid": "2b9d83c4-b123-4e30-9938-2b24cf79fe31",
    "hitokoto": "聆听雨落的声音，俯看凋零的落叶。伫细雨之中，感雨落之殇。",
    "type": "e",
    "from": "雨落凋殇",
    "from_who": null,
    "creator": "雨伤",
    "creator_uid": 171,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1487255804",
    "length": 28
  },
  {
    "id": 1148,
    "uuid": "17b87b73-9a6e-4526-b436-8573ac6a4fc6",
    "hitokoto": "你说最开心的是你，我说最难过的是你……",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Mystery0",
    "creator_uid": 261,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1489643352",
    "length": 19
  },
  {
    "id": 1155,
    "uuid": "1eef659b-3a69-454b-930f-6823d1b290ef",
    "hitokoto": "我们，在路上，勿忘初心。找寻最初的梦想和微弱的希望。",
    "type": "e",
    "from": "根号菌SAMA",
    "from_who": null,
    "creator": "根号菌のSAMA",
    "creator_uid": 283,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491210065",
    "length": 26
  },
  {
    "id": 1156,
    "uuid": "09d95092-c25d-4170-9627-c636f05f6c19",
    "hitokoto": "不管明天会发生什么，请牢记住今天。",
    "type": "e",
    "from": "根号菌SAMA",
    "from_who": null,
    "creator": "根号菌のSAMA",
    "creator_uid": 283,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491210031",
    "length": 17
  },
  {
    "id": 1157,
    "uuid": "4fbdb917-160f-4c6f-aea7-219d5c7522c8",
    "hitokoto": "孤独不是病，习惯了自然会好。",
    "type": "e",
    "from": "根号菌SAMA",
    "from_who": null,
    "creator": "根号菌のSAMA",
    "creator_uid": 283,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491209984",
    "length": 14
  },
  {
    "id": 1158,
    "uuid": "0517343a-62b2-4c9f-b168-6513d9a94ab7",
    "hitokoto": "忘却并不是可怕的，而是你不肯。",
    "type": "e",
    "from": "根号菌SAMA",
    "from_who": null,
    "creator": "根号菌のSAMA",
    "creator_uid": 283,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1491209890",
    "length": 15
  },
  {
    "id": 1170,
    "uuid": "fee0e9ef-4c7f-4a3f-b107-6d830c3383a0",
    "hitokoto": "我笑了，开怀的笑了，真的",
    "type": "e",
    "from": "小C",
    "from_who": null,
    "creator": "KKMC",
    "creator_uid": 312,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1492774071",
    "length": 12
  },
  {
    "id": 1171,
    "uuid": "4cc8ec9d-0e2f-4596-adc0-a633ba2d363d",
    "hitokoto": "风牛流马·我带你回家",
    "type": "e",
    "from": "ccdalao",
    "from_who": null,
    "creator": "KKMC",
    "creator_uid": 312,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1492774038",
    "length": 10
  },
  {
    "id": 1172,
    "uuid": "1b963d37-4e1f-46ec-abb2-41f3b8cb627c",
    "hitokoto": "我只是一个小后端",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Ghost_chu",
    "creator_uid": 311,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1492613621",
    "length": 8
  },
  {
    "id": 1179,
    "uuid": "f6abe7a2-503a-4838-9f6d-f5b10c51aff6",
    "hitokoto": "我特别讨厌悲观的人，做任何事情只要出了点挫折就放弃。那是你，别自以为是把我搞得和你一样！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Lonely",
    "creator_uid": 359,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1494950103",
    "length": 44
  },
  {
    "id": 1180,
    "uuid": "4bc2b2f1-b480-44ba-80f0-9171d71ca9b9",
    "hitokoto": "如果真的失败了，请总结自己\"为什么会失败？\"",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Lonely",
    "creator_uid": 359,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1495264809",
    "length": 22
  },
  {
    "id": 1183,
    "uuid": "eaeb085b-115c-4760-847d-debf6d3dde13",
    "hitokoto": "如果你的眉眼，肯为我停留半分，又怎会不知我情比海深。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "yc",
    "creator_uid": 162,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1496649114",
    "length": 26
  },
  {
    "id": 1185,
    "uuid": "42276164-e2e4-4351-9bd8-31285111c16d",
    "hitokoto": "不是他，变成他。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "公子司煊。",
    "creator_uid": 428,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1497173785",
    "length": 8
  },
  {
    "id": 1186,
    "uuid": "a0cf5e67-ffd9-4b32-befd-8077b6eff198",
    "hitokoto": "我不分白天或黑夜，因为我觉得我的人生就像在白夜中行走。",
    "type": "e",
    "from": "不善",
    "from_who": null,
    "creator": "不善",
    "creator_uid": 433,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1498005680",
    "length": 27
  },
  {
    "id": 1187,
    "uuid": "a3455375-329e-4bab-ba96-533a3a8dec08",
    "hitokoto": "人总是害怕死亡，却殊不知有出生之时必有死亡之日。",
    "type": "e",
    "from": "不善",
    "from_who": null,
    "creator": "不善",
    "creator_uid": 433,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1498005544",
    "length": 24
  },
  {
    "id": 1188,
    "uuid": "8d117aee-15d8-4d52-99f5-4107fd3c24e3",
    "hitokoto": "宣纸泛黄，时间流逝，即使眨眼即过，也要抓住那瞬间的辉煌。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "凌夏",
    "creator_uid": 434,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1497777222",
    "length": 28
  },
  {
    "id": 1190,
    "uuid": "33a50389-e7ec-4c45-9c19-8c9267493294",
    "hitokoto": "你要乖，要长大，要不负众望。",
    "type": "e",
    "from": "耽萌",
    "from_who": null,
    "creator": "yc",
    "creator_uid": 162,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1497699862",
    "length": 14
  },
  {
    "id": 1192,
    "uuid": "2d182b39-6739-4ed1-a334-9a59ed52d149",
    "hitokoto": "机会永远都有 就看你能不能抓得住",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Ghost_chu",
    "creator_uid": 311,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1497520731",
    "length": 16
  },
  {
    "id": 1193,
    "uuid": "b9fe6313-029f-43da-b125-0eb7e7213c4a",
    "hitokoto": "本是无所谓输赢的，却在一时激发起了斗志。",
    "type": "e",
    "from": "不善",
    "from_who": null,
    "creator": "不善",
    "creator_uid": 433,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1498005929",
    "length": 20
  },
  {
    "id": 1203,
    "uuid": "16454be6-1066-454d-a376-286229e55132",
    "hitokoto": "贫积德，富积善。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "梦语",
    "creator_uid": 438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1499820141",
    "length": 8
  },
  {
    "id": 1212,
    "uuid": "420d3df2-f5d6-41ea-ac91-2512c20073c7",
    "hitokoto": "即便是一个毫无存在感的影子，也应当寸步不离自己的目标步步前进。",
    "type": "e",
    "from": "西风",
    "from_who": null,
    "creator": "this4th",
    "creator_uid": 467,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501209459",
    "length": 31
  },
  {
    "id": 1213,
    "uuid": "9591a902-5024-4873-9e6c-3cb4972736f6",
    "hitokoto": "每个人都衣冠楚楚，从来没有人会关心光芒万丈的外表下那藏在角落的，发了霉的落寞。",
    "type": "e",
    "from": "西风",
    "from_who": null,
    "creator": "this4th",
    "creator_uid": 467,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501209135",
    "length": 39
  },
  {
    "id": 1214,
    "uuid": "ecaedf87-e554-4fd4-a74b-24580bdac15d",
    "hitokoto": "每个人都有着不为人知的肮脏。这、就是灵魂。",
    "type": "e",
    "from": "西风",
    "from_who": null,
    "creator": "this4th",
    "creator_uid": 467,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501208174",
    "length": 21
  },
  {
    "id": 1215,
    "uuid": "d5520221-928c-4a6d-8141-e82d31d31c2d",
    "hitokoto": "错过了就错过了,再追回来天色也不对。",
    "type": "e",
    "from": "西风",
    "from_who": null,
    "creator": "this4th",
    "creator_uid": 467,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501080916",
    "length": 18
  },
  {
    "id": 1216,
    "uuid": "0e14ce82-ee3e-4d02-98ab-08d2a026cec7",
    "hitokoto": "孤独的人不过都是一厢情愿的伤害自己，然后再感动自己罢了。",
    "type": "e",
    "from": "西风",
    "from_who": null,
    "creator": "this4th",
    "creator_uid": 467,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501080877",
    "length": 28
  },
  {
    "id": 1217,
    "uuid": "c0bf6ba3-840a-4bec-af8e-985fb41d341a",
    "hitokoto": "每个人都曾有一个梦。但最后我们都把它弄丢了，在追逐幻影的路上。",
    "type": "e",
    "from": "西风",
    "from_who": null,
    "creator": "this4th",
    "creator_uid": 467,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1501080854",
    "length": 31
  },
  {
    "id": 1239,
    "uuid": "a24215e4-7861-4a46-86c6-ebe8b6aece62",
    "hitokoto": "愿留在Minecraft，也不愿回到现实。",
    "type": "e",
    "from": "Lipww1234",
    "from_who": null,
    "creator": "Lipww1234",
    "creator_uid": 514,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1503820685",
    "length": 21
  },
  {
    "id": 1283,
    "uuid": "3d897d00-bf9e-427a-8ea1-af8ed426e48a",
    "hitokoto": "不当回忆起,已不知落下多少份曾经以为坚定不移都丢不下的纯真,现虽能捡起,但却已失去了当初的味道。",
    "type": "e",
    "from": "生活",
    "from_who": null,
    "creator": "牧云溪",
    "creator_uid": 677,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509690149",
    "length": 48
  },
  {
    "id": 1287,
    "uuid": "115b8ef2-b2ae-4972-8803-bc788fc2eb1c",
    "hitokoto": "你是清风上的明月，枫林间的鸟雀。",
    "type": "e",
    "from": "白开",
    "from_who": null,
    "creator": "肖白开",
    "creator_uid": 673,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509628541",
    "length": 16
  },
  {
    "id": 1288,
    "uuid": "1107c654-1834-46ec-b002-7f1ea64b75c6",
    "hitokoto": "梦里与现实的距离，仅仅是双眸的一合一闭。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Brandon",
    "creator_uid": 629,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509457750",
    "length": 20
  },
  {
    "id": 1295,
    "uuid": "0a2e5306-5283-4d80-b4da-17646d4ad572",
    "hitokoto": "暴力出奇迹，骗分过样例。",
    "type": "e",
    "from": "OIer",
    "from_who": null,
    "creator": "Mockaven",
    "creator_uid": 701,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1509797219",
    "length": 12
  },
  {
    "id": 1298,
    "uuid": "53377e0f-5357-4dd2-815f-e4b98d0fdf5b",
    "hitokoto": "If you can't win the game, change the rules.",
    "type": "e",
    "from": "Leann",
    "from_who": null,
    "creator": "Simon Ma",
    "creator_uid": 623,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1510412165",
    "length": 44
  },
  {
    "id": 1306,
    "uuid": "e868e9cd-0b91-4df9-9179-7ce6312d25da",
    "hitokoto": "永远别放弃一个你每天都在想念的人",
    "type": "e",
    "from": "jcworm",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512524847",
    "length": 16
  },
  {
    "id": 1316,
    "uuid": "f41e8048-50d2-45ce-b07c-5a5aabaf3fc4",
    "hitokoto": "力所能及的帮助他人是我们做人的本分，刻意的那么做就超出了我们的能力范畴，说不定还会引来恶意的猜想。",
    "type": "e",
    "from": "胡说八道",
    "from_who": null,
    "creator": "宝宝洗头爱飘柔",
    "creator_uid": 898,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1512718665",
    "length": 49
  },
  {
    "id": 1317,
    "uuid": "ec8eee25-c48c-4cc5-bc7a-383d6f6a968e",
    "hitokoto": "异地恋是，尝过欣喜若狂，也知道失魂落魄。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "彩虹糖不甜",
    "creator_uid": 936,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513221347",
    "length": 20
  },
  {
    "id": 1321,
    "uuid": "490212b9-79d4-4721-a745-68f0857021f1",
    "hitokoto": "人生的意义都不同，你需要的是发现属于自己的人生观、价值观。",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513131674",
    "length": 29
  },
  {
    "id": 1323,
    "uuid": "cc5b062e-6610-44cf-8b14-40f3bd48b7e0",
    "hitokoto": "最简单的，有的人认为人活着就是为了吃饭，有的人是为了吃饭而活着。",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513131698",
    "length": 32
  },
  {
    "id": 1329,
    "uuid": "b1a3cf36-513a-4fdd-afaa-52df5f3b2069",
    "hitokoto": "清晨、黄昏、天空 和飞鸟，代码、诗歌、活着 和爱你。",
    "type": "e",
    "from": "一个程序员",
    "from_who": null,
    "creator": "飞鸟",
    "creator_uid": 159,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1513052859",
    "length": 26
  },
  {
    "id": 1336,
    "uuid": "e11b5e0f-02ba-4396-b6ef-5b68d38029a9",
    "hitokoto": "世界上最令人激动的一件事就是：你原本以为没有机会靠近的人，竟然爱上了你...",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514339462",
    "length": 38
  },
  {
    "id": 1338,
    "uuid": "46485132-0305-4fae-bf1a-57ca780ab275",
    "hitokoto": "不必刻意的陪伴，只需偶尔的相视一笑，如此自然，却又仿佛胜过千言万语。",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514338975",
    "length": 34
  },
  {
    "id": 1345,
    "uuid": "2d3adb5f-98d2-4f89-86c1-e5000e554adf",
    "hitokoto": "别总因为迁就别人,委屈了自己,这个世界上,没几个人值得你总弯腰",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514339059",
    "length": 31
  },
  {
    "id": 1352,
    "uuid": "04ba0062-0127-49a9-bedd-d7c6d56f3df5",
    "hitokoto": "充满着无尽的能量与自信，向着未来出发",
    "type": "e",
    "from": "涓尘",
    "from_who": null,
    "creator": "涓尘",
    "creator_uid": 895,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1514968455",
    "length": 18
  },
  {
    "id": 1360,
    "uuid": "ab33d2a2-b9c2-42b7-ac78-ac938de4bc50",
    "hitokoto": "我纯净的笑容，我想一生珍藏",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516586265",
    "length": 13
  },
  {
    "id": 1361,
    "uuid": "3cd14428-9f28-4109-993e-4e6e12b5cadc",
    "hitokoto": "虽然你很普通，但你是世上独一无二的唯一",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516586466",
    "length": 19
  },
  {
    "id": 1363,
    "uuid": "0a0f0381-f45f-40ae-9eee-502cf6abc3e4",
    "hitokoto": "不需要逃避，也不必看轻自己，接受自己的不完美，更加努力，凡是打不倒你的都会让你变得更加坚强。",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1517367761",
    "length": 46
  },
  {
    "id": 1370,
    "uuid": "31a34841-74af-476b-91ed-25b811df1669",
    "hitokoto": "为自己当初的誓言而努力！",
    "type": "e",
    "from": "疯人",
    "from_who": null,
    "creator": "一人",
    "creator_uid": 1063,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516332970",
    "length": 12
  },
  {
    "id": 1371,
    "uuid": "e5ccf6ac-c023-4a62-b253-6e0126b42ea7",
    "hitokoto": "我要名正言顺闯进你生活，干预你原本的生活，吃我不曾敢食的醋，做我这身份该做的事情--拥抱你。",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516269202",
    "length": 46
  },
  {
    "id": 1373,
    "uuid": "d72036d0-c331-41ac-9853-6f490c7c7cf3",
    "hitokoto": "不怕万人阻挡，就怕自己投降，将来的你一定会感激现在拼命的自己，自己选择的路，再艰难，跪着也要走完。",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1515988764",
    "length": 49
  },
  {
    "id": 1375,
    "uuid": "7abc96e3-ea38-4123-9692-2ccbfc4745d9",
    "hitokoto": "人终其一生都是自我改善的过程。",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1518597519",
    "length": 15
  },
  {
    "id": 1377,
    "uuid": "089d5969-4326-468f-87c0-8f350fe6ce0f",
    "hitokoto": "回避现实的人，未来将更不理想",
    "type": "e",
    "from": "温白",
    "from_who": null,
    "creator": "温白",
    "creator_uid": 1150,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1518335687",
    "length": 14
  },
  {
    "id": 1378,
    "uuid": "bd63bb2a-5872-4276-9d2c-95d5d0c4b681",
    "hitokoto": "其实本来就没有什么大彻大悟，不过是找到一个够麻痹自己一生的理由。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "ChewBen",
    "creator_uid": 1177,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1519146511",
    "length": 32
  },
  {
    "id": 1384,
    "uuid": "a7be9e89-5869-4db0-a6ff-f67af25aee2c",
    "hitokoto": "美食之于他们是爱、是救赎、是一切美好及温暖的集合",
    "type": "e",
    "from": "Bruce Jc",
    "from_who": null,
    "creator": "Bruce jcworm",
    "creator_uid": 884,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1516593534",
    "length": 24
  },
  {
    "id": 3582,
    "uuid": "8d48c8bd-4996-49a2-9751-19f67ef5cef5",
    "hitokoto": "彼岸花花开彼岸，断肠草草断肝肠。",
    "type": "e",
    "from": "MXLBS",
    "from_who": null,
    "creator": "MXLBS",
    "creator_uid": 1288,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521289517",
    "length": 16
  },
  {
    "id": 3588,
    "uuid": "4c64b338-0853-4a28-8be0-61f18d0cfeea",
    "hitokoto": "我卸掉眼鏡，世界全是朦朧美！",
    "type": "e",
    "from": "cyalias",
    "from_who": null,
    "creator": "cyalias",
    "creator_uid": 647,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521679403",
    "length": 14
  },
  {
    "id": 3589,
    "uuid": "6650e42a-d4fe-4c38-bac6-c8f1bf41b520",
    "hitokoto": "一口饭掉一滴泪，一次咀嚼一个叹息",
    "type": "e",
    "from": "GGB",
    "from_who": null,
    "creator": "灰灰鸟",
    "creator_uid": 1308,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521866332",
    "length": 16
  },
  {
    "id": 3590,
    "uuid": "3da55b8c-f213-4954-b216-3670a2a16065",
    "hitokoto": "一个悲伤的故事，第二支冰激凌半价",
    "type": "e",
    "from": "GGB",
    "from_who": null,
    "creator": "灰灰鸟",
    "creator_uid": 1308,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521866000",
    "length": 16
  },
  {
    "id": 3592,
    "uuid": "1d6be254-8514-434e-a7a7-fb57f666c060",
    "hitokoto": "待至暮年归,挽手戏落日.",
    "type": "e",
    "from": "Nice · 南先生",
    "from_who": null,
    "creator": "Nice南先生",
    "creator_uid": 1305,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1521812123",
    "length": 12
  },
  {
    "id": 3594,
    "uuid": "d95517a0-1ab1-40e9-85e7-b47058934dd5",
    "hitokoto": "可以理解，无法原谅。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "逗逼领主",
    "creator_uid": 1292,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1522712397",
    "length": 10
  },
  {
    "id": 3596,
    "uuid": "83304462-2325-47cb-b36c-367bfefc7f08",
    "hitokoto": "每一天都可能会有刷新你世界观的事",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Lipww1234",
    "creator_uid": 514,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1523454861",
    "length": 16
  },
  {
    "id": 3622,
    "uuid": "5f0c3caa-24a2-415a-8c46-d7a7e7fddc04",
    "hitokoto": "学习和什么使我们快乐",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "lausanne",
    "creator_uid": 1398,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1524274567",
    "length": 10
  },
  {
    "id": 3633,
    "uuid": "c3a0632c-b5f3-4a10-9b5c-37e436297eb4",
    "hitokoto": "因为刚好遇见你，原来你也在这里……",
    "type": "e",
    "from": "Nice·南先生",
    "from_who": null,
    "creator": "Nice南先生",
    "creator_uid": 1305,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1526718390",
    "length": 17
  },
  {
    "id": 3635,
    "uuid": "7fdcaff8-3e12-46ae-a04d-51d015cfc9cd",
    "hitokoto": "我说：“ 我确信 你知道的，只有努力，才不会让自己轻易地被别人打倒或者看不起。”你说：“ 我知道，我知道，我一直都知道。”",
    "type": "e",
    "from": "Nice·南先生",
    "from_who": null,
    "creator": "Nice南先生",
    "creator_uid": 1305,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1526718612",
    "length": 61
  },
  {
    "id": 3667,
    "uuid": "907aab50-de45-4908-8dca-e353843546a5",
    "hitokoto": "固执守旧说的就是我了吧",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530013832",
    "length": 11
  },
  {
    "id": 3672,
    "uuid": "5bd4dadd-f4f3-4442-a51c-2cbc9a9fc81c",
    "hitokoto": "OIer和拉拉人都是应该相信奇迹的",
    "type": "e",
    "from": "SilverN",
    "from_who": null,
    "creator": "Labelray",
    "creator_uid": 1634,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1529076429",
    "length": 17
  },
  {
    "id": 3673,
    "uuid": "8e532150-5e7a-4d07-9b6b-7a4971dcc9d8",
    "hitokoto": "现在得到的将来定将十倍失去",
    "type": "e",
    "from": "言午",
    "from_who": null,
    "creator": "言午",
    "creator_uid": 1664,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1529405784",
    "length": 13
  },
  {
    "id": 3674,
    "uuid": "db0a7b02-51c3-4908-9b3d-1a2c218ede14",
    "hitokoto": "我打架很厉害的，身体疼没什么了不起，心里疼才会哭",
    "type": "e",
    "from": "答案",
    "from_who": null,
    "creator": "答案",
    "creator_uid": 1792,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1531847133",
    "length": 24
  },
  {
    "id": 3675,
    "uuid": "1402530b-a10c-48db-9b23-d2fe818039a4",
    "hitokoto": "加油，努力，当然，这只是对你而言，如果是我的话，还是算了吧。请别对我抱有任何期望，失望的感觉真的很难受呢",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530013870",
    "length": 52
  },
  {
    "id": 3678,
    "uuid": "a0230b1e-72fa-4852-8845-a814a0fc60bc",
    "hitokoto": "我有坚硬如钢铁的皮，骨缝中刀匕，肩头上荆棘，都不足以让我哭泣。",
    "type": "e",
    "from": "ccdalao",
    "from_who": null,
    "creator": "KKMC",
    "creator_uid": 312,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530410216",
    "length": 31
  },
  {
    "id": 3679,
    "uuid": "300919fe-4dfb-4f6c-b97a-a58ae9464f40",
    "hitokoto": "故事的结尾，我在那里藏了一个秘密，我依旧爱着这个世界，这件事，希望你们永远都不要提起。",
    "type": "e",
    "from": "ccdalao",
    "from_who": null,
    "creator": "KKMC",
    "creator_uid": 312,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530410282",
    "length": 43
  },
  {
    "id": 3680,
    "uuid": "4113af30-7377-438e-a3f5-3d159c43c82d",
    "hitokoto": "好想把网易云留给自己后代，因为我的的青春里有太多的歌曲，希望他们能记起。",
    "type": "e",
    "from": "ccdalao",
    "from_who": null,
    "creator": "KKMC",
    "creator_uid": 312,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530410300",
    "length": 36
  },
  {
    "id": 3683,
    "uuid": "a85c5f44-68a3-4f1b-9291-59db2add39d5",
    "hitokoto": "你要知道我所做出的决定都没改变过 无论如何也会达成",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014177",
    "length": 25
  },
  {
    "id": 3686,
    "uuid": "976e6276-4c66-43a3-ab46-1859cb2d6892",
    "hitokoto": "倘若是为了爱而放弃一切，最终连同这份爱意都会丧失掉。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014447",
    "length": 26
  },
  {
    "id": 3688,
    "uuid": "ab5d7cb1-05f9-4b53-9ac9-0c1146ece917",
    "hitokoto": "那不是温柔，那不过是软弱罢了",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014489",
    "length": 14
  },
  {
    "id": 3689,
    "uuid": "2134dbaf-85d7-4897-b34c-6ae68d771333",
    "hitokoto": "想变成你所了解的那个我，但是.......抱歉.....似乎......不太可能",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014550",
    "length": 40
  },
  {
    "id": 3690,
    "uuid": "beb9022b-d318-43b8-a538-86aa34908799",
    "hitokoto": "生命的长度我是拓展不了了，但是我可以试着把它拉宽一点，这样子就能印出彩虹了。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014606",
    "length": 38
  },
  {
    "id": 3691,
    "uuid": "0a02d54e-544c-4179-84f5-0f98868ba7e2",
    "hitokoto": "如果杞人看见过天塌下来，那么杞人忧天也就可以理解了吧。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014734",
    "length": 27
  },
  {
    "id": 3694,
    "uuid": "0cfb3aa9-6812-4788-9d08-ef4a16e5753a",
    "hitokoto": "生活就是和过去再见，和未来遇见！",
    "type": "e",
    "from": "柠檬茶",
    "from_who": null,
    "creator": "柠檬茶",
    "creator_uid": 1771,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1531465592",
    "length": 16
  },
  {
    "id": 3700,
    "uuid": "c9cefcc4-abf2-4378-8261-c631e64f5f4c",
    "hitokoto": "如果一个人连死都不怕的话,那么他害怕的事情就太多了",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014633",
    "length": 25
  },
  {
    "id": 3701,
    "uuid": "7c7ea4d6-34e8-42e5-83be-2124c112de6d",
    "hitokoto": "我想拥有温柔，不仅仅止于表面的伪装。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014799",
    "length": 18
  },
  {
    "id": 3706,
    "uuid": "c73ebf91-3757-4a5d-b9ed-bf70954bc97d",
    "hitokoto": "哪怕再苦再累我也情愿去背负，请放下我，放我离开。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530015105",
    "length": 24
  },
  {
    "id": 3708,
    "uuid": "ff503fe9-d223-4228-9032-518d7db30bd4",
    "hitokoto": "即使被人记恨 只要各位安好 抛弃一切便好",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530015274",
    "length": 20
  },
  {
    "id": 3710,
    "uuid": "bd13116c-b876-43cd-8866-376b17d0fd2c",
    "hitokoto": "有些人适合牵手，而有些人适合孤独地走。愿岁月静好，愿年华依旧，愿有人用其一生。挽你衣袖！",
    "type": "e",
    "from": "Myself-原创",
    "from_who": null,
    "creator": "O_O",
    "creator_uid": 1850,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854834",
    "length": 44
  },
  {
    "id": 3712,
    "uuid": "8353627b-6059-4c91-84d1-48c4777dd2c9",
    "hitokoto": "一个人有多热心，他就会感到有多寒冷",
    "type": "e",
    "from": "Myself-原创",
    "from_who": null,
    "creator": "O_O",
    "creator_uid": 1850,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854685",
    "length": 17
  },
  {
    "id": 3713,
    "uuid": "b295ab2a-9706-47e8-8bc0-01b932176b69",
    "hitokoto": "踏碎零花，执剑称皇！",
    "type": "e",
    "from": "Myself-原创",
    "from_who": null,
    "creator": "O_O",
    "creator_uid": 1850,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532854644",
    "length": 10
  },
  {
    "id": 3721,
    "uuid": "ce41944d-4d4e-4bba-a39a-575d22c2cd80",
    "hitokoto": "是我不该如此，抱歉，怪我太矫情。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530014667",
    "length": 16
  },
  {
    "id": 3723,
    "uuid": "c45105f4-c253-493f-835d-c16433727a7f",
    "hitokoto": "猿粪和狗屎其实是一类东西，这个你知道的吧。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530015518",
    "length": 21
  },
  {
    "id": 3739,
    "uuid": "bf3ba35e-dd8e-483b-84c0-ad7fadb799e1",
    "hitokoto": "幸福是什么？幸福就像第一次我轻轻地牵住你的手，然后我们不约而同地调整手的位置都想要牢牢的抓紧对方。这是我第二次写幸福。",
    "type": "e",
    "from": "顾",
    "from_who": null,
    "creator": "漆黑烈焰使",
    "creator_uid": 1521,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532308827",
    "length": 59
  },
  {
    "id": 3740,
    "uuid": "a7f3edc7-075b-42bb-8b31-201b8b40ac32",
    "hitokoto": "人颜美祸，不过一场空悲。",
    "type": "e",
    "from": "终究",
    "from_who": null,
    "creator": "终究",
    "creator_uid": 1784,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532251460",
    "length": 12
  },
  {
    "id": 3746,
    "uuid": "f4d9ffc7-67a7-441f-b1e0-8b2395e26033",
    "hitokoto": "如果现在不开始想，那以后哪有时间做",
    "type": "e",
    "from": "哲理",
    "from_who": null,
    "creator": "LF112",
    "creator_uid": 1845,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532774431",
    "length": 17
  },
  {
    "id": 3754,
    "uuid": "05fae027-f323-4662-9b2b-448f6bed3280",
    "hitokoto": "你很好，我也很喜欢，但我不是追着别人跑的年纪了。",
    "type": "e",
    "from": "相信你愿意相信的就好了",
    "from_who": null,
    "creator": "相信你愿意相信的就好了",
    "creator_uid": 1738,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530691769",
    "length": 24
  },
  {
    "id": 3755,
    "uuid": "8027b270-3c84-4e59-b7e6-73f8664a5188",
    "hitokoto": "等一条离群太远的深海游鱼 碰到一只 离群太远的蚁",
    "type": "e",
    "from": "ccdalao",
    "from_who": null,
    "creator": "KKMC",
    "creator_uid": 312,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530410255",
    "length": 24
  },
  {
    "id": 3756,
    "uuid": "61d71053-cb19-411a-bd0c-be91b05cb01d",
    "hitokoto": "可能你现在不是别人的，但将来也不会是我的。",
    "type": "e",
    "from": "相信你愿意相信的就好了",
    "from_who": null,
    "creator": "相信你愿意相信的就好了",
    "creator_uid": 1738,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530691845",
    "length": 21
  },
  {
    "id": 3763,
    "uuid": "9e618bd6-2b48-4236-bcaf-ca2373d9dea6",
    "hitokoto": "放开我吧，求求你们，放我走吧，让我离开",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "妖酆",
    "creator_uid": 1702,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1530015083",
    "length": 19
  },
  {
    "id": 3784,
    "uuid": "5b720897-0c79-42a0-af56-70dda0117d49",
    "hitokoto": "亲爱的，如果你爱上别人，请记得告诉我，然后狠狠甩我一巴掌，大声告诉我“我们不可能了”，让我滚。 这样，我才好歇斯底里的忘了你。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533106788",
    "length": 63
  },
  {
    "id": 3789,
    "uuid": "d7564239-a5c9-43fa-88d5-6663b0f5a231",
    "hitokoto": "为什么要难过,一直微笑就好啦",
    "type": "e",
    "from": "Doraemon!",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533692014",
    "length": 14
  },
  {
    "id": 3792,
    "uuid": "d6427ecf-c0b8-45b7-a1f3-e4476f9f0f74",
    "hitokoto": "很多事情犹如天气，慢慢热或是渐渐冷，等到惊悟的时候，已过了一季。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533107240",
    "length": 32
  },
  {
    "id": 3793,
    "uuid": "8f69d1d8-ee66-47e9-abe6-a745a060a629",
    "hitokoto": "穿别人的鞋，走自己的路，让他们找去吧。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533107209",
    "length": 19
  },
  {
    "id": 3801,
    "uuid": "5478d6b3-596b-4e99-be2f-b10a7c31f66b",
    "hitokoto": "雷锋做了好事不留名，但是每一件事情都记到日记里面。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533107138",
    "length": 25
  },
  {
    "id": 3802,
    "uuid": "7acc6a93-2dd6-460e-b224-666c28189b8e",
    "hitokoto": "青春就像卫生纸。看着挺多的，用着用着就不够了。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533107094",
    "length": 23
  },
  {
    "id": 3805,
    "uuid": "c2c65803-4157-45b1-bf0f-23e80e6af7f1",
    "hitokoto": "路，在不通时，选择拐弯，心，在不快时，选择看淡；情，在渐远时，就选择随意。圈子不同，不必强融。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533107230",
    "length": 47
  },
  {
    "id": 3806,
    "uuid": "e712f02b-3aa9-4498-8802-666ad7fca461",
    "hitokoto": "漫漫人生路，相知有几人。",
    "type": "e",
    "from": "安如星",
    "from_who": null,
    "creator": "安如星",
    "creator_uid": 1917,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534233299",
    "length": 12
  },
  {
    "id": 3807,
    "uuid": "e86827bd-2ed2-4d7a-9842-fbe09f58f8f8",
    "hitokoto": "别跟我谈感情，多伤钱啊！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "zhouzz",
    "creator_uid": 1856,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1533107129",
    "length": 12
  },
  {
    "id": 3814,
    "uuid": "1aa70b1e-6cf0-4292-80b0-d79f39048f26",
    "hitokoto": "与其在家颓废，还不如多出去干点善事",
    "type": "e",
    "from": "哲理",
    "from_who": null,
    "creator": "LF112",
    "creator_uid": 1845,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1534503458",
    "length": 17
  },
  {
    "id": 3820,
    "uuid": "ceaa98b0-9d48-4a5a-b506-e1c25bab33a5",
    "hitokoto": "事实总是露骨地斥责我，有些痛苦是不能体尝的。",
    "type": "e",
    "from": "听海听心",
    "from_who": null,
    "creator": "听海听心",
    "creator_uid": 1985,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535439597",
    "length": 22
  },
  {
    "id": 3822,
    "uuid": "40d2e6f7-11c4-4e08-a317-8306dd570717",
    "hitokoto": "该来的回忆总令人回味。不该来的，迟早逝去。",
    "type": "e",
    "from": "终究",
    "from_who": null,
    "creator": "终究",
    "creator_uid": 1784,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535418453",
    "length": 21
  },
  {
    "id": 3823,
    "uuid": "69ddaeb2-e330-407f-9548-dc25df746983",
    "hitokoto": "免费？不存在的！别人总要从你那里拿走点什么，或者是名声或者是金钱。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "墨影",
    "creator_uid": 1963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535191768",
    "length": 33
  },
  {
    "id": 3824,
    "uuid": "d6d4c99f-ed2a-4b0b-bf6a-cf09b81fd533",
    "hitokoto": "这个世界上不存在绝对的免费，哪怕你摘一个野果也是要向果树付出劳动的！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "墨影",
    "creator_uid": 1963,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535191853",
    "length": 34
  },
  {
    "id": 3836,
    "uuid": "769c93c2-b7db-47f8-a39b-df52e37b0f01",
    "hitokoto": "落日拉开黑夜的帷幕，繁星点燃黎明的火光。",
    "type": "e",
    "from": "神奇のDzoer",
    "from_who": null,
    "creator": "神奇のDzoer",
    "creator_uid": 2029,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536461618",
    "length": 20
  },
  {
    "id": 3861,
    "uuid": "35ef7d69-5771-4869-b9f9-d843bc91d3df",
    "hitokoto": "重要的事情，你怎么不做呢？",
    "type": "e",
    "from": "vasvdfg",
    "from_who": null,
    "creator": "vasvdfg",
    "creator_uid": 1830,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1532670394",
    "length": 13
  },
  {
    "id": 3864,
    "uuid": "b039fc01-8fa1-4656-a1c2-c8dfa09309aa",
    "hitokoto": "不要企图窥探我的生活，你能看到的，都是我希望让你看到的。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "青衫酒",
    "creator_uid": 1957,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535075901",
    "length": 28
  },
  {
    "id": 3867,
    "uuid": "76fff68e-5740-4b70-a837-404958a8fae7",
    "hitokoto": "假使让ta的爱回归，你的心过得去吗？",
    "type": "e",
    "from": "终究",
    "from_who": null,
    "creator": "终究",
    "creator_uid": 1784,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1535590172",
    "length": 18
  },
  {
    "id": 3873,
    "uuid": "c96dcb18-03ed-4f60-9877-7f3e68448a3d",
    "hitokoto": "汐文小姐，我会想你，在我这漫漫长路上的每一步！",
    "type": "e",
    "from": "事事",
    "from_who": null,
    "creator": "事事",
    "creator_uid": 1412,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1536422532",
    "length": 23
  },
  {
    "id": 3882,
    "uuid": "128ea711-0223-40c9-9089-d1bd4fb99f33",
    "hitokoto": "我既不想伤害别人，也不想被伤害",
    "type": "e",
    "from": "Doraemon!",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537159222",
    "length": 15
  },
  {
    "id": 3888,
    "uuid": "561acf75-0ebf-42c0-8306-81701ee46dff",
    "hitokoto": "卑屈游戏谁是先该离场的呢？",
    "type": "e",
    "from": "兰斯洛特",
    "from_who": null,
    "creator": "兰斯落洛特",
    "creator_uid": 2078,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537417401",
    "length": 13
  },
  {
    "id": 3891,
    "uuid": "c53f6c01-d633-46f3-90b8-bf32ccf09302",
    "hitokoto": "每个人生来都是妄想家",
    "type": "e",
    "from": "mozei",
    "from_who": null,
    "creator": "mozei",
    "creator_uid": 2081,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537442645",
    "length": 10
  },
  {
    "id": 3892,
    "uuid": "289ae44c-b3f9-45dd-aa88-392d6a889b47",
    "hitokoto": "天不生我墨泽埃，赌道万古如长夜。钱来！",
    "type": "e",
    "from": "mozei",
    "from_who": null,
    "creator": "mozei",
    "creator_uid": 2081,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537442888",
    "length": 19
  },
  {
    "id": 3924,
    "uuid": "260de447-6582-4c91-ad67-1c3bc9058f26",
    "hitokoto": "人生四然：来是偶然，去是必然，尽其当然，顺其自然 ...",
    "type": "e",
    "from": "san.ci",
    "from_who": null,
    "creator": "sanci",
    "creator_uid": 2093,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537730523",
    "length": 28
  },
  {
    "id": 3928,
    "uuid": "813088c5-a2d7-4ac4-bf9c-c2d1a80d8a2b",
    "hitokoto": "是模仿出来的，模仿不出来",
    "type": "e",
    "from": "isoks",
    "from_who": null,
    "creator": "isoks",
    "creator_uid": 2092,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1537779664",
    "length": 12
  },
  {
    "id": 3931,
    "uuid": "afc68395-6e1c-429c-b322-f1b7f4d43eba",
    "hitokoto": "嘿！活着是件很好的事",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Great old ones",
    "creator_uid": 2073,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538200036",
    "length": 10
  },
  {
    "id": 3936,
    "uuid": "4d6f4d61-7f72-4cb8-88e9-c7d7239992ab",
    "hitokoto": "我追着你，因为我爱你",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "yemaster",
    "creator_uid": 1159,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538572519",
    "length": 10
  },
  {
    "id": 3938,
    "uuid": "6628373f-d1ed-48bc-837e-6ccb3d2b7045",
    "hitokoto": "路过的熟悉，如同有你，已无转身的距离。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Carlos1872",
    "creator_uid": 2138,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538618196",
    "length": 19
  },
  {
    "id": 3941,
    "uuid": "81d3691a-620a-4857-ac2b-cf9e00fb9281",
    "hitokoto": "你身上散发出的迷人气息足以说明你是一朵艳丽的玫瑰 不过也是一场祸。",
    "type": "e",
    "from": "云卿。",
    "from_who": null,
    "creator": "MC蓝莲花。",
    "creator_uid": 2141,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538651516",
    "length": 33
  },
  {
    "id": 3943,
    "uuid": "f3d460ac-7a02-485b-8dcf-15bfb5c1aae0",
    "hitokoto": "小时候，我妈说我的手指长，将来能当钢琴家，然后我成了码农",
    "type": "e",
    "from": "erevus",
    "from_who": null,
    "creator": "yiveco",
    "creator_uid": 0,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538733180",
    "length": 28
  },
  {
    "id": 3950,
    "uuid": "cdf98e14-8308-4ed0-b135-594830df822c",
    "hitokoto": "梦里什么都有？梦里有你就够了。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541230015",
    "length": 15
  },
  {
    "id": 3951,
    "uuid": "e157cfdc-fedb-4268-9ff7-b4dba506a92b",
    "hitokoto": "你特殊的遭遇并不是你可以特殊的理由",
    "type": "e",
    "from": "CrankAR",
    "from_who": null,
    "creator": "CrankAR",
    "creator_uid": 2131,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1538811509",
    "length": 17
  },
  {
    "id": 3966,
    "uuid": "3c76655e-4235-4ee1-b908-4771ea9b8ca1",
    "hitokoto": "上帝点头给你想要的，摇头给你更好的，他让你等，就是要给你最棒的❤",
    "type": "e",
    "from": "喵小皮",
    "from_who": null,
    "creator": "喵小皮",
    "creator_uid": 2301,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541663963",
    "length": 32
  },
  {
    "id": 3967,
    "uuid": "56a77fc7-1d7a-4605-a4bd-2201caac29d3",
    "hitokoto": "你是绚烂白昼，也是沉寂黑夜，你是我血液里涌动的色彩，你是那治愈良药，也是那极致痛苦，你是我渴望触摸的唯一",
    "type": "e",
    "from": "喵小皮",
    "from_who": null,
    "creator": "喵小皮",
    "creator_uid": 2301,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541677364",
    "length": 52
  },
  {
    "id": 3982,
    "uuid": "612dd1ce-96e4-4996-b74d-09bb0cfe20ee",
    "hitokoto": "我们走过了幼稚，走过了纯粹，走过了伤痛，也就走过了青春。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "MontyTitan",
    "creator_uid": 2262,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540724078",
    "length": 28
  },
  {
    "id": 3984,
    "uuid": "2200401a-5add-4001-9663-e1d90505033a",
    "hitokoto": "因为喜欢你，所以喜欢你。",
    "type": "e",
    "from": "茶",
    "from_who": null,
    "creator": "YukoAsuka",
    "creator_uid": 2253,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540651919",
    "length": 12
  },
  {
    "id": 3986,
    "uuid": "14e98e54-dbfb-47f1-9ce0-9508fe8a1ea4",
    "hitokoto": "可以嘲笑你的朋友，但不能嘲笑他喜欢的东西。",
    "type": "e",
    "from": "茶",
    "from_who": null,
    "creator": "YukoAsuka",
    "creator_uid": 2253,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540639028",
    "length": 21
  },
  {
    "id": 3998,
    "uuid": "3ab28bee-680f-48e0-bce3-ed85bff2d97e",
    "hitokoto": "你说夜里做的决定隔天就会反悔，那么我就要为了你的反悔等到零点。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540043213",
    "length": 31
  },
  {
    "id": 4020,
    "uuid": "bc7e896b-7580-4e51-a610-f5835ac8772e",
    "hitokoto": "路这么窄，好难过啊！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540185890",
    "length": 10
  },
  {
    "id": 4021,
    "uuid": "60dc49f4-d738-442c-b7e3-fe8dd734780c",
    "hitokoto": "为什么我要走这条路？因为我在这条路上遇到过你。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540185942",
    "length": 23
  },
  {
    "id": 4022,
    "uuid": "29956a65-07dd-42a7-94db-468a5722b198",
    "hitokoto": "请记住，努力不是为了让别人更喜欢你，而是为了让你更喜欢你自己！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Zctoylm",
    "creator_uid": 2237,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540204207",
    "length": 31
  },
  {
    "id": 4025,
    "uuid": "d445adcd-ea6e-4e59-99b9-cb3744eb5b3a",
    "hitokoto": "人和人是无法理解的，所有的理解都是建立在自己的主观之上。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "世界唯一の勇者",
    "creator_uid": 243,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540464688",
    "length": 28
  },
  {
    "id": 4026,
    "uuid": "f0d63f18-9d16-4638-b75f-ff115ea1b83d",
    "hitokoto": "误会，不是始于说出的话。而且从“言行”本身开始，就已经在发生了",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "世界唯一の勇者",
    "creator_uid": 243,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540464722",
    "length": 31
  },
  {
    "id": 4027,
    "uuid": "fbf70bcb-5d25-422e-ae16-5f132a1a4ddf",
    "hitokoto": "你不会独属于我，但我心中有你的专属位置。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "世界唯一の勇者",
    "creator_uid": 243,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540464792",
    "length": 20
  },
  {
    "id": 4033,
    "uuid": "1583e594-de4d-42e2-8ffb-a2671ef346f4",
    "hitokoto": "喜欢 不过是我愿意在冬天把自己当做你的暖水袋而已 如此便是",
    "type": "e",
    "from": "pulei",
    "from_who": null,
    "creator": "pulei",
    "creator_uid": 2185,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539446491",
    "length": 29
  },
  {
    "id": 4035,
    "uuid": "b69df0ef-287e-4ae8-b728-81d50cc03dd4",
    "hitokoto": "故事的结局从来不人意！",
    "type": "e",
    "from": "九思",
    "from_who": null,
    "creator": "我眼中有星河万里",
    "creator_uid": 2311,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541996434",
    "length": 11
  },
  {
    "id": 4037,
    "uuid": "cac0b5ad-d201-4de0-8525-ba86d58ffc6c",
    "hitokoto": "只要我喝的够多，寂寞就侵蚀不了我",
    "type": "e",
    "from": "晓龙鸽鸽",
    "from_who": null,
    "creator": "Xlong",
    "creator_uid": 2308,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1541901912",
    "length": 16
  },
  {
    "id": 4047,
    "uuid": "40f617c9-6fe3-42a5-9ba5-47ebb1c96912",
    "hitokoto": "知道为什么你会遭受这么多的挫折吗？因为神认为，只有历尽了磨难的人才能成功啊！你是神选之子啊！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542463404",
    "length": 46
  },
  {
    "id": 4050,
    "uuid": "457df911-efa3-475d-a657-4e6fe951bbc6",
    "hitokoto": "我身上早已烙下沉默燃烧后遗留下来的哀愁",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "key lin",
    "creator_uid": 2340,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542337129",
    "length": 19
  },
  {
    "id": 4051,
    "uuid": "b3065772-c92a-4782-9efd-fd941db743d0",
    "hitokoto": "真正无穷的自由，会包容你所有的思念",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "少年听雨歌楼上",
    "creator_uid": 1950,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542291451",
    "length": 17
  },
  {
    "id": 4053,
    "uuid": "7e57c392-3861-4fa7-bae9-1501653461b3",
    "hitokoto": "愿用余生换半城烟雨，半城繁花。",
    "type": "e",
    "from": "乱世流年",
    "from_who": null,
    "creator": "乱世流年",
    "creator_uid": 2306,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542193004",
    "length": 15
  },
  {
    "id": 4056,
    "uuid": "df4e9ac7-5315-4c6d-8ae7-2104c8b42190",
    "hitokoto": "不是所有牛奶都叫特仑苏。",
    "type": "e",
    "from": "乱世流年",
    "from_who": null,
    "creator": "乱世流年",
    "creator_uid": 2306,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542084495",
    "length": 12
  },
  {
    "id": 4067,
    "uuid": "3fd57d95-07b5-4d6f-aae6-13ae2fa47ea4",
    "hitokoto": "容忍别人的一切错误",
    "type": "e",
    "from": "Doraemon!",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544495202",
    "length": 9
  },
  {
    "id": 4068,
    "uuid": "8f9e670e-6ad5-411b-9d1e-c3cb2e544f57",
    "hitokoto": "重逢大都是暖心的，时隔多年，偌大的城市，人海茫茫，我已不复当初，你却仍然，温暖如故",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "梁沐夏",
    "creator_uid": 2466,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544448296",
    "length": 41
  },
  {
    "id": 4087,
    "uuid": "a28a4db6-f052-4051-9bb8-01be305e9582",
    "hitokoto": "我们坚持一件事情的时候，不是因为这样做了会有效果，而是坚信，这样做是对的。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "清丶痕",
    "creator_uid": 2212,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1539860022",
    "length": 37
  },
  {
    "id": 4098,
    "uuid": "a666a16f-e627-4e2d-8d18-cbf3c63bf651",
    "hitokoto": "老天又给我开了一个大大的玩笑。但是，玩笑是无伤大雅的，对吗？",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540019466",
    "length": 30
  },
  {
    "id": 4114,
    "uuid": "707fbfe2-b839-4e90-9c17-f25bbacf5a98",
    "hitokoto": "程序漏洞叫特性，设计漏洞叫特色",
    "type": "e",
    "from": "沃·兹基·硕得",
    "from_who": null,
    "creator": "语冰夏虫",
    "creator_uid": 2263,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1540725706",
    "length": 15
  },
  {
    "id": 4122,
    "uuid": "e9171518-4cc9-4ca4-a9bf-4e2c3acad9b5",
    "hitokoto": "The more you learn the less you will feel you know.",
    "type": "e",
    "from": "ChildEden",
    "from_who": null,
    "creator": "ChildEden",
    "creator_uid": 2314,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542122543",
    "length": 51
  },
  {
    "id": 4131,
    "uuid": "600d7269-99e9-49e2-95b9-3f9626e05423",
    "hitokoto": "别人走在拼命赚钱，而我赚不到，我感觉我和这个世界格格不入",
    "type": "e",
    "from": "二十一",
    "from_who": null,
    "creator": "二十一",
    "creator_uid": 2361,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1542693931",
    "length": 28
  },
  {
    "id": 4141,
    "uuid": "f3a56508-2b52-4ae6-8ed9-828e19d227e4",
    "hitokoto": "有多少人以友谊的名义，爱着一个人，认为拥有，就是失去的开始。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "竹恋蝶",
    "creator_uid": 2408,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543562355",
    "length": 30
  },
  {
    "id": 4142,
    "uuid": "c8363ebb-00a1-4695-91c6-e5f217f7ae59",
    "hitokoto": "你能留给岁月的，岁月能留给你的，除了一个最好的自己，别无他物。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "竹恋蝶",
    "creator_uid": 2408,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543562384",
    "length": 31
  },
  {
    "id": 4143,
    "uuid": "a600d24c-57fb-4c9b-9e71-13f922aa16eb",
    "hitokoto": "守口如瓶，包括对自己。这是一种美德。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "竹恋蝶",
    "creator_uid": 2408,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543562503",
    "length": 18
  },
  {
    "id": 4144,
    "uuid": "e0ee1322-a4b6-4a67-af05-cf546c1d5987",
    "hitokoto": "心若不动，风又奈何",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "竹恋蝶",
    "creator_uid": 2408,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543562568",
    "length": 9
  },
  {
    "id": 4145,
    "uuid": "fbf3ec9c-d5c6-433d-b905-969a7a9e142a",
    "hitokoto": "你想要的，岁月会给你",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "竹恋蝶",
    "creator_uid": 2408,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1543562623",
    "length": 10
  },
  {
    "id": 4157,
    "uuid": "c4cc4c96-9dbd-4b91-a3be-d5795ca6db8d",
    "hitokoto": "我想去很远很远的地方，不是天堂，也不是西藏，是没有你的地方。",
    "type": "e",
    "from": "我",
    "from_who": null,
    "creator": "社糖糖",
    "creator_uid": 2372,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544446963",
    "length": 30
  },
  {
    "id": 4158,
    "uuid": "4f3244c1-4c8b-420a-b8a8-c8548fc0fa17",
    "hitokoto": "我不再是我，我究竟是什么",
    "type": "e",
    "from": "Doraemon!",
    "from_who": null,
    "creator": "Doraemon!",
    "creator_uid": 1438,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1544495121",
    "length": 12
  },
  {
    "id": 4163,
    "uuid": "44d47cfe-7ef6-4848-99fc-7d924e337a48",
    "hitokoto": "自命不凡者，脑中被其所知的少数事物所占据，以致没有空间去容纳无数其所不知的事物。",
    "type": "e",
    "from": "萧伯纳",
    "from_who": null,
    "creator": "zhouyuheng",
    "creator_uid": 2498,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545028012",
    "length": 40
  },
  {
    "id": 4180,
    "uuid": "e6ed1f59-39a8-4d84-9380-dbcc81d035a8",
    "hitokoto": "我们所做的事情，不过是重复前人所做的事情罢了",
    "type": "e",
    "from": "Myself – 原创",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547732850",
    "length": 22
  },
  {
    "id": 4188,
    "uuid": "ab341911-6b4d-46c1-b1e4-7b9b529a4466",
    "hitokoto": "真可悲，你什么都不知道，在这个世界上没有什么是不重要的！",
    "type": "e",
    "from": "克劳德",
    "from_who": null,
    "creator": "dugulp",
    "creator_uid": 2523,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545329579",
    "length": 28
  },
  {
    "id": 4191,
    "uuid": "8b761a8c-3f82-4664-98ca-6afd8d76867a",
    "hitokoto": "得之我幸，失之我命。",
    "type": "e",
    "from": "徐志摩",
    "from_who": null,
    "creator": "AshenOne",
    "creator_uid": 2517,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545396942",
    "length": 10
  },
  {
    "id": 4194,
    "uuid": "918eabaa-247a-4612-a51a-36687aa91a4d",
    "hitokoto": "梦，随时生，随实灭。",
    "type": "e",
    "from": "墓封影",
    "from_who": null,
    "creator": "fory",
    "creator_uid": 2549,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545673192",
    "length": 10
  },
  {
    "id": 4196,
    "uuid": "46e10f2a-b748-417b-96dc-41c1da400e88",
    "hitokoto": "忘了TA以后，我还能忘记什么！",
    "type": "e",
    "from": "墓封影",
    "from_who": null,
    "creator": "fory",
    "creator_uid": 2549,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1545673242",
    "length": 15
  },
  {
    "id": 4220,
    "uuid": "70b5301e-7240-4556-a305-f279fe94aac7",
    "hitokoto": "天下没有免费的午餐，努力创造奇迹吧少年！",
    "type": "e",
    "from": "不朽千秋",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546145543",
    "length": 20
  },
  {
    "id": 4221,
    "uuid": "8152aa82-2d69-4994-8e70-66e8232bbeef",
    "hitokoto": "我无法参加你的派对，因为我沉迷在自己的世界。",
    "type": "e",
    "from": "不朽千秋",
    "from_who": null,
    "creator": "不朽千秋",
    "creator_uid": 2571,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546145687",
    "length": 22
  },
  {
    "id": 4222,
    "uuid": "a7d689b8-9006-481e-8a9f-71de7b844b0c",
    "hitokoto": "无论如何轮回做出选择，终将还是会后悔。",
    "type": "e",
    "from": "HUAMBAKA",
    "from_who": null,
    "creator": "HUAMBAKA",
    "creator_uid": 2588,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1546440545",
    "length": 19
  },
  {
    "id": 4233,
    "uuid": "b049604a-e8ac-4494-902d-b6f54a33ee36",
    "hitokoto": "即使这一切如此虚假，那又如何？",
    "type": "e",
    "from": "small_xu",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1547787815",
    "length": 15
  },
  {
    "id": 4257,
    "uuid": "b4e447a5-14af-49d5-9687-d0b450074982",
    "hitokoto": "时间突然向前迈了一大步，我奋力追赶，却遥不可及。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1548043665",
    "length": 24
  },
  {
    "id": 4279,
    "uuid": "4f154808-f62a-49d5-9f7b-471494dae0df",
    "hitokoto": "未知和恐惧并不是你停下脚步的理由",
    "type": "e",
    "from": "孤影墨香",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549883917",
    "length": 16
  },
  {
    "id": 4282,
    "uuid": "b9c40cf1-fad6-45fe-916e-354ac790d6a3",
    "hitokoto": "坚定信念走下去。",
    "type": "e",
    "from": "孤影墨香",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549884831",
    "length": 8
  },
  {
    "id": 4284,
    "uuid": "095ef8c3-f8ab-484d-9189-6627836218db",
    "hitokoto": "在地球75亿人内与你相遇是多么幸福啊。",
    "type": "e",
    "from": "孤影墨香",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1549888397",
    "length": 19
  },
  {
    "id": 4298,
    "uuid": "f002c8ca-be74-4f31-9832-cf58eb849f33",
    "hitokoto": "破解版的“爱情”APP，有吗？",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "礼乐",
    "creator_uid": 2215,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1550063016",
    "length": 15
  },
  {
    "id": 4303,
    "uuid": "640cffc2-1eae-4974-a53e-fcbef74e5d3c",
    "hitokoto": "生死听天命，你也由天定！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "by柯乐",
    "creator_uid": 2788,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1550688607",
    "length": 12
  },
  {
    "id": 4306,
    "uuid": "bbe6102c-af5b-4e32-99a8-fd3777b24ce9",
    "hitokoto": "我愿将歌化作风，聆听朗朗的春声。",
    "type": "e",
    "from": "村花上树",
    "from_who": null,
    "creator": "村花上树梢",
    "creator_uid": 2824,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551444532",
    "length": 16
  },
  {
    "id": 4307,
    "uuid": "69473a12-6e15-4b0f-8bea-627ff134f794",
    "hitokoto": "水滴撞碎的不仅仅是2000艘恒星级战舰，更是人类的骄傲自大的心。",
    "type": "e",
    "from": "孤影墨香",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551446535",
    "length": 32
  },
  {
    "id": 4308,
    "uuid": "eb0cce48-5906-43a4-ad9c-e7abed799f96",
    "hitokoto": "请保持理性，冰冷的数字总是比一拍脑门的决定好多了。",
    "type": "e",
    "from": "孤影墨香",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551446586",
    "length": 25
  },
  {
    "id": 4318,
    "uuid": "531d7277-02c2-46a9-bbb0-7864cca021db",
    "hitokoto": "我是个特别害怕失败的人，为此错过了好多事。",
    "type": "e",
    "from": "碎碎念",
    "from_who": null,
    "creator": "柔刃",
    "creator_uid": 3053,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557285569",
    "length": 21
  },
  {
    "id": 4319,
    "uuid": "e543aa76-cdc5-4956-a61a-a8b62ab95a97",
    "hitokoto": "就是因为知道永远都不可能在一起，所以我才会更加珍惜和你在一起的每一天！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "「❦」",
    "creator_uid": 3191,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557225000",
    "length": 35
  },
  {
    "id": 4347,
    "uuid": "acfa746f-0af1-4a9d-96eb-859512fb5fd5",
    "hitokoto": "多年后，我终于成就了自己。然而可惜不是你，陪我到最后",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "ICANESCAPE",
    "creator_uid": 2859,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1551884236",
    "length": 26
  },
  {
    "id": 4353,
    "uuid": "fcef9b93-eb2a-40d6-a79b-aeae7309799d",
    "hitokoto": "来去无常，得过且过",
    "type": "e",
    "from": "温十三",
    "from_who": null,
    "creator": "foxphehe",
    "creator_uid": 2893,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1552554448",
    "length": 9
  },
  {
    "id": 4354,
    "uuid": "7d71f027-34ba-4cc1-8bd7-c4a7294ec51f",
    "hitokoto": "大部分人对自我的否定是心理作用，实际上他人可能会给你更高的评价。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Lipww1234",
    "creator_uid": 514,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557070261",
    "length": 32
  },
  {
    "id": 4356,
    "uuid": "d2459726-e1ed-40fb-bf41-325ef00a9b9c",
    "hitokoto": "不是我想要放弃，你自己不去珍惜为什么要去怪我？",
    "type": "e",
    "from": "Az殇芯",
    "from_who": null,
    "creator": "Az殇芯",
    "creator_uid": 3173,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556887006",
    "length": 23
  },
  {
    "id": 4357,
    "uuid": "c43cd325-c8c1-4a32-98a7-40c30b63e5ac",
    "hitokoto": "有时候，和你吵架，我宁愿当一个输家，也不愿意赢我爱的你！！！",
    "type": "e",
    "from": "Az殇芯",
    "from_who": null,
    "creator": "Az殇芯",
    "creator_uid": 3173,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1556887319",
    "length": 30
  },
  {
    "id": 4372,
    "uuid": "4a5d608e-aeb1-4f6f-bbbf-74d3ac0ea44e",
    "hitokoto": "希望只在一瞬之间，而黑暗，永恒。",
    "type": "e",
    "from": "孤影墨香",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1555511272",
    "length": 16
  },
  {
    "id": 4381,
    "uuid": "7be21831-4dfd-464e-bf15-f3684822b2cd",
    "hitokoto": "又苦又甜，也挺好嘛，很像生活",
    "type": "e",
    "from": "singular港",
    "from_who": null,
    "creator": "singular港",
    "creator_uid": 3138,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557156793",
    "length": 14
  },
  {
    "id": 4382,
    "uuid": "df225c78-cc10-4818-9bc5-5fcc25be016b",
    "hitokoto": "从未仔细感受怦然心动的时候，后来才发现它叫：喜欢。如果时间能冲流该有多好！无论如何，能和你成为朋友亦是不易！余生我陪你！",
    "type": "e",
    "from": "自创",
    "from_who": null,
    "creator": "うさぎドロップ「结缘」",
    "creator_uid": 3185,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557062485",
    "length": 60
  },
  {
    "id": 4391,
    "uuid": "7da9e966-393a-4d0e-a702-009864a7975b",
    "hitokoto": "梦想不应被嘲笑，也应该不惧流言！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "某某",
    "creator_uid": 2936,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553273914",
    "length": 16
  },
  {
    "id": 4400,
    "uuid": "b043c902-6614-4a06-a608-463d971e58b0",
    "hitokoto": "前进路上的阴影，来自身后的光明。",
    "type": "e",
    "from": "无心却总伤心",
    "from_who": null,
    "creator": "无心却总伤心",
    "creator_uid": 2778,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1550483742",
    "length": 16
  },
  {
    "id": 4406,
    "uuid": "611d3a72-69f3-4817-adb3-c9a28e925e5d",
    "hitokoto": "上一阵风、它吹过的时候，带走了我的心我的寂寞。",
    "type": "e",
    "from": "声音工作室晚风部",
    "from_who": null,
    "creator": "takeshita1",
    "creator_uid": 2950,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553612776",
    "length": 23
  },
  {
    "id": 4407,
    "uuid": "55af6f29-6fad-44ea-b822-0d5538d2c4c6",
    "hitokoto": "我们执着于模糊的现在，迷茫于陌生的未来，却从未曾发觉，耳边那一阵灿烂的微风。",
    "type": "e",
    "from": "声音工作室晚风部",
    "from_who": null,
    "creator": "takeshita1",
    "creator_uid": 2950,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1553615214",
    "length": 38
  },
  {
    "id": 4437,
    "uuid": "9aba379d-4c4b-4805-b7e6-9ce899778065",
    "hitokoto": "不过一介凡人，何必与世纷争。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Lisaboy",
    "creator_uid": 3232,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1557838158",
    "length": 14
  },
  {
    "id": 4454,
    "uuid": "76769625-7f85-4d20-987f-3dd9371ecdc0",
    "hitokoto": "如果没有见过光明，我本可以忍受黑暗",
    "type": "e",
    "from": "Emily Dickinson",
    "from_who": null,
    "creator": "QIQI",
    "creator_uid": 494,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565146850",
    "length": 17
  },
  {
    "id": 4458,
    "uuid": "cd580ed9-d03f-40e6-9a00-339393103e84",
    "hitokoto": "少年，别想了，那个人不是你。",
    "type": "e",
    "from": "Scholar",
    "from_who": null,
    "creator": "Scholar",
    "creator_uid": 3739,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566615414",
    "length": 14
  },
  {
    "id": 4475,
    "uuid": "4dfda1c2-c9b1-43c3-8183-12935cf39082",
    "hitokoto": "我不知道明天会怎么样，但是我一定要努力过好今天。",
    "type": "e",
    "from": "Alex Cui",
    "from_who": null,
    "creator": "Alex Cui",
    "creator_uid": 3308,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1559391030",
    "length": 24
  },
  {
    "id": 4484,
    "uuid": "bac14101-c168-49c8-a0db-3b95c5380112",
    "hitokoto": "若不爱你，死生无地。若不爱你，青魂可离。",
    "type": "e",
    "from": "有风来",
    "from_who": null,
    "creator": "丑橘子",
    "creator_uid": 3358,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1560421678",
    "length": 20
  },
  {
    "id": 4499,
    "uuid": "ec6028b8-3e54-4177-8545-b9bb3bfe16f5",
    "hitokoto": "我也要AK IOI！",
    "type": "e",
    "from": "zyd",
    "from_who": null,
    "creator": "陈俊豪",
    "creator_uid": 3452,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562111095",
    "length": 10
  },
  {
    "id": 4509,
    "uuid": "d8dc797d-2fa0-45f8-9499-d5cfe88a40ac",
    "hitokoto": "世事变迁，沧海桑田，它在万维网的角落，等着哥伦布和他的船员。",
    "type": "e",
    "from": "心印杂记",
    "from_who": null,
    "creator": "心印001",
    "creator_uid": 3471,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562508185",
    "length": 30
  },
  {
    "id": 4513,
    "uuid": "a090eac7-a77e-4be9-8c8a-d336a2c88a4b",
    "hitokoto": "“喜欢一个人难道就要放弃吗。”",
    "type": "e",
    "from": "可爱猫",
    "from_who": null,
    "creator": "un",
    "creator_uid": 3134,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562663829",
    "length": 15
  },
  {
    "id": 4516,
    "uuid": "4938063a-c968-42b7-acf6-031503fc6b7f",
    "hitokoto": "落座无言行三载，持笔无悔笑苍生！",
    "type": "e",
    "from": "SpaceSkyNet",
    "from_who": null,
    "creator": "spaceskynet",
    "creator_uid": 535,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562767182",
    "length": 16
  },
  {
    "id": 4533,
    "uuid": "1b129a74-1ab9-485a-ac98-85345612f288",
    "hitokoto": "忘了我吧，我都忘了",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "矜沫",
    "creator_uid": 3501,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1562984342",
    "length": 9
  },
  {
    "id": 4539,
    "uuid": "e3995cbb-e55e-49f3-8f91-777159ea1704",
    "hitokoto": "快乐，至少比富裕要好。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "yemaster",
    "creator_uid": 1159,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563174782",
    "length": 11
  },
  {
    "id": 4540,
    "uuid": "5aef4e77-6a40-4038-8670-de4a20f6752f",
    "hitokoto": "夏雨微尘轻拂袖，两衫风雪若得闲。",
    "type": "e",
    "from": "随笔",
    "from_who": null,
    "creator": "不负卿的伤",
    "creator_uid": 3441,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563256472",
    "length": 16
  },
  {
    "id": 4543,
    "uuid": "b2aa6665-a3d9-4121-80cf-2ddab1cd42e6",
    "hitokoto": "如果全世界都对你恶语相加，我愿对你说上一世情话。",
    "type": "e",
    "from": "临沂冈田武",
    "from_who": null,
    "creator": "临沂彭于晏",
    "creator_uid": 3519,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563342727",
    "length": 24
  },
  {
    "id": 4544,
    "uuid": "8e12fc18-5144-415e-bb22-cf3a1fc81679",
    "hitokoto": "爱是等待，是细水长流。",
    "type": "e",
    "from": "临沂冈田武",
    "from_who": null,
    "creator": "临沂彭于晏",
    "creator_uid": 3519,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563342769",
    "length": 11
  },
  {
    "id": 4545,
    "uuid": "06185fc5-5374-4aaf-b936-ad71a00b59c7",
    "hitokoto": "我没有说谎，是爱情说谎，他带你来骗我说，渴望的，有可能，有希望。",
    "type": "e",
    "from": "临沂冈田武",
    "from_who": null,
    "creator": "临沂彭于晏",
    "creator_uid": 3519,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563342855",
    "length": 32
  },
  {
    "id": 4546,
    "uuid": "1be9f951-c27b-4a07-bf7b-cbe0a91c38a3",
    "hitokoto": "如果可以，请让我们慢慢了解，慢慢喜欢。",
    "type": "e",
    "from": "临沂彭养鱼",
    "from_who": null,
    "creator": "临沂彭于晏",
    "creator_uid": 3519,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563343064",
    "length": 19
  },
  {
    "id": 4548,
    "uuid": "25ba9273-b103-41f3-a944-ff8360e80be0",
    "hitokoto": "每一个人都是带着枷锁出生的，我们渴望遇到另一个人来减轻自己负担，亦或是带着沉重的枷锁离开。",
    "type": "e",
    "from": "诗",
    "from_who": null,
    "creator": "kaishang",
    "creator_uid": 3528,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563547054",
    "length": 45
  },
  {
    "id": 4551,
    "uuid": "dbc37737-8085-45a4-a7e7-fc6927134316",
    "hitokoto": "真正珍惜时间的人不会找任何借口。。。。。可惜我不是",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "wise_world",
    "creator_uid": 3537,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563839916",
    "length": 25
  },
  {
    "id": 4556,
    "uuid": "d934051f-c4a5-4c6c-bfef-ecb35a62eab0",
    "hitokoto": "只要你在我们心里，你就不会死。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "yemaster",
    "creator_uid": 1159,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1563972621",
    "length": 15
  },
  {
    "id": 4571,
    "uuid": "b32ee34f-29bc-49e0-aaf3-dbc92e92932d",
    "hitokoto": "我喜欢的姑娘，眉如青山。",
    "type": "e",
    "from": "Yly",
    "from_who": null,
    "creator": "Yly",
    "creator_uid": 3624,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1565336776",
    "length": 12
  },
  {
    "id": 4583,
    "uuid": "af18f709-0220-4c86-8b55-27565cc83603",
    "hitokoto": "你不得不承认，你自以为那些跟你关系很好的人，他们都有关系比你更好的朋友，而你没有。",
    "type": "e",
    "from": "@抖音小助手\n",
    "from_who": null,
    "creator": "hhhh",
    "creator_uid": 1639,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566541822",
    "length": 41
  },
  {
    "id": 4586,
    "uuid": "aeff3091-f1de-4ea7-bd6f-cdf0fa2dd20d",
    "hitokoto": "愿字起于心头 转瞬又死于心间",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "liebing",
    "creator_uid": 3727,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566554787",
    "length": 14
  },
  {
    "id": 4587,
    "uuid": "5d466a87-acc1-4f84-88e0-073ffcc820b3",
    "hitokoto": "然而世事千帆而过 路的尽头终归是温柔和月光",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "liebing",
    "creator_uid": 3727,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566554836",
    "length": 21
  },
  {
    "id": 4589,
    "uuid": "6c5e4222-d5a0-46d6-a8c1-6ea1d2da061f",
    "hitokoto": "生活就像一盒巧克力，你永远不知道下一块会是什么味道。",
    "type": "e",
    "from": "阿飞",
    "from_who": null,
    "creator": "憶中人",
    "creator_uid": 3731,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1566564617",
    "length": 26
  },
  {
    "id": 4595,
    "uuid": "42383d89-72de-491f-afd9-31e701ce4a4d",
    "hitokoto": "|｡･㉨･)っ♡　喜欢你♪",
    "type": "e",
    "from": "无",
    "from_who": null,
    "creator": "lrelia",
    "creator_uid": 3787,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567014585",
    "length": 13
  },
  {
    "id": 4603,
    "uuid": "a90359d1-167d-4bfe-b9b5-55017ffe804d",
    "hitokoto": "愿将来的你，路无险阻，前途有光，每一个明天都熠熠生辉，充满希望。",
    "type": "e",
    "from": "Zeaf",
    "from_who": null,
    "creator": "Zeaf",
    "creator_uid": 3809,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567321582",
    "length": 32
  },
  {
    "id": 4621,
    "uuid": "cad40bdd-e44b-4970-abff-00ba8f488756",
    "hitokoto": "我想这世上能让我却步和流泪的人，让我心绪波动拿起烟斗的人，终究是极少数。",
    "type": "e",
    "from": "阿怂",
    "from_who": null,
    "creator": "Heay",
    "creator_uid": 3852,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567697217",
    "length": 36
  },
  {
    "id": 4627,
    "uuid": "e401ce70-5f99-4f6b-ba9e-945b9b63d32c",
    "hitokoto": "漂亮姑娘千千万，功名万里惟一人！",
    "type": "e",
    "from": "春风词",
    "from_who": null,
    "creator": "Sariay",
    "creator_uid": 3195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567970414",
    "length": 16
  },
  {
    "id": 4628,
    "uuid": "5a9fc8f5-695e-4299-b1c9-e170245be103",
    "hitokoto": "一沈秋园，满庭霜落，云烟北桥夜连城。",
    "type": "e",
    "from": "北湖词",
    "from_who": null,
    "creator": "Sariay",
    "creator_uid": 3195,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1567970516",
    "length": 18
  },
  {
    "id": 4632,
    "uuid": "32c495b1-5017-4dfe-878d-8b556f979529",
    "hitokoto": "我也是二十岁的大人了～",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "长不胖の橘猫",
    "creator_uid": 3876,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568002038",
    "length": 11
  },
  {
    "id": 4636,
    "uuid": "6d9f282c-0c49-4af5-a79e-0051890281f6",
    "hitokoto": "你怎么这么奇奇怪怪怪。。怪可爱的",
    "type": "e",
    "from": "还未找到女朋友的林同学",
    "from_who": null,
    "creator": "wait.",
    "creator_uid": 3905,
    "reviewer": 0,
    "commit_from": "web",
    "created_at": "1568398417",
    "length": 16
  },
  {
    "id": 4643,
    "uuid": "76e208ca-c9df-43d5-892d-d3665f48b83c",
    "hitokoto": "我相信所有被我遗忘的美好，一定还在这世上的某个角落，也相信总有一天，走过很长的生命，遇见美好，春暖花开！",
    "type": "e",
    "from": "Twitter",
    "from_who": "shiraishirin",
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1577864214",
    "length": 52
  },
  {
    "id": 4646,
    "uuid": "467eb993-72bd-4191-a558-0f2869607e5e",
    "hitokoto": "黎明前的黑暗，是最深不见底的黑暗。",
    "type": "e",
    "from": "彭小呆",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312140",
    "length": 17
  },
  {
    "id": 4647,
    "uuid": "a6d5f93e-fd8a-4820-9e96-fcf3d77ada31",
    "hitokoto": "校服是我和她唯一穿过的情侣装，毕业照是我和她唯一的合影。",
    "type": "e",
    "from": "彭小呆",
    "from_who": null,
    "creator": "彭小呆",
    "creator_uid": 3110,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569312157",
    "length": 28
  },
  {
    "id": 4673,
    "uuid": "e4bacb1a-c020-4d80-8069-02277d340373",
    "hitokoto": "往事不过五彩斑斓蜻蜓点水，你我呢喃皆随风语四散而去，人来人往只是日常 ​​。​​",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "amor耳朵",
    "creator_uid": 3987,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569491885",
    "length": 40
  },
  {
    "id": 4674,
    "uuid": "1ff4a1ab-94ad-4dda-b6e2-2a1b166d492f",
    "hitokoto": "焦虑像毒瘾，让人想对死亡说你好……",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "amor耳朵",
    "creator_uid": 3987,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1569491941",
    "length": 17
  },
  {
    "id": 4693,
    "uuid": "7d475d9e-7f66-4ade-b20d-6c18af1d42c7",
    "hitokoto": "对过去遗忘，对现在荒唐，对未来迷茫；\r\n大部分人如此，小部分人即便如此，也没行动改变。",
    "type": "e",
    "from": "年轻人的颓丧",
    "from_who": null,
    "creator": "萖呓儿",
    "creator_uid": 4032,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1570453353",
    "length": 43
  },
  {
    "id": 4694,
    "uuid": "a9036c4e-3186-42b3-a1c6-398d489e9d00",
    "hitokoto": "世界真可怕，想回到妈妈的肚子里。",
    "type": "e",
    "from": "年轻人的颓丧",
    "from_who": null,
    "creator": "萖呓儿",
    "creator_uid": 4032,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1570453940",
    "length": 16
  },
  {
    "id": 4696,
    "uuid": "c578b2da-c613-4206-ae17-579e8c7b10f2",
    "hitokoto": "忙碌时渴望悠闲，闲暇时却不知道干啥啦。",
    "type": "e",
    "from": "年轻人的颓废",
    "from_who": null,
    "creator": "萖呓儿",
    "creator_uid": 4032,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1570453660",
    "length": 19
  },
  {
    "id": 4698,
    "uuid": "f7349f36-0616-4bb8-afab-8e472290fc33",
    "hitokoto": "一个人，一个人，一个人，不是不想交朋友，而是懒。",
    "type": "e",
    "from": "年轻人的颓丧",
    "from_who": null,
    "creator": "萖呓儿",
    "creator_uid": 4032,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1570453832",
    "length": 24
  },
  {
    "id": 4701,
    "uuid": "06ec29e4-b7d4-4fe6-806f-7cacade2ac7b",
    "hitokoto": "天亮之后又是崭新的一天，把种种神伤丢弃在昨天，从未真正将它们消灭，于是一个又一个的昨天，把我们杀死在今夜……",
    "type": "e",
    "from": "原创",
    "from_who": "amor耳朵",
    "creator": "amor耳朵",
    "creator_uid": 3987,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1569491995",
    "length": 54
  },
  {
    "id": 4704,
    "uuid": "51df2309-7c89-40e0-a01b-fd766e215ef2",
    "hitokoto": "如果你热爱生活就不要浪费时间，因为时间组成了生活。",
    "type": "e",
    "from": "joah",
    "from_who": "joah",
    "creator": "joah",
    "creator_uid": 4054,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1570791183",
    "length": 25
  },
  {
    "id": 4708,
    "uuid": "6c5f5fa9-126a-4d43-b9d0-0a0b1c47c32d",
    "hitokoto": "在繁华中沉淀自我，在乱世中静静伫立，一笔一划，雕刻时光",
    "type": "e",
    "from": "Henry_Huang",
    "from_who": null,
    "creator": "Henry_Huang",
    "creator_uid": 4069,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571118676",
    "length": 27
  },
  {
    "id": 4716,
    "uuid": "2cf0cb70-4b52-4d7e-b2b9-7db5b876785f",
    "hitokoto": "记着你想要的东西还很贵、你喜欢的人也还不属于你、所以努力！让自己变的有资格！",
    "type": "e",
    "from": "M\u0026Yu",
    "from_who": null,
    "creator": "M\u0026Yu",
    "creator_uid": 4055,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571144517",
    "length": 38
  },
  {
    "id": 4725,
    "uuid": "061fd0e2-5b66-461f-9dce-7d053b0f35f8",
    "hitokoto": "失败是成功之母，不失败怎么能成功？",
    "type": "e",
    "from": "小林",
    "from_who": "小林",
    "creator": "xhlyy",
    "creator_uid": 4790,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580695979",
    "length": 17
  },
  {
    "id": 4756,
    "uuid": "d83d56f8-b38c-4918-9844-5f7288947acd",
    "hitokoto": "你知道的都是真相。只可惜那些并不是真相的全部。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580452921",
    "length": 23
  },
  {
    "id": 4785,
    "uuid": "cd0d1cd3-b3ac-43ba-a491-aab26cfeac09",
    "hitokoto": "诗和远方，不如家乡。",
    "type": "e",
    "from": "dreamer",
    "from_who": null,
    "creator": "dreamer",
    "creator_uid": 4116,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571717463",
    "length": 10
  },
  {
    "id": 4786,
    "uuid": "c78141b2-0b89-4230-bb90-20c88faf0930",
    "hitokoto": "人会在生活中成长，一边是成熟的模样一边是保持幼稚的模样，难免看上去会有些怪异\r\n",
    "type": "e",
    "from": "陌小五",
    "from_who": null,
    "creator": "小五五五你",
    "creator_uid": 4080,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571931191",
    "length": 40
  },
  {
    "id": 4791,
    "uuid": "89f74fae-a3cd-46a5-895f-1c2c8393aefe",
    "hitokoto": "愿你走过一场青春，还留有三分纯真",
    "type": "e",
    "from": "网络",
    "from_who": null,
    "creator": "冷兮",
    "creator_uid": 4121,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1571791456",
    "length": 16
  },
  {
    "id": 4806,
    "uuid": "b884b5bb-ce5b-4555-a1b8-e81301bef12b",
    "hitokoto": "我也不知道你哪里好，但是别人就是替代不了。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Kilig",
    "creator_uid": 4140,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572139360",
    "length": 21
  },
  {
    "id": 4812,
    "uuid": "de938080-cec7-49ae-b182-b05c398129da",
    "hitokoto": "生活就是一个游乐场，它会让你开心，也会让你焦虑，也会让你悲痛...",
    "type": "e",
    "from": "ming5234",
    "from_who": null,
    "creator": "Ming5234",
    "creator_uid": 4151,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572150685",
    "length": 33
  },
  {
    "id": 4827,
    "uuid": "2e38881f-8adb-4c3b-8005-d31f064becfe",
    "hitokoto": "多想再次回到那个夏天，那满是柠檬味气泡水和回忆的季节，漫天星河，熠熠生辉，就好像再也不见的你，历历如初。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "七夏浅笑",
    "creator_uid": 1532,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572252183",
    "length": 52
  },
  {
    "id": 4829,
    "uuid": "af543ba6-7b11-4ccc-ba97-f4004cdd856f",
    "hitokoto": "春去夏又来，而某些人和事，不再回来。留下记忆终将随风飘散，陪着一同逝去的青春。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "七夏浅笑",
    "creator_uid": 1532,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572252303",
    "length": 39
  },
  {
    "id": 4830,
    "uuid": "6a1737b1-96da-4c12-8b1c-0a7bd3233a5e",
    "hitokoto": "窗外下起了雨，雨水落向大地，远方的人却渐行渐远，我的心又该去往何方呢。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "七夏浅笑",
    "creator_uid": 1532,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572252420",
    "length": 35
  },
  {
    "id": 4831,
    "uuid": "f5ac5a0f-3bfc-46c6-b148-dfd91ad8aeaa",
    "hitokoto": "收不到回复的时间再短，也无比的漫长。胡思乱想，内心忧虑，望向窗外，叶子已落光，远方的人，何时才能相见呢。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "七夏浅笑",
    "creator_uid": 1532,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572252503",
    "length": 52
  },
  {
    "id": 4832,
    "uuid": "7527285a-daea-4f1d-a47e-cae81944a326",
    "hitokoto": "一年又一年，喜欢的的节目，一个个没了，喜欢的人，也一个个远去。以前的以前，有多少多少美好，现在的现在，却有多么多么无奈。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "七夏浅笑",
    "creator_uid": 1532,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572252587",
    "length": 60
  },
  {
    "id": 4834,
    "uuid": "495a4b36-56a2-4f4b-bc26-bca78bfd8c9d",
    "hitokoto": "多少岁月与轻狂交织的梦，被遗忘在大海的尽头，随时光匆匆流去。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "七夏浅笑",
    "creator_uid": 1532,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572253021",
    "length": 30
  },
  {
    "id": 4835,
    "uuid": "d6402cea-0742-4396-b01d-17e3af9dc593",
    "hitokoto": "我不敢去，但必须去，有些事是必须要做的逃避不了",
    "type": "e",
    "from": "孤心",
    "from_who": null,
    "creator": "孤心",
    "creator_uid": 4160,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572263068",
    "length": 23
  },
  {
    "id": 4842,
    "uuid": "a93105ea-a2b1-470f-97e4-871bacd0ac49",
    "hitokoto": "你走过的路，我都去过。我想做的事情，你都比我快一步。我们的心，像用透明的线连接在一起。",
    "type": "e",
    "from": "kangyo",
    "from_who": null,
    "creator": "linyuki",
    "creator_uid": 4100,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572828152",
    "length": 43
  },
  {
    "id": 4847,
    "uuid": "91f38f5e-3afd-4c78-9558-8e794119c796",
    "hitokoto": "既然不能让对手变弱，那就让自己变强！",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "gd56koua",
    "creator_uid": 4224,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573057247",
    "length": 18
  },
  {
    "id": 4848,
    "uuid": "752dee2a-7a6c-452f-9d3e-df67fd5999c5",
    "hitokoto": "你强归你强，我永不示弱",
    "type": "e",
    "from": "Siyuan",
    "from_who": null,
    "creator": "gd56koua",
    "creator_uid": 4224,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573121960",
    "length": 11
  },
  {
    "id": 4864,
    "uuid": "f6517b2c-6bf5-4d25-84b3-39e70aa82a37",
    "hitokoto": "自己选择的路，跪着也要走完",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "gd56koua",
    "creator_uid": 4224,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573620322",
    "length": 13
  },
  {
    "id": 4879,
    "uuid": "a1899b46-b9f7-446e-a9e1-7f9d74d3c727",
    "hitokoto": "我以为我和别人不一样,其实我只是另外一种形式的奴隶。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Suzushina_IkE",
    "creator_uid": 4285,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573782526",
    "length": 26
  },
  {
    "id": 4880,
    "uuid": "5c3069fd-9fc7-4ade-b2b5-cf49ba4e8408",
    "hitokoto": "语言的力量是强大的，但其体现是潜移默化的。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Suzushina_IkE",
    "creator_uid": 4285,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1573782778",
    "length": 21
  },
  {
    "id": 4886,
    "uuid": "13200026-fa81-472f-a784-af8380faf7c6",
    "hitokoto": "或许我们真的不配拥有一些美好的事物",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "七夏浅笑",
    "creator_uid": 1532,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572252674",
    "length": 17
  },
  {
    "id": 4887,
    "uuid": "05c33af2-cf1d-4866-8d20-0b0526993ccb",
    "hitokoto": "我向你发脾气的时候，亲亲我吧，亲亲我，我就会好了。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "是小梦呀",
    "creator_uid": 4176,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1572448311",
    "length": 25
  },
  {
    "id": 4894,
    "uuid": "f0136d60-c81b-47f4-8859-59e314a4c2eb",
    "hitokoto": "也罢就这样吧，淡看缘起缘落，有缘聚，无缘不见",
    "type": "e",
    "from": "—兔先森",
    "from_who": "—兔先森",
    "creator": "小染",
    "creator_uid": 70,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572313354",
    "length": 22
  },
  {
    "id": 4915,
    "uuid": "2e9b5d0d-ca2b-4f50-b8ac-22ed48896764",
    "hitokoto": "莲子这个东西，等的越久，它越苦涩啊。",
    "type": "e",
    "from": "Yly",
    "from_who": "Yly",
    "creator": "Yly",
    "creator_uid": 3624,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1572856045",
    "length": 18
  },
  {
    "id": 4926,
    "uuid": "06265526-a7c8-489f-9930-764fd180059b",
    "hitokoto": "Decisions as I go, to anywhere I flow.",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "梦泽",
    "creator_uid": 4342,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574569004",
    "length": 38
  },
  {
    "id": 4930,
    "uuid": "db404adf-b790-43c5-8997-55c88db449f4",
    "hitokoto": "一生能有多少次机会能遇到喜欢成这样的人呢？付出点时间和生命又如何呢？",
    "type": "e",
    "from": "旧梦",
    "from_who": null,
    "creator": "旧梦酱",
    "creator_uid": 4115,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574688599",
    "length": 34
  },
  {
    "id": 4931,
    "uuid": "815361ef-fa19-444f-a30b-1560f1059ad9",
    "hitokoto": "面子都是互相给的。",
    "type": "e",
    "from": "momo",
    "from_who": null,
    "creator": "微懒",
    "creator_uid": 4358,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1574690026",
    "length": 9
  },
  {
    "id": 4952,
    "uuid": "77859028-7dd9-4d9c-833e-b93112126994",
    "hitokoto": "这个世界上，活得轻松的只有两种人：傻子和疯子。每个正常人都有压力，或大，或小。但是请不要忘记，你不是一个人。",
    "type": "e",
    "from": "随笔",
    "from_who": null,
    "creator": "司徒和丞相",
    "creator_uid": 4434,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575721468",
    "length": 54
  },
  {
    "id": 4953,
    "uuid": "b5a17268-bb44-41d0-a8a2-9e68408cb462",
    "hitokoto": "生命本是没有意义的,但生命的存在即是其意义,更多的意义需要自己寻找,而不是课本的灌输.",
    "type": "e",
    "from": "自己",
    "from_who": null,
    "creator": "Fox Fairy",
    "creator_uid": 4436,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575732088",
    "length": 43
  },
  {
    "id": 4954,
    "uuid": "0b8a951d-b616-483f-b57c-ca0c719e6068",
    "hitokoto": "我从不相信这世界上有什么天赋异禀。那些看起来超乎寻常的人，总有你没看到的一面。",
    "type": "e",
    "from": "随笔",
    "from_who": null,
    "creator": "司徒和丞相",
    "creator_uid": 4434,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1575721581",
    "length": 39
  },
  {
    "id": 4962,
    "uuid": "03f4ea52-2181-4e10-b789-f9a1d71a80be",
    "hitokoto": "每一栋楼都要尊重不知道为他们付出了多少汗水的脚手架。",
    "type": "e",
    "from": "原创",
    "from_who": "坐凳人",
    "creator": "坐凳人",
    "creator_uid": 4832,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581668488",
    "length": 26
  },
  {
    "id": 4972,
    "uuid": "87ec3ae8-320a-4999-a248-b31e559a87d5",
    "hitokoto": "我把这几个字写了又删，删了又写。",
    "type": "e",
    "from": "原创",
    "from_who": "叶子",
    "creator": "Vicky",
    "creator_uid": 4913,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581654035",
    "length": 16
  },
  {
    "id": 4973,
    "uuid": "db38ae9c-249e-4d8f-b2cb-53eda0be9345",
    "hitokoto": "现在可以任性，但是等以后毕业了，面对生活时，却只有满目的苍茫，这是社会.......",
    "type": "e",
    "from": ":",
    "from_who": "Fly",
    "creator": "一支歌",
    "creator_uid": 4901,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581598690",
    "length": 42
  },
  {
    "id": 5001,
    "uuid": "1b1cceb4-a84b-427c-9914-2537876aa390",
    "hitokoto": "再深的感情终是黄粱一梦。",
    "type": "e",
    "from": "蓝麓",
    "from_who": "蓝麓",
    "creator": "Qicloud",
    "creator_uid": 4635,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581385911",
    "length": 12
  },
  {
    "id": 5004,
    "uuid": "0143b012-444c-4aa1-8b76-6ea3a4eb8b66",
    "hitokoto": "无知不可怕，可怕的是不知道自己需要知道什么。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "坐凳人",
    "creator_uid": 4832,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1581247806",
    "length": 22
  },
  {
    "id": 5018,
    "uuid": "2196fcdc-82fb-4136-ac72-665a646935e6",
    "hitokoto": "生命的最终奥义，不过就是活得自在罢了。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "墨客熊",
    "creator_uid": 4413,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1580370084",
    "length": 19
  },
  {
    "id": 5026,
    "uuid": "ef31e828-5dae-421f-82dc-494835d5e58e",
    "hitokoto": "人们总是在意得不到的，从而忘记了已经拥有的",
    "type": "e",
    "from": "东滨乙",
    "from_who": null,
    "creator": "东滨乙",
    "creator_uid": 4521,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576951298",
    "length": 21
  },
  {
    "id": 5030,
    "uuid": "55138601-c16f-47c9-92a9-b2d5f7e2e2af",
    "hitokoto": "你若愿爱，我若无悔",
    "type": "e",
    "from": "后会无期",
    "from_who": null,
    "creator": "后会无期",
    "creator_uid": 4525,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1576999220",
    "length": 9
  },
  {
    "id": 5036,
    "uuid": "b99c8a47-4b4f-4c84-b074-31505b43ba5a",
    "hitokoto": "浩如星海的人群中，与你相遇真是一件幸运的事情",
    "type": "e",
    "from": "小小柳之絮",
    "from_who": null,
    "creator": "smallxu",
    "creator_uid": 2639,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1577960032",
    "length": 22
  },
  {
    "id": 5037,
    "uuid": "3f29c6fd-aee3-45de-9840-0e2962d0cd93",
    "hitokoto": "有任何人在意自己，都是幸福的",
    "type": "e",
    "from": "Diving_lin",
    "from_who": null,
    "creator": "Diving_lin",
    "creator_uid": 4593,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578104198",
    "length": 14
  },
  {
    "id": 5039,
    "uuid": "eefe3d1c-8302-4ffa-83ed-c737350a47b7",
    "hitokoto": "如果只是路过，那我就在终点等你。",
    "type": "e",
    "from": "北省",
    "from_who": null,
    "creator": "东滨乙",
    "creator_uid": 4521,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578180608",
    "length": 16
  },
  {
    "id": 5040,
    "uuid": "21b22a64-8154-4996-ba49-bd1efdbdcc8f",
    "hitokoto": "生活原本沉闷，但跑起来就会有风。",
    "type": "e",
    "from": "北省",
    "from_who": null,
    "creator": "东滨乙",
    "creator_uid": 4521,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578180633",
    "length": 16
  },
  {
    "id": 5046,
    "uuid": "15c0eff6-5da8-4893-9ba0-1892bd0e9d32",
    "hitokoto": "我们都在努力的活着",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Boxpaper",
    "creator_uid": 4623,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578535752",
    "length": 9
  },
  {
    "id": 5053,
    "uuid": "b576b02c-c878-4f4d-8be7-0bf9874fe70a",
    "hitokoto": "相思不露，只因入骨，晚安！",
    "type": "e",
    "from": "自创",
    "from_who": null,
    "creator": "童年往事",
    "creator_uid": 4648,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578991929",
    "length": 13
  },
  {
    "id": 5063,
    "uuid": "f54e75e0-f0f5-460b-bef9-dd02951a5985",
    "hitokoto": "虽然你不是与我并肩走到最后的人  但感谢你曾照亮了我人生中那段漆黑的路  ",
    "type": "e",
    "from": "萧寒",
    "from_who": null,
    "creator": "童年往事",
    "creator_uid": 4648,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1578992158",
    "length": 37
  },
  {
    "id": 5067,
    "uuid": "1c4a1e24-3a12-46c4-9afc-558a2138c552",
    "hitokoto": "对于一个人而言，惨痛的经历，既能唤醒涂炭生灵的邪恶，也能孕育悲悯世间的上上之心。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581837459",
    "length": 40
  },
  {
    "id": 5074,
    "uuid": "74a40ed4-bae1-411e-92e5-438c4df1dbf1",
    "hitokoto": "看破了自己才算看破红尘",
    "type": "e",
    "from": "珂朵莉诺塔瑟尼欧里斯",
    "from_who": null,
    "creator": "珂朵莉诺塔瑟尼欧里斯",
    "creator_uid": 4939,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1581830631",
    "length": 11
  },
  {
    "id": 5079,
    "uuid": "774478ff-4257-4ff5-98d1-afc9c4a4eed1",
    "hitokoto": "我知道，时间也许会把我们分开。因此，我把你装进了我的心中。这样，我就无惧时间的洗礼了。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582099522",
    "length": 43
  },
  {
    "id": 5102,
    "uuid": "90d49934-9de5-4a21-92f2-d4808b808b42",
    "hitokoto": "记忆不是我的延续。精神才是。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582099103",
    "length": 14
  },
  {
    "id": 5125,
    "uuid": "7ee4f7be-c3af-4a51-8e11-a8a2caff496d",
    "hitokoto": "一定要像小孩子一样爱笑，眼睛一定要闪着不谙世事的光。",
    "type": "e",
    "from": "致她",
    "from_who": null,
    "creator": "童年往事",
    "creator_uid": 4648,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578992080",
    "length": 26
  },
  {
    "id": 5126,
    "uuid": "601354c8-18f7-4da1-9d12-1974be406d7f",
    "hitokoto": "打雷时你想到的是要下雨还是她害怕。",
    "type": "e",
    "from": "签名",
    "from_who": null,
    "creator": "童年往事",
    "creator_uid": 4648,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1578992019",
    "length": 17
  },
  {
    "id": 5130,
    "uuid": "9b5a0159-6b4f-44ac-a43b-0bad2778d34f",
    "hitokoto": "与恶龙相斗的少年终将成为恶龙？不过是因为他在打败恶龙前没有找到存在恶龙的缘由罢了。",
    "type": "e",
    "from": "pokon548",
    "from_who": null,
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1582100942",
    "length": 41
  },
  {
    "id": 5148,
    "uuid": "86380b6d-fccb-4cff-9f5c-5350a98b09cd",
    "hitokoto": "满天繁星思绪起，一言一诺只为你。",
    "type": "e",
    "from": "fine",
    "from_who": null,
    "creator": "ƒine",
    "creator_uid": 4433,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1575717614",
    "length": 16
  },
  {
    "id": 5159,
    "uuid": "c5255f92-d998-42c2-bea8-b63ce98b78e7",
    "hitokoto": "其实一个人单身久了，你就会慢慢地发现你根本不适合谈恋爱，更不适合结婚，你只适合工作和赚钱，赚钱能治愈一切矫情，有钱能治愈一切自卑。",
    "type": "e",
    "from": "厌猫",
    "from_who": null,
    "creator": "厌猫",
    "creator_uid": 5103,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1582787881",
    "length": 65
  },
  {
    "id": 5163,
    "uuid": "f594044d-aa3d-4cf7-818d-bf0c89de76e7",
    "hitokoto": "好多烦恼是你错觉以为你空有一身抱负的怀才不遇，其实更多真相是给你机会你却胸无点墨的后悔不已。",
    "type": "e",
    "from": "了一理",
    "from_who": null,
    "creator": "了一理",
    "creator_uid": 5122,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1582860471",
    "length": 46
  },
  {
    "id": 5174,
    "uuid": "3fb50c98-73d6-41a6-be19-321ba6bda287",
    "hitokoto": "你回头，我就在身后。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "Honerc",
    "creator_uid": 5151,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1582984752",
    "length": 10
  },
  {
    "id": 5175,
    "uuid": "044160df-8426-430c-852a-84bbd62807c1",
    "hitokoto": "城市夜空的灯光太过明亮，以至于我曾一度怀疑，我所存在的世界，是否真的有月亮。",
    "type": "e",
    "from": "原创",
    "from_who": "寒慕夜泽",
    "creator": "寒慕夜泽",
    "creator_uid": 5161,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583028598",
    "length": 38
  },
  {
    "id": 5189,
    "uuid": "aed41cf0-c9c5-42dc-b87d-f283e7f30d81",
    "hitokoto": "片是落叶处，一切尽萧然。",
    "type": "e",
    "from": "方树",
    "from_who": null,
    "creator": "方回",
    "creator_uid": 5185,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583141209",
    "length": 12
  },
  {
    "id": 5190,
    "uuid": "226a5499-7ef4-44ea-9750-06c338d2faab",
    "hitokoto": "从今以后，你走你的路，我演我的戏。",
    "type": "e",
    "from": "宋锦瑟",
    "from_who": null,
    "creator": "宋锦瑟",
    "creator_uid": 5194,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583160711",
    "length": 17
  },
  {
    "id": 5201,
    "uuid": "64d05f29-2aee-499d-bb14-ea4848778040",
    "hitokoto": "一言，一思，一走，一生。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "追风寻雨",
    "creator_uid": 5083,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583221989",
    "length": 12
  },
  {
    "id": 5205,
    "uuid": "6e9ede12-6ae5-4a83-89d9-a1c58ac27cdc",
    "hitokoto": "如果不愿意从梦里醒过来，那就一直沉溺下去；反正现实里，地狱的景象附拾皆是，还不如一个好梦……",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "夏遇星",
    "creator_uid": 5224,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1583310789",
    "length": 46
  },
  {
    "id": 5214,
    "uuid": "aa7b8982-16c0-4ced-9848-c82a9f818090",
    "hitokoto": "时间，捉摸不透。",
    "type": "e",
    "from": "GoodChing",
    "from_who": null,
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583453343",
    "length": 8
  },
  {
    "id": 5215,
    "uuid": "7acb6f86-c2db-4b4b-a931-d4fa12a194dc",
    "hitokoto": "意境，如水一空。",
    "type": "e",
    "from": "GoodChing",
    "from_who": null,
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583453675",
    "length": 8
  },
  {
    "id": 5220,
    "uuid": "37beea93-3d06-421c-a5a8-62a87656e4a7",
    "hitokoto": "乱风错错卷卷云散散八千里。",
    "type": "e",
    "from": "无",
    "from_who": "无名氏",
    "creator": "无名氏",
    "creator_uid": 5265,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583493716",
    "length": 13
  },
  {
    "id": 5221,
    "uuid": "e8421802-8dba-43d3-a4a4-842f5338f0c5",
    "hitokoto": "纵观世界无非就两件事最火：断章取义和美名其曰。",
    "type": "e",
    "from": "无",
    "from_who": "无名氏",
    "creator": "无名氏",
    "creator_uid": 5265,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583499518",
    "length": 23
  },
  {
    "id": 5226,
    "uuid": "830b7fb7-49f8-4bda-b061-379223677d54",
    "hitokoto": "光，火交错，诞生了夕阳。",
    "type": "e",
    "from": "无",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1583718511",
    "length": 12
  },
  {
    "id": 5274,
    "uuid": "ac2f4dde-be27-4ccd-9ac1-e510b19cdbd1",
    "hitokoto": "脚步声的急促是我想见你的预示。",
    "type": "e",
    "from": "原创",
    "from_who": "Zlemon",
    "creator": "zlemon",
    "creator_uid": 5405,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584147688",
    "length": 15
  },
  {
    "id": 5276,
    "uuid": "fc83fef2-5249-498f-bae8-517d7220e528",
    "hitokoto": "生活如叶，重重叠叠，只如毡般消逝在林间。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1584316146",
    "length": 20
  },
  {
    "id": 5292,
    "uuid": "65d5aea7-ca83-45bf-b8ea-b4d0a21d8c6c",
    "hitokoto": "弱小不是逃避的借口，应是竭尽全力的理由。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "白玉楼的白麻薯",
    "creator_uid": 5325,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1583821308",
    "length": 20
  },
  {
    "id": 5296,
    "uuid": "ecf19550-7614-41e6-9b36-b062c26d05c2",
    "hitokoto": "有些人的温柔，不过是骨子里的卑微。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "宋锦瑟",
    "creator_uid": 5194,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1584231098",
    "length": 17
  },
  {
    "id": 5306,
    "uuid": "a0ed3158-c41f-40d2-8674-e7cd1c9eca87",
    "hitokoto": "我真的很想喜欢你们，可是你们没有人喜欢我。",
    "type": "e",
    "from": "梨子",
    "from_who": null,
    "creator": "Ali",
    "creator_uid": 3642,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1584789926",
    "length": 21
  },
  {
    "id": 5315,
    "uuid": "331a4c99-2556-45ea-819d-335963d26849",
    "hitokoto": "大千世界，仙女万千。踏足于世界，被迷的沦陷。恨不得多长几眼，一眼千遍。",
    "type": "e",
    "from": "fishfish",
    "from_who": "鱼鱼",
    "creator": "fish_fishq",
    "creator_uid": 5610,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585099961",
    "length": 35
  },
  {
    "id": 5316,
    "uuid": "1f5a54f6-4337-4d65-bb56-fea48de3f93c",
    "hitokoto": "我喜欢热闹，但并不拒绝孤独。",
    "type": "e",
    "from": "原创",
    "from_who": "莽红尘觅知嘤",
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585100333",
    "length": 14
  },
  {
    "id": 5325,
    "uuid": "4a5ce569-02eb-4547-970a-1a0cc7209d8a",
    "hitokoto": "雨，打湿了窗，打湿了行人，打湿了梦境。",
    "type": "e",
    "from": "无",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585227232",
    "length": 19
  },
  {
    "id": 5327,
    "uuid": "1d955fb9-5fa7-491e-bddd-7a6f7a067f3a",
    "hitokoto": "夜空像撒了葡萄酒的甜。诗人在街头晃着酒瓶醉。手里的诗也撕碎成星光。",
    "type": "e",
    "from": "原创",
    "from_who": "夙鱼",
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585366306",
    "length": 33
  },
  {
    "id": 5328,
    "uuid": "a2ea288b-0c66-41be-8172-e6c3c715b2b3",
    "hitokoto": "一举一动牵吾魂，一言一语勾吾思。",
    "type": "e",
    "from": "只是",
    "from_who": "只是",
    "creator": "只是",
    "creator_uid": 5542,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584693381",
    "length": 16
  },
  {
    "id": 5333,
    "uuid": "e5e4666d-9a5e-4838-954e-2f01b1f34775",
    "hitokoto": "别让生活蹂躏了你眉间的温柔。",
    "type": "e",
    "from": "生活",
    "from_who": "结局",
    "creator": "不负遇见",
    "creator_uid": 5551,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584714896",
    "length": 14
  },
  {
    "id": 5335,
    "uuid": "4e45a183-e440-4a14-88a2-a52fc0fb43b0",
    "hitokoto": "其实你不是真的很有趣，你只是太孤独。这个你，就是我。",
    "type": "e",
    "from": "食不知味",
    "from_who": "食不知味",
    "creator": "食不知味",
    "creator_uid": 5581,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1584945886",
    "length": 26
  },
  {
    "id": 5351,
    "uuid": "22020007-43fe-4df4-a9d6-0976b29c65d0",
    "hitokoto": "望不穿那海底突然跌落的暗与无穷。",
    "type": "e",
    "from": "原创",
    "from_who": "夙鱼",
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585366231",
    "length": 16
  },
  {
    "id": 5352,
    "uuid": "f7e6db82-12e2-4c1b-acf5-d5f4beb49d46",
    "hitokoto": "为了能体面地死去而狼狈地活着。",
    "type": "e",
    "from": "原创",
    "from_who": "夙鱼",
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585366452",
    "length": 15
  },
  {
    "id": 5353,
    "uuid": "95991a54-4628-44a7-ab12-408c29e886db",
    "hitokoto": "入夜随孤灯等昙花开。",
    "type": "e",
    "from": "原创",
    "from_who": "夙鱼",
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585366479",
    "length": 10
  },
  {
    "id": 5360,
    "uuid": "d02b66ae-61d5-4b0c-a307-0bc1cc1eb8e7",
    "hitokoto": "一场秋雨一场凉，秋心酌满泪为霜。",
    "type": "e",
    "from": "原创",
    "from_who": "夙鱼",
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585366524",
    "length": 16
  },
  {
    "id": 5364,
    "uuid": "c665a6ec-86a7-4443-96de-8ab1ead415cc",
    "hitokoto": "雾都伦敦的浪漫，是迷雾之下珍藏的一缕阳光。",
    "type": "e",
    "from": "原创",
    "from_who": "夙鱼",
    "creator": "ash",
    "creator_uid": 5670,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585366598",
    "length": 21
  },
  {
    "id": 5365,
    "uuid": "36ddd370-aa9c-409c-badc-f8b10cf62ad5",
    "hitokoto": "过俗世的生活，做通天的梦，手不能触及的，心可以直达。",
    "type": "e",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585421873",
    "length": 26
  },
  {
    "id": 5367,
    "uuid": "91dd51db-5af5-484f-8719-006e9a06ef43",
    "hitokoto": "你会不会在某一个瞬间想起我，哪怕，一瞬间。",
    "type": "e",
    "from": "原创",
    "from_who": "Qicloud",
    "creator": "Qicloud",
    "creator_uid": 4635,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585493213",
    "length": 21
  },
  {
    "id": 5368,
    "uuid": "fec66eab-ccfc-43b7-bb29-adbcd58e7dc2",
    "hitokoto": "可能我表述的太过明显，毕竟梦里常出现你的脸，他一遍一遍让我反复失眠，但这都不是重点，无解的是 很多话我已藏了大半年。",
    "type": "e",
    "from": "原创",
    "from_who": "Qicloud",
    "creator": "Qicloud",
    "creator_uid": 4635,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585493324",
    "length": 58
  },
  {
    "id": 5369,
    "uuid": "8d81788d-3e33-454c-8726-0a9cf55cba9f",
    "hitokoto": "许久未见的朋友，定会在梦里，有一次无需言语的交流。",
    "type": "e",
    "from": "原创",
    "from_who": "JiujiuYu",
    "creator": "JiujiuYu",
    "creator_uid": 5675,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585406898",
    "length": 25
  },
  {
    "id": 5374,
    "uuid": "7f368386-816d-424a-8acb-30d8dbb73b83",
    "hitokoto": "是，你是这个世界的人，但同时你要相信你创造的世界也是存在的。",
    "type": "e",
    "from": "bia",
    "from_who": null,
    "creator": "bia",
    "creator_uid": 5687,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585474898",
    "length": 30
  },
  {
    "id": 5375,
    "uuid": "8d742dd4-e975-4be4-8323-9115c3256344",
    "hitokoto": "输了你，赢了这个世界也没意义。",
    "type": "e",
    "from": "原创",
    "from_who": "Qicloud",
    "creator": "Qicloud",
    "creator_uid": 4635,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585493095",
    "length": 15
  },
  {
    "id": 5376,
    "uuid": "cf741332-de25-4e8d-a074-9f6a1c805bfe",
    "hitokoto": "始终弄不明白，合适和喜欢哪个更重要。",
    "type": "e",
    "from": "原创",
    "from_who": "Qicloud",
    "creator": "Qicloud",
    "creator_uid": 4635,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585493189",
    "length": 18
  },
  {
    "id": 5379,
    "uuid": "611ac7af-07ce-4442-ab86-31888f8848bf",
    "hitokoto": "明明就是喜欢，失去了才痛心，你在胆怯什么啊喂？",
    "type": "e",
    "from": "原创",
    "from_who": "流光印记",
    "creator": "流光印记",
    "creator_uid": 5586,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1585051654",
    "length": 23
  },
  {
    "id": 5400,
    "uuid": "06910e7f-0cfd-4943-9e61-9689007667a0",
    "hitokoto": "电影结束的那一刻，灯光逐渐升起。走在情侣之间，想起当时的我和你；只可惜，我们没有坚持到底。",
    "type": "e",
    "from": "原创",
    "from_who": "Qicloud",
    "creator": "Qicloud",
    "creator_uid": 4635,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585493233",
    "length": 45
  },
  {
    "id": 5401,
    "uuid": "05f9f9b1-a685-422c-bf6b-4bd4f0a08258",
    "hitokoto": "去你的城市，路过你熟悉的街，吃你以前常对我讲的街角的那家小吃，坐在图书馆的楼梯上，一个像极你的背影。路过，边上那人，叫着曾经熟悉的名字，我知道我该回家了。",
    "type": "e",
    "from": "原创",
    "from_who": "橘子味的泡菜",
    "creator": "Qicloud",
    "creator_uid": 4635,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585493276",
    "length": 77
  },
  {
    "id": 5402,
    "uuid": "ef15c2ad-8c48-40b1-af0a-2e9466a74e3a",
    "hitokoto": "这个世界并没有变坏，只是人们自己的心、坏了。",
    "type": "e",
    "from": "原创",
    "from_who": "Qicloud",
    "creator": "Qicloud",
    "creator_uid": 4635,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585493564",
    "length": 22
  },
  {
    "id": 5405,
    "uuid": "08734689-6d3f-45b9-932a-dfa09e7ff84c",
    "hitokoto": "记忆付诸生命之时，时间亦将付诸生命。",
    "type": "e",
    "from": "原创",
    "from_who": "JLD",
    "creator": "JLD",
    "creator_uid": 5130,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1585621186",
    "length": 18
  },
  {
    "id": 5410,
    "uuid": "8bba9c44-a11d-4d62-ba00-6425b61932d4",
    "hitokoto": "既然长相忘，谁知来时路。",
    "type": "e",
    "from": "斫琴赴长顾",
    "from_who": "斫琴赴长顾",
    "creator": "斫琴赴长顾",
    "creator_uid": 5705,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585620170",
    "length": 12
  },
  {
    "id": 5420,
    "uuid": "ecfaaba3-f5ea-4155-a611-1a90b2ce49f6",
    "hitokoto": "大气的人不会因为这点小事来和你生气。",
    "type": "e",
    "from": "绮梦",
    "from_who": null,
    "creator": "Soiltary、K",
    "creator_uid": 3915,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1585672995",
    "length": 18
  },
  {
    "id": 5429,
    "uuid": "74c1c8db-bb76-4ad8-9294-252135193fae",
    "hitokoto": "微笑着挥手再见，但内心却却深知，以后不会再相见。",
    "type": "e",
    "from": "忆梦小站",
    "from_who": "何叶",
    "creator": "何叶",
    "creator_uid": 5724,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1585669067",
    "length": 24
  },
  {
    "id": 5948,
    "uuid": "f28d0d0b-21db-4bfc-abb3-9ee7ec680ae4",
    "hitokoto": "想不完的思念，道不尽的话。",
    "type": "e",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586610324",
    "length": 13
  },
  {
    "id": 5955,
    "uuid": "284b2051-50c1-46a5-8d92-52b201867a74",
    "hitokoto": "我喜新厌旧得厉害，而你是个例外，其他的我从不专一。",
    "type": "e",
    "from": "原创",
    "from_who": "D.I.E.玩家·K",
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586776765",
    "length": 25
  },
  {
    "id": 5958,
    "uuid": "737d46c2-62c0-4e49-9c56-e679aae3fb12",
    "hitokoto": "请热爱这个世界，哪怕它是冷的；请保持一颗火热的心，因为我们脚下的星球，她的心也是“热”的。",
    "type": "e",
    "from": "kirisa",
    "from_who": "kirisa",
    "creator": "kirisa",
    "creator_uid": 5872,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586740388",
    "length": 45
  },
  {
    "id": 5959,
    "uuid": "1e511678-173e-46b7-9474-c5bbd6fd83ff",
    "hitokoto": "希望各位程序员能保持当初第一次输出hello world的兴奋，每条代码都有它存在的意义，不要被社会打倒。指不定哪天你就改变世界了。",
    "type": "e",
    "from": "一名苦逼程序员",
    "from_who": "Lo1i",
    "creator": "Lo1i",
    "creator_uid": 2610,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1586755449",
    "length": 66
  },
  {
    "id": 5971,
    "uuid": "d04f0c6a-65bb-47b4-b279-f61ac4e63a92",
    "hitokoto": "给你的努力一个交代，挥出已经紧握在双拳中的梦想。",
    "type": "e",
    "from": "原创",
    "from_who": "柠檬盐",
    "creator": "柠檬盐",
    "creator_uid": 5984,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587437012",
    "length": 24
  },
  {
    "id": 5975,
    "uuid": "0e8a57ae-fb35-4a96-9819-0bf6c72b45a9",
    "hitokoto": "我已经过了会脸红的年纪。",
    "type": "e",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1587643310",
    "length": 12
  },
  {
    "id": 5976,
    "uuid": "1ce81a72-5917-4081-8c91-56e736cc1786",
    "hitokoto": "眼泪不能洗去痛苦，但岁月足以抹去一切。",
    "type": "e",
    "from": "原创",
    "from_who": "希铁石z",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1588064435",
    "length": 19
  },
  {
    "id": 5977,
    "uuid": "6fbb8815-c9a1-4d4e-ace5-e6bbd38b8a26",
    "hitokoto": "不是我熬夜，是黑夜需要我这颗璀璨明亮的星。",
    "type": "e",
    "from": "原创",
    "from_who": "希铁石z",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1588064353",
    "length": 21
  },
  {
    "id": 5978,
    "uuid": "183ce7bc-722d-4055-8b89-0a459bd4fc94",
    "hitokoto": "我们都是游离于这个时代之外的人，我们永远无法理解别人。",
    "type": "e",
    "from": "原创",
    "from_who": "希铁石z",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1588064399",
    "length": 27
  },
  {
    "id": 5983,
    "uuid": "a857a1b4-cb76-4d43-a6a2-cfe44e678534",
    "hitokoto": "不管什么天气，记得随时带上自己的阳光；不管什么遭遇，记得内心装满开心的童话。",
    "type": "e",
    "from": "契约千魂",
    "from_who": "契约千魂",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341341",
    "length": 38
  },
  {
    "id": 5984,
    "uuid": "02ebeee4-22be-4d78-a582-c68d9982a5e6",
    "hitokoto": "每天都是新的一天，有好运比什么都强。",
    "type": "e",
    "from": "契约千魂",
    "from_who": "契约千魂",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341364",
    "length": 18
  },
  {
    "id": 5985,
    "uuid": "f0834b74-ccb6-46b8-8dbc-4b922d892aa2",
    "hitokoto": "我们终究还是走散了。",
    "type": "e",
    "from": "契约千魂",
    "from_who": "契约千魂",
    "creator": "契约",
    "creator_uid": 5584,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586341514",
    "length": 10
  },
  {
    "id": 6005,
    "uuid": "88fa6905-2494-4d0e-9dd3-976e1160788d",
    "hitokoto": "脸皮要是能厚一些就好了，这样就不会再因为生活中的这些破事而哭泣了，让那些狗屁情绪都见鬼去吧。",
    "type": "e",
    "from": "2020年4月10日，原创",
    "from_who": "刘占涛",
    "creator": "lzt",
    "creator_uid": 5623,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586501554",
    "length": 46
  },
  {
    "id": 6009,
    "uuid": "bbb84534-33a3-4e1a-b1bf-86142e0e649b",
    "hitokoto": "对于事情的预期越低，失败的时候越不伤心，成功的时候就越快乐。",
    "type": "e",
    "from": "原创",
    "from_who": "TPSET",
    "creator": "TPSET",
    "creator_uid": 5857,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586605984",
    "length": 30
  },
  {
    "id": 6010,
    "uuid": "fb18a153-411c-4b02-b1c4-5d735e48ee7d",
    "hitokoto": "人生，自在意，得其乐。",
    "type": "e",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586610137",
    "length": 11
  },
  {
    "id": 6011,
    "uuid": "3fe36a51-886e-40c2-8c42-9cdfe6d50748",
    "hitokoto": "如果人生结束，连遗言都没有，会不会太可惜。",
    "type": "e",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586610194",
    "length": 21
  },
  {
    "id": 6012,
    "uuid": "54dd8c50-4cff-4880-9954-e68b75315314",
    "hitokoto": "我抱着你，就像抱着一枝柔弱的花骨朵，让我深深的感受到你是多么的无助。",
    "type": "e",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1586610274",
    "length": 34
  },
  {
    "id": 6028,
    "uuid": "9ccf7609-3da8-4448-9a34-efa45b46c2b5",
    "hitokoto": "我重新活了千百遍，深爱过也失去了，可当我再次见到你，枯骨里生出花。",
    "type": "e",
    "from": "原创",
    "from_who": "D.I.E.玩家·K",
    "creator": "Npc玩家柯拉",
    "creator_uid": 5658,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1586939701",
    "length": 33
  },
  {
    "id": 6050,
    "uuid": "78a3bde8-582f-484c-bc0d-2b869cef5f56",
    "hitokoto": "梦醒人终散，缘尽情已空。",
    "type": "e",
    "from": "原创",
    "from_who": "幻梦琉影",
    "creator": "幻梦琉影",
    "creator_uid": 6001,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587537956",
    "length": 12
  },
  {
    "id": 6055,
    "uuid": "6af7d400-2c5b-4465-b96c-cbca5d5d4ee0",
    "hitokoto": "你如果認識以前的我，也許你會原諒現在的我。",
    "type": "e",
    "from": "原创",
    "from_who": "Hasty",
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587650012",
    "length": 21
  },
  {
    "id": 6057,
    "uuid": "113b9c0f-0633-42f6-8c17-2518e08cf990",
    "hitokoto": "我真想拉起你的手，逃向初晴的天空和田野，不畏縮也不回顧。",
    "type": "e",
    "from": "原创",
    "from_who": "Hasty",
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587650246",
    "length": 28
  },
  {
    "id": 6058,
    "uuid": "0c51aaa1-32eb-4611-a199-cea54d75a1f9",
    "hitokoto": "風可以決定樹的方向，而你可以決定自己的方向。",
    "type": "e",
    "from": "原创",
    "from_who": "Hasty",
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587650289",
    "length": 22
  },
  {
    "id": 6061,
    "uuid": "1e8eaef1-ece8-4e59-9a1f-a6330adb4e39",
    "hitokoto": "我们明知光明无法永恒，但是我们却始终追寻着，因此我们度过了黑夜。",
    "type": "e",
    "from": "原创",
    "from_who": "此店不售此书",
    "creator": "此店不售此书",
    "creator_uid": 6005,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587817595",
    "length": 32
  },
  {
    "id": 6062,
    "uuid": "31ae7a55-941d-4ee2-84fa-db1574ce9b5f",
    "hitokoto": "真正引领我们成功的，并非是我们曾经和现在拥有什么，而是我们对于未来的希望！",
    "type": "e",
    "from": "原创",
    "from_who": "此店不售此书",
    "creator": "此店不售此书",
    "creator_uid": 6005,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1587817644",
    "length": 37
  },
  {
    "id": 6066,
    "uuid": "3d1ba2fa-1d63-4944-b142-3bdefbd1f3f8",
    "hitokoto": "悲痛藏于心，欢喜言于表。说的不就是我们吗！",
    "type": "e",
    "from": "原创",
    "from_who": "白凝羽",
    "creator": "白凝羽",
    "creator_uid": 6045,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1587881022",
    "length": 21
  },
  {
    "id": 6069,
    "uuid": "ce4e077a-98bd-4fae-a0a6-76da5c60f3a6",
    "hitokoto": "过去的不再回来，回来的不再美好。",
    "type": "e",
    "from": "原创",
    "from_who": "窃格瓦斯·凡",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588063142",
    "length": 16
  },
  {
    "id": 6072,
    "uuid": "4353d678-062b-4cac-8ee5-e00fadbbb079",
    "hitokoto": "我们通常把自己做的傻事称为“命运”。",
    "type": "e",
    "from": "原创",
    "from_who": "凡ICE",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588063834",
    "length": 18
  },
  {
    "id": 6073,
    "uuid": "958a78cc-eca1-4f56-b441-7d1a2ba09ea4",
    "hitokoto": "站起来吧孩子，没人会看见倒下的人。",
    "type": "e",
    "from": "原创",
    "from_who": "凡ICE",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588063891",
    "length": 17
  },
  {
    "id": 6074,
    "uuid": "cd6879b1-3338-40c0-a583-61eb9eff9ff6",
    "hitokoto": "勇气就是明知会受伤，却还要这样做，愚蠢也是如此。",
    "type": "e",
    "from": "原创",
    "from_who": "凡ICE",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588063934",
    "length": 24
  },
  {
    "id": 6075,
    "uuid": "e414dace-6a25-47b5-83f1-2401a0280429",
    "hitokoto": "某些人喜好名利是“好大喜功”，某些人喜好名利是“人之常情”。",
    "type": "e",
    "from": "原创",
    "from_who": "希铁石z",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588063996",
    "length": 30
  },
  {
    "id": 6081,
    "uuid": "5252b547-e829-48c0-b82e-830e056dbf2c",
    "hitokoto": "何必怕鬼，折磨你的永远是人。何必怕死，折磨你的永远是生。",
    "type": "e",
    "from": "原创",
    "from_who": "希铁石z",
    "creator": "希铁石",
    "creator_uid": 5496,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588064304",
    "length": 28
  },
  {
    "id": 6082,
    "uuid": "3d21e4ed-a2a1-46e4-9a57-2b7be6ab796f",
    "hitokoto": "社会是个就像个机床，人就像块没有加工过的铁。",
    "type": "e",
    "from": "原创",
    "from_who": "小忧忧",
    "creator": "小忧忧",
    "creator_uid": 4701,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588228034",
    "length": 22
  },
  {
    "id": 6083,
    "uuid": "83bbbc1e-8f9a-444f-a7ad-7b5236fe35f0",
    "hitokoto": "往回首。即使那些不悦的，厌恶的，也化作尘埃，随风而去。",
    "type": "e",
    "from": "原创",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588240790",
    "length": 27
  },
  {
    "id": 6084,
    "uuid": "01a897ed-93fc-46f0-a34e-a60ef60ca26e",
    "hitokoto": "人生路上，岔路口。如何走？自己的路。",
    "type": "e",
    "from": "原创",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588240944",
    "length": 18
  },
  {
    "id": 6087,
    "uuid": "4a578d8b-3aa4-45c7-ad0e-4e5b2db7400e",
    "hitokoto": "执着与进退？这是个问题。",
    "type": "e",
    "from": "原创",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588331097",
    "length": 12
  },
  {
    "id": 6098,
    "uuid": "898db02a-f4f0-4be8-8bde-6c276f65d161",
    "hitokoto": "不会去爱，那就别爱，天有注定，缘也会散。",
    "type": "e",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590138682",
    "length": 20
  },
  {
    "id": 6112,
    "uuid": "1ff99d94-4529-4ae1-98f1-89b4d968d5ba",
    "hitokoto": "他们的人生本该是充满希望，而不是在深渊的泥潭里绝望的打滚。",
    "type": "e",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588553889",
    "length": 29
  },
  {
    "id": 6113,
    "uuid": "6dcaffe9-6536-4c86-b5a8-20522d0d9c29",
    "hitokoto": "星河浩瀚，万人争渡。",
    "type": "e",
    "from": "梦中",
    "from_who": "流光印记",
    "creator": "流光印记",
    "creator_uid": 5586,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1588568255",
    "length": 10
  },
  {
    "id": 6124,
    "uuid": "21bf901c-2205-4d99-895c-fca2e437b493",
    "hitokoto": "当某人某事突然出现一群黑子，要么是做的太好遭人嫉妒，要么是做的太坏遭人厌恶。",
    "type": "e",
    "from": "原创",
    "from_who": "茗莠",
    "creator": "茗莠",
    "creator_uid": 2993,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588745787",
    "length": 38
  },
  {
    "id": 6129,
    "uuid": "b0ed9c44-990e-4e67-9080-4dad0002ee47",
    "hitokoto": "长的不好看，优点也不多，梦想很平凡，如果说我喜欢你，你可不可以、不要笑我。",
    "type": "e",
    "from": "原创",
    "from_who": "魂爷",
    "creator": "凡为过往，皆为序章",
    "creator_uid": 4914,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1588817723",
    "length": 37
  },
  {
    "id": 6133,
    "uuid": "500ff3d9-951f-4c19-9cbd-dd0d01b70d30",
    "hitokoto": "无眠之夜黑混沌，她忘点灯昏红阵。",
    "type": "e",
    "from": "混沌点阵",
    "from_who": "Awoluua_",
    "creator": "Awoluua_",
    "creator_uid": 6258,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591403463",
    "length": 16
  },
  {
    "id": 6134,
    "uuid": "87fd3e5e-c359-4ae4-a6a2-d3d26cd9efdf",
    "hitokoto": "灰尽暗夜燎前线，烟起迷雾挂蓝巾。",
    "type": "e",
    "from": "前线迷雾",
    "from_who": "Awoluua_",
    "creator": "Awoluua_",
    "creator_uid": 6258,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591403490",
    "length": 16
  },
  {
    "id": 6142,
    "uuid": "6c94d2b0-b707-430d-861d-b0111a9ea974",
    "hitokoto": "她着红衣丝千里，天铺巨网罩深红。",
    "type": "e",
    "from": "深红之网",
    "from_who": "Awoluua_",
    "creator": "Awoluua_",
    "creator_uid": 6258,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591403527",
    "length": 16
  },
  {
    "id": 6143,
    "uuid": "d5ea6722-a141-407d-994e-fcf9154c8485",
    "hitokoto": "我喜欢同性的可能性只有百分之一，而你就是那百分之一，也是我的唯一。",
    "type": "e",
    "from": "一叶知秋",
    "from_who": "残灯晓霜",
    "creator": "残灯晓霜",
    "creator_uid": 6140,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589003693",
    "length": 33
  },
  {
    "id": 6144,
    "uuid": "cd3b8d01-6d2b-4c4d-a313-8bf9ac1a2819",
    "hitokoto": "虽然我的心脏停止跳动了，但它不会停止爱你。",
    "type": "e",
    "from": "我死了",
    "from_who": "残灯晓霜",
    "creator": "残灯晓霜",
    "creator_uid": 6140,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589004130",
    "length": 21
  },
  {
    "id": 6145,
    "uuid": "21560587-c4f5-4347-a760-8dab1b1d755a",
    "hitokoto": "当你面临死亡时，当你参加亲人葬礼的时候，当你看到无数的死亡时，你会真真切切地领悟它，看透它。最后化为四个字：即死领悟。",
    "type": "e",
    "from": "原创",
    "from_who": "石夜道转",
    "creator": "流木却邪",
    "creator_uid": 5700,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589034169",
    "length": 59
  },
  {
    "id": 6146,
    "uuid": "fe98f3da-3ff1-4fce-ba90-9e8eb0bd1cdd",
    "hitokoto": "我披上了一层世俗的外衣，只为珍藏那份唯有你能揭开的纯真。回首，我依然是那个在阳光下奔跑的少年。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589078510",
    "length": 47
  },
  {
    "id": 6149,
    "uuid": "32c6a220-8231-4a0b-ae3d-dcd65eb40051",
    "hitokoto": "心比顽石，药师无益，心若水泊，浮萍无存。",
    "type": "e",
    "from": "原创",
    "from_who": "可",
    "creator": "可",
    "creator_uid": 6195,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589272933",
    "length": 20
  },
  {
    "id": 6151,
    "uuid": "2c61063d-5f62-4a1e-8037-9115c0a5f05f",
    "hitokoto": "嘴上说着考名校，手里打着游戏，你是在和谁开玩笑。",
    "type": "e",
    "from": "原创",
    "from_who": "边妤仙",
    "creator": "边妤仙",
    "creator_uid": 6204,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589346050",
    "length": 24
  },
  {
    "id": 6152,
    "uuid": "41d21f63-6bfe-414b-9de4-c96bca493c49",
    "hitokoto": "不要想，去感受。",
    "type": "e",
    "from": "原创",
    "from_who": "边妤仙",
    "creator": "边妤仙",
    "creator_uid": 6204,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589346243",
    "length": 8
  },
  {
    "id": 6153,
    "uuid": "8a259e33-2069-4e1c-b056-f6d0d91dc163",
    "hitokoto": "趁现在吧，一点一点，重新来过。",
    "type": "e",
    "from": "原创",
    "from_who": "边妤仙",
    "creator": "边妤仙",
    "creator_uid": 6204,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589346366",
    "length": 15
  },
  {
    "id": 6154,
    "uuid": "0de5b911-6ae7-46ef-bfe9-91d94f8196ac",
    "hitokoto": "不要随便找个参照物就坠落得理所应当。",
    "type": "e",
    "from": "原创",
    "from_who": "边妤仙",
    "creator": "边妤仙",
    "creator_uid": 6204,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589346504",
    "length": 18
  },
  {
    "id": 6155,
    "uuid": "c6239fd3-7279-4155-9e9b-323a76393219",
    "hitokoto": "不用羡慕，你也是太阳。",
    "type": "e",
    "from": "原创",
    "from_who": "边妤仙",
    "creator": "边妤仙",
    "creator_uid": 6204,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589346861",
    "length": 11
  },
  {
    "id": 6159,
    "uuid": "2bc8e7ed-9ee7-475f-8e89-47e86b1e4858",
    "hitokoto": "做生意人站在道德与法律之内，做资本家只要在法律范围内即可。",
    "type": "e",
    "from": "原创",
    "from_who": "茗莠",
    "creator": "茗莠",
    "creator_uid": 2993,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589434958",
    "length": 29
  },
  {
    "id": 6165,
    "uuid": "85332196-c873-45ce-b23c-db2336ac8674",
    "hitokoto": "失落至极致，是虚无。",
    "type": "e",
    "from": "原创",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589635005",
    "length": 10
  },
  {
    "id": 6166,
    "uuid": "f19c5697-7994-424e-ab42-910bb68ae603",
    "hitokoto": "无法忘却的，无法留念的，就让它随风去吧。",
    "type": "e",
    "from": "原创",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589635110",
    "length": 20
  },
  {
    "id": 6168,
    "uuid": "b4186e05-78ea-4e6f-bfaa-8c7d091c069f",
    "hitokoto": "如果累，那就停下来，想一想，你在做什么……",
    "type": "e",
    "from": "一颗忙乱的大脑",
    "from_who": "ideng",
    "creator": "ideng",
    "creator_uid": 6229,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589725461",
    "length": 21
  },
  {
    "id": 6169,
    "uuid": "a255cd87-ad8d-4e92-8240-26067347fb0d",
    "hitokoto": "我有一个脑洞，洞里有颗橡树种子，种子已经发芽钻出了头发，如果碰巧你也有一个脑洞，洞里有颗木棉种子，请和我紧握双手，那是我们在相互致意，那是我们的语言，没有人能懂。",
    "type": "e",
    "from": "致敬《致橡树》",
    "from_who": "ideng",
    "creator": "ideng",
    "creator_uid": 6229,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1589726415",
    "length": 81
  },
  {
    "id": 6185,
    "uuid": "ca732780-6636-4caa-8c16-ebd41e03f9dc",
    "hitokoto": "始无弱，盛极衰，和以中之大同。",
    "type": "e",
    "from": "大略",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482093",
    "length": 15
  },
  {
    "id": 6186,
    "uuid": "a64d5c19-3ecb-4e21-95a5-44942fabbd88",
    "hitokoto": "如日中天，群魔乱舞，应臆。",
    "type": "e",
    "from": "大略",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482145",
    "length": 13
  },
  {
    "id": 6187,
    "uuid": "cb4109d5-c8e8-40ce-93b0-2c7cdf2ae127",
    "hitokoto": "不以为然的存在，细品起来会得到意想不到的有趣。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482170",
    "length": 23
  },
  {
    "id": 6188,
    "uuid": "b2e22f7c-934b-4551-b1af-7279c9398df7",
    "hitokoto": "避弊盗利非小人不可为，须纳其弊方承其禾。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482193",
    "length": 20
  },
  {
    "id": 6189,
    "uuid": "20353911-a0d0-4b62-83df-462b1cfbcdcf",
    "hitokoto": "扬帆起航，于舟渡之。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482208",
    "length": 10
  },
  {
    "id": 6190,
    "uuid": "132f7a23-5381-4a59-bf09-2e38c01ea4b5",
    "hitokoto": "需要的不外乎是“路程”，也许能一步到位。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482222",
    "length": 20
  },
  {
    "id": 6191,
    "uuid": "d8d7b264-3229-4522-b89d-893a89420df8",
    "hitokoto": "或许此刻需要“推力”来成长。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482253",
    "length": 14
  },
  {
    "id": 6192,
    "uuid": "46ce206d-7473-4769-a160-ab86516dad21",
    "hitokoto": "静以制动，明以破军。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482275",
    "length": 10
  },
  {
    "id": 6194,
    "uuid": "4ce255f7-7a6f-49fa-9615-b83518ea8632",
    "hitokoto": "冬至子月，证启明兆。倚伏依之。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482313",
    "length": 15
  },
  {
    "id": 6195,
    "uuid": "8adcf1ee-d934-4b4f-bbee-a923eda0a130",
    "hitokoto": "春秋相往犹如似水流年。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482336",
    "length": 11
  },
  {
    "id": 6196,
    "uuid": "ddbd3bb9-fe1f-42f4-92ee-7bb0361d749c",
    "hitokoto": "站在蝼蚁的角度涉观无限大宇宙，是已知宇宙最大的嗔妄。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482351",
    "length": 26
  },
  {
    "id": 6197,
    "uuid": "a0d37c8d-4e2d-4e4e-b682-5b6971524dcf",
    "hitokoto": "醉生梦死才是人生真正追求。",
    "type": "e",
    "from": "乱世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482366",
    "length": 13
  },
  {
    "id": 6198,
    "uuid": "6fb02480-5790-4329-a283-625cbded6faa",
    "hitokoto": "事與願違，安天命乎？",
    "type": "e",
    "from": "乱世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482377",
    "length": 10
  },
  {
    "id": 6199,
    "uuid": "b103264e-474f-41b2-a73d-325fdd30b3b6",
    "hitokoto": "文豪野犬的区别，或许在于浪漫，与非浪漫。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482403",
    "length": 20
  },
  {
    "id": 6200,
    "uuid": "4316372f-f9db-481c-be29-62fc286ac5d3",
    "hitokoto": "持道而修，不可议其。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482437",
    "length": 10
  },
  {
    "id": 6201,
    "uuid": "dfd9c70b-b826-47fb-84a6-1511fdc1dc2c",
    "hitokoto": "所谓豪言壮志，只是为了安慰某刻的自己。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482644",
    "length": 19
  },
  {
    "id": 6202,
    "uuid": "bc326033-2f4c-487a-a28f-147769e5549c",
    "hitokoto": "翻开对你仅有的记忆，然后放大，彻底的覆盖我的脑海。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482655",
    "length": 25
  },
  {
    "id": 6203,
    "uuid": "66fe1343-a490-4bc8-92bc-5a76448ed8e0",
    "hitokoto": "当黄昏时的光照耀在我的脸颊，我就知道夜晚快要来临了。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482666",
    "length": 26
  },
  {
    "id": 6204,
    "uuid": "9d5a04e0-c2d2-4659-a7f7-2767758a6aaf",
    "hitokoto": "给予的希望不要让其轻易破灭。毕竟没到最后，一切都还在进行中。而，结束在什么时刻，谁又说的定。若放弃了，那才是真正结束。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482695",
    "length": 59
  },
  {
    "id": 6205,
    "uuid": "94904be0-9a51-4d0d-879c-91d58e85f0fd",
    "hitokoto": "没有过多的幸运值，就得拥有个坚持不懈的斗志。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482713",
    "length": 22
  },
  {
    "id": 6208,
    "uuid": "b97a9743-aceb-4763-aa79-5f8aae646984",
    "hitokoto": "不要太在意，太在意会开始害怕失去。",
    "type": "e",
    "from": "原创",
    "from_who": "Cherri",
    "creator": "7cherri",
    "creator_uid": 6327,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590772661",
    "length": 17
  },
  {
    "id": 6210,
    "uuid": "bc908f7e-9985-44d3-8234-4e0273e19672",
    "hitokoto": "我不是畏惧风，我只是怕风把沙子吹到我的眼睛里！",
    "type": "e",
    "from": "日常随笔",
    "from_who": "白凝羽",
    "creator": "白凝羽",
    "creator_uid": 6045,
    "reviewer": 1044,
    "commit_from": "app",
    "created_at": "1590722736",
    "length": 23
  },
  {
    "id": 6213,
    "uuid": "a7953b27-54c5-4ed3-88b2-bc359cbd5e11",
    "hitokoto": "因为你在，我不是太阳，而是化作星辰，与你遨游星空。",
    "type": "e",
    "from": "原创",
    "from_who": "若芜芫",
    "creator": "陨星、若芜芫",
    "creator_uid": 6317,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590716277",
    "length": 25
  },
  {
    "id": 6215,
    "uuid": "b842a9c8-1c6c-43be-90fd-1d309d0a52db",
    "hitokoto": "结果需要的是一个开始。没开始说什么都是废话。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590483091",
    "length": 22
  },
  {
    "id": 6216,
    "uuid": "27893c2c-f517-4768-9cfd-af70b43dca5c",
    "hitokoto": "逆而顺之，顺而逆之。",
    "type": "e",
    "from": "大世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590483069",
    "length": 10
  },
  {
    "id": 6217,
    "uuid": "d52ed11f-7ba4-4c50-bfad-3ef1c0b549ac",
    "hitokoto": "非人之学能，非人之能学。",
    "type": "e",
    "from": "大世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590483051",
    "length": 12
  },
  {
    "id": 6218,
    "uuid": "8e556a37-ce4f-431f-b1e0-3a179abc59dd",
    "hitokoto": "黄昏时的天略带有妩媚。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590483082",
    "length": 11
  },
  {
    "id": 6219,
    "uuid": "55feafa7-e693-498d-b4d5-5c16677f0918",
    "hitokoto": "一个人的思想等于一个人的素养。",
    "type": "e",
    "from": "大世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590483025",
    "length": 15
  },
  {
    "id": 6220,
    "uuid": "22b8700a-d01e-43bd-b08e-0b4f1f3f93d2",
    "hitokoto": "也许是把一些事物看太重了，然而失去了才患于恋恋不舍。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590483010",
    "length": 26
  },
  {
    "id": 6221,
    "uuid": "86fe5b12-bc21-41e4-894b-d799a68b1d40",
    "hitokoto": "没有逃不脱的厄难！如果有，那是因为还没找到那合理的理由！",
    "type": "e",
    "from": "乱世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482999",
    "length": 28
  },
  {
    "id": 6222,
    "uuid": "485629a7-cc35-4cbd-9958-b16f35ed3966",
    "hitokoto": "明明是个视观者，却以主角的观念活着！",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482969",
    "length": 18
  },
  {
    "id": 6223,
    "uuid": "12e49a52-6092-4b28-a025-bd00e85eb38e",
    "hitokoto": "一切都将成为过去。 当一切都将成为过去的时候你得到了什么?",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482979",
    "length": 29
  },
  {
    "id": 6224,
    "uuid": "1f635f9f-c398-4c20-a8b1-2713a8b20440",
    "hitokoto": "不肯迈出第一步的人永远学不会走路，也无法体会奔跑的喜悦！",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482928",
    "length": 28
  },
  {
    "id": 6225,
    "uuid": "7becc34a-5959-4518-9f17-2c1fcdd8078e",
    "hitokoto": "知道是一个陷阱的诱惑，但偏偏乐于陷入其中，归根到底还是欲望的作祟！",
    "type": "e",
    "from": "乱世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482864",
    "length": 33
  },
  {
    "id": 6226,
    "uuid": "d93d6463-2741-40b1-af23-623faf89e75f",
    "hitokoto": "别人无法左右你，别人只是帮你决定了你犹豫不决的决定而已！",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482908",
    "length": 28
  },
  {
    "id": 6227,
    "uuid": "d70082b5-8874-4911-8c4f-337de9550106",
    "hitokoto": "心血来潮的时候，总会有那么几人要顿悟的。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482828",
    "length": 20
  },
  {
    "id": 6228,
    "uuid": "526ad96f-92f8-4cb9-85e2-6b4ac9163814",
    "hitokoto": "你在试探的同时，别人亦在试探你。谁也不喜欢被试探，所以何不以诚相待。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482801",
    "length": 34
  },
  {
    "id": 6229,
    "uuid": "a507e5dd-b8a7-4c40-abcd-7c8d213f447f",
    "hitokoto": "思路也仅仅是思路，不能赖于行走。况且也不止于一条。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482791",
    "length": 25
  },
  {
    "id": 6230,
    "uuid": "5f56c7dc-9972-4eb0-abcf-b46df32c43a0",
    "hitokoto": "最好的时间段，莫过于开始的时候。那时候充满了好奇，向往和自约的协议动力，对一切选择来者不拒，但慢慢的发现并非一切的中途都是无害的。虽不知那一段时间是几何，也不管善恶的对象。最后想起了当初，一切的开始都还是美好的。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482814",
    "length": 106
  },
  {
    "id": 6231,
    "uuid": "b9239d8b-c74b-40dd-acb4-04fd321065f9",
    "hitokoto": "放下的过程很难，但是结束的来临很快。",
    "type": "e",
    "from": "小世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482774",
    "length": 18
  },
  {
    "id": 6232,
    "uuid": "5fa16e03-efe6-4513-854c-d794ef8a2a49",
    "hitokoto": "不从善恶意，只遵本心行。",
    "type": "e",
    "from": "安世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482762",
    "length": 12
  },
  {
    "id": 6233,
    "uuid": "ad4c0334-b725-456c-bb1a-d32801783794",
    "hitokoto": "没有信仰的夜晚是充满厄难的白天！",
    "type": "e",
    "from": "乱世",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1590482726",
    "length": 16
  },
  {
    "id": 6234,
    "uuid": "e21c4cae-5494-4740-809d-427fe4700b91",
    "hitokoto": "我与残局皆遗憾，她与大狙皆如梦。",
    "type": "e",
    "from": "浮生如梦",
    "from_who": "Awoluua_",
    "creator": "Awoluua_",
    "creator_uid": 6258,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591403430",
    "length": 16
  },
  {
    "id": 6237,
    "uuid": "5bd117a9-2025-458a-aacc-371d32e9f406",
    "hitokoto": "天下没有不散的宴席，那就放下过去，憧憬未来！",
    "type": "e",
    "from": "灵感",
    "from_who": "姜传江",
    "creator": "茳蓠",
    "creator_uid": 6386,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591333338",
    "length": 22
  },
  {
    "id": 6238,
    "uuid": "a62f7655-39f6-4b4f-b292-4982d4d01c38",
    "hitokoto": "平安喜乐，万事胜意。",
    "type": "e",
    "from": "张喜乐",
    "from_who": null,
    "creator": "张喜乐",
    "creator_uid": 6383,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591320695",
    "length": 10
  },
  {
    "id": 6255,
    "uuid": "5c390c87-79d1-43a3-a512-2140a4fc7a7e",
    "hitokoto": "最后一次听你的，尝试着不去想你。",
    "type": "e",
    "from": "那个她",
    "from_who": null,
    "creator": "attachment",
    "creator_uid": 6474,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592192237",
    "length": 16
  },
  {
    "id": 6268,
    "uuid": "45ede1cc-439c-42c3-9aa1-698288bf6b22",
    "hitokoto": "冢边枯萎之叶，何人知是蔷薇？长守孤冢之旁，芳华逝矣。",
    "type": "e",
    "from": "一言",
    "from_who": "骨戮八千咲",
    "creator": "骨戮八千咲",
    "creator_uid": 6468,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592121240",
    "length": 26
  },
  {
    "id": 6275,
    "uuid": "f6821e26-6ccd-4eda-9afd-97dd6edd5761",
    "hitokoto": "鲁迅：我没说过这句话。",
    "type": "e",
    "from": "网络",
    "from_who": "我是皮皮参",
    "creator": "皮皮参",
    "creator_uid": 6402,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591971289",
    "length": 11
  },
  {
    "id": 6278,
    "uuid": "337e907c-4f5e-40b9-afcf-c68cf6877dd7",
    "hitokoto": "就很犯困很困很困~很忙还是很困！",
    "type": "e",
    "from": "上班",
    "from_who": null,
    "creator": "美美的鱼香肉丝",
    "creator_uid": 6446,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591939257",
    "length": 16
  },
  {
    "id": 6279,
    "uuid": "fe714371-1e51-4cf5-98ea-52a715b76226",
    "hitokoto": "今天的雨很大，你那边下雨了么？",
    "type": "e",
    "from": "生活",
    "from_who": null,
    "creator": "美美的鱼香肉丝",
    "creator_uid": 6446,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1591932316",
    "length": 15
  },
  {
    "id": 6285,
    "uuid": "c4a83f3c-ada4-4067-b614-7fc470f605ae",
    "hitokoto": "风告诉我你在想我，我把思念揉在小溪里，等它化成雨落在你的额头。",
    "type": "e",
    "from": "小语",
    "from_who": "毛巾",
    "creator": "芒果",
    "creator_uid": 6481,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1592302943",
    "length": 31
  },
  {
    "id": 6303,
    "uuid": "c2700f8e-8bee-4c75-b49d-9dadeab3fba5",
    "hitokoto": "转回首，依旧前行。",
    "type": "e",
    "from": "GoodCing",
    "from_who": "GoodCing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593182593",
    "length": 9
  },
  {
    "id": 6307,
    "uuid": "97ef46eb-cc0b-4ac6-a58e-5f345d13e31f",
    "hitokoto": "纵天下几变春秋，我依旧还是我。",
    "type": "e",
    "from": "crazy",
    "from_who": null,
    "creator": "crazy",
    "creator_uid": 6503,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592629806",
    "length": 15
  },
  {
    "id": 6310,
    "uuid": "7d10b019-cf56-4f23-8084-5f05391e5352",
    "hitokoto": "不打扰你的日常，在需要时递上一份力所能及的帮助，在变得不可理喻时会把你好好的收拾一顿。也许这就是所谓的死党吧。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592839438",
    "length": 55
  },
  {
    "id": 6312,
    "uuid": "10c0f549-fa47-4468-a43f-3d85d087b79f",
    "hitokoto": "每天，似乎都一样。",
    "type": "e",
    "from": "原创",
    "from_who": "-小哆啦酱-",
    "creator": "-小哆啦酱-",
    "creator_uid": 6529,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1592907177",
    "length": 9
  },
  {
    "id": 6328,
    "uuid": "277b7416-9cfc-489f-b18f-b8987ab7f339",
    "hitokoto": "别人看见的只有你的光鲜亮丽，他们永远不知道你失去了什么。",
    "type": "e",
    "from": "原创",
    "from_who": "意难藏",
    "creator": "意难藏",
    "creator_uid": 6572,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593251075",
    "length": 28
  },
  {
    "id": 6329,
    "uuid": "32d489cf-be43-475f-b23c-a0abf5da1713",
    "hitokoto": "别人总是以为你什么都有，但你只剩自己了。",
    "type": "e",
    "from": "原创",
    "from_who": "意难藏",
    "creator": "意难藏",
    "creator_uid": 6572,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593251118",
    "length": 20
  },
  {
    "id": 6337,
    "uuid": "eddedf0e-5641-49dd-94bc-8d523ac338aa",
    "hitokoto": "奋斗吧！为了人生，为了梦想，为了自己，也为了你心中的那个ta！",
    "type": "e",
    "from": "原创",
    "from_who": "AST_hong",
    "creator": "AST_hong",
    "creator_uid": 6577,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593265099",
    "length": 31
  },
  {
    "id": 6341,
    "uuid": "98e4427e-c4e8-4132-b040-edc4eff2235b",
    "hitokoto": "明月，被称为明月。只因为它反射了太阳的光芒。而名人，之所以被称为名人，是因为它成为了世界的那颗太阳。",
    "type": "e",
    "from": "原创",
    "from_who": "HuiGuo",
    "creator": "HuiGuo",
    "creator_uid": 6591,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593435318",
    "length": 50
  },
  {
    "id": 6343,
    "uuid": "d844038b-cb58-489d-874d-65efc95d9f6f",
    "hitokoto": "人生，三十年前看爹敬儿，三十年后看儿敬爹！",
    "type": "e",
    "from": "原创",
    "from_who": "白给少年洛初",
    "creator": "白给少年洛初",
    "creator_uid": 6596,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593486207",
    "length": 21
  },
  {
    "id": 6363,
    "uuid": "16b7a1e0-77af-411e-8dcc-3189bfd69702",
    "hitokoto": "手上的疤痕，那是过逝的生命，一道，两道，直到手腕上遍布了密密麻麻的伤疤，数都数不清。",
    "type": "e",
    "from": "原创",
    "from_who": "陈树凤",
    "creator": "陈树凤",
    "creator_uid": 5678,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1593946111",
    "length": 42
  },
  {
    "id": 6367,
    "uuid": "5e54aaf8-8098-418d-bd69-903c8e96e373",
    "hitokoto": "你总说你很累，可谁又过的顺风顺水。",
    "type": "e",
    "from": "原创",
    "from_who": "像风",
    "creator": "像风",
    "creator_uid": 6731,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1594981312",
    "length": 17
  },
  {
    "id": 6382,
    "uuid": "954ed277-51c4-4b28-aa47-85bdbc4103c9",
    "hitokoto": "我得罪了领导，领导醉了。",
    "type": "e",
    "from": "ideng",
    "from_who": "ideng",
    "creator": "ideng",
    "creator_uid": 6229,
    "reviewer": 6,
    "commit_from": "web",
    "created_at": "1593351205",
    "length": 12
  },
  {
    "id": 6384,
    "uuid": "6a833e0d-7dd7-4cb7-9184-47a7412ab934",
    "hitokoto": "这世间太不公平了，我都已经完完全全失去你了，可你还拥有着我。",
    "type": "e",
    "from": "落陈",
    "from_who": "落陈",
    "creator": "落陈",
    "creator_uid": 6737,
    "reviewer": 6,
    "commit_from": "web",
    "created_at": "1595168492",
    "length": 30
  },
  {
    "id": 6386,
    "uuid": "77d7e02b-3f15-4ad1-bee7-68709e48a619",
    "hitokoto": "每个人藏在影子里的，才是他真实的那面。",
    "type": "e",
    "from": "史上最骚大侦探",
    "from_who": "老番茄",
    "creator": "麻吉酷博异",
    "creator_uid": 6796,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1595665575",
    "length": 19
  },
  {
    "id": 6416,
    "uuid": "85d2c421-f8d3-456e-87bd-60c219f2b55c",
    "hitokoto": "本想自省，却闭门思他人之过。",
    "type": "e",
    "from": "氧化_小卡门",
    "from_who": "氧化_小卡门",
    "creator": "氧化_小卡门",
    "creator_uid": 6867,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596383912",
    "length": 14
  },
  {
    "id": 6424,
    "uuid": "0077021a-ef28-4d39-8e73-1a4eff34392c",
    "hitokoto": "我这么无聊，几乎从不主动的一个人也想为你变得有趣呢！",
    "type": "e",
    "from": "just now",
    "from_who": "非知名面包",
    "creator": "你有多久没有看过星星",
    "creator_uid": 6840,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1596108273",
    "length": 26
  },
  {
    "id": 6427,
    "uuid": "950eb0a3-cc49-4824-bf75-5abee9ca8ed5",
    "hitokoto": "只想着相见时春风细雨甜，哪管他相思夜星前月下苦。",
    "type": "e",
    "from": "日央",
    "from_who": "日央",
    "creator": "日央",
    "creator_uid": 6882,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596598830",
    "length": 24
  },
  {
    "id": 6434,
    "uuid": "5ab9661e-14d8-40fb-ae1b-118cf0ace6a6",
    "hitokoto": "明明付出远高于回报，却依旧选择硬着头皮做下去。只为了能在还未触及到的未来帮到你。或许这就是傻白甜吧。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1596861224",
    "length": 50
  },
  {
    "id": 6440,
    "uuid": "6cab6512-8cfe-4dfe-a1de-54532d884ff4",
    "hitokoto": "旅人不识清明雨，深院碧桃香红袖。",
    "type": "e",
    "from": "日央",
    "from_who": null,
    "creator": "日央",
    "creator_uid": 6882,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596599067",
    "length": 16
  },
  {
    "id": 6443,
    "uuid": "4c92849d-7011-43ea-957f-9c7180c83019",
    "hitokoto": "若有来生，我愿重至，月明花下。化雨为雾，赏曾经，灼灼桃花。",
    "type": "e",
    "from": "夜言",
    "from_who": "刘渤源",
    "creator": "负雨",
    "creator_uid": 6885,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596624737",
    "length": 29
  },
  {
    "id": 6444,
    "uuid": "87af43a0-60cc-42e8-9990-02707b7a5209",
    "hitokoto": "负断只舟阡陌短，雨淋青瓦深巷中。",
    "type": "e",
    "from": "负雨",
    "from_who": "刘渤源",
    "creator": "负雨",
    "creator_uid": 6885,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596625748",
    "length": 16
  },
  {
    "id": 6448,
    "uuid": "31a6ef13-6f24-4f71-82f0-3b92ffbe5961",
    "hitokoto": "究竟要说多少次你才能明白：在真正的友谊中，最强大的不是能力，而是信任。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1596952499",
    "length": 35
  },
  {
    "id": 6450,
    "uuid": "d898c41d-c663-4b3c-b8f6-f4706b3f6202",
    "hitokoto": "失去，得到，往往于一念间。",
    "type": "e",
    "from": "GoodChing",
    "from_who": "GoodChing",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1597190898",
    "length": 13
  },
  {
    "id": 6460,
    "uuid": "ec5cf8ed-232a-415f-8987-df84af0542d7",
    "hitokoto": "不去占有就是最好的拥有。",
    "type": "e",
    "from": "本人",
    "from_who": "青岑",
    "creator": "青岑",
    "creator_uid": 7432,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1602505035",
    "length": 12
  },
  {
    "id": 6474,
    "uuid": "4a695d75-63e5-4ea9-9ce2-6283fd7d0fc3",
    "hitokoto": "人啊，是利益的作品。",
    "type": "e",
    "from": "陈和锐",
    "from_who": "陈和锐",
    "creator": "陈和锐",
    "creator_uid": 7397,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1602126558",
    "length": 10
  },
  {
    "id": 6480,
    "uuid": "442fbb7f-d261-4b97-b6c7-d364e9ab64e7",
    "hitokoto": "朋友，如果有一天我死了，请相信我只是去了另一个世界等你",
    "type": "e",
    "from": "圣",
    "from_who": null,
    "creator": "那什么的阿鸽",
    "creator_uid": 7316,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1601724719",
    "length": 27
  },
  {
    "id": 6481,
    "uuid": "28c8d7e6-f179-4d8f-a939-daac4fa9c2da",
    "hitokoto": "忍着身体的惨痛，憧憬黎明的光芒。",
    "type": "e",
    "from": "原创",
    "from_who": "九月彷徨",
    "creator": "九月彷徨",
    "creator_uid": 7499,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1603174788",
    "length": 16
  },
  {
    "id": 6486,
    "uuid": "b8498051-18f4-4ab3-aae2-6f52fd339c99",
    "hitokoto": "没有理所当然的帮忙，只有个人素养的体现。",
    "type": "e",
    "from": "生活经历",
    "from_who": "loki",
    "creator": "loki",
    "creator_uid": 6950,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597370516",
    "length": 20
  },
  {
    "id": 6487,
    "uuid": "ddbe4911-b07e-4dda-a0df-4a656fd0b32c",
    "hitokoto": "每一个人活着，本质上都是对自己的不信任。",
    "type": "e",
    "from": "原创",
    "from_who": "浮生若梦",
    "creator": "浮生若梦",
    "creator_uid": 6985,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597716418",
    "length": 20
  },
  {
    "id": 6510,
    "uuid": "2dda386d-d4c5-4e6c-b107-b137c56cd189",
    "hitokoto": "厌倦了行尸走肉的生活，只想过有血有肉的生活。",
    "type": "e",
    "from": "原创",
    "from_who": "山涧",
    "creator": "shanjian",
    "creator_uid": 7013,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597982293",
    "length": 22
  },
  {
    "id": 6511,
    "uuid": "85762a66-7d16-4aed-938e-6447b9c80c6e",
    "hitokoto": "我当真能担得起，少年人这个词吗？",
    "type": "e",
    "from": "原创：追光集",
    "from_who": "山涧",
    "creator": "shanjian",
    "creator_uid": 7013,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1597982360",
    "length": 16
  },
  {
    "id": 6514,
    "uuid": "538aedba-184e-478c-943e-dcdc0b20b465",
    "hitokoto": "三年懵懂，三年凌辱，又三年孤独迷惘。空留纸上，寥落诗句数行。",
    "type": "e",
    "from": "原创",
    "from_who": "空中骑士的背影",
    "creator": "空中骑士的背影",
    "creator_uid": 7024,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598098542",
    "length": 30
  },
  {
    "id": 6525,
    "uuid": "5ecb4311-f743-4b07-9bd3-48e8132269e4",
    "hitokoto": "我收集了满屋子阳光，因为你是太阳。",
    "type": "e",
    "from": "小甜酿的日记",
    "from_who": "小甜酿",
    "creator": "小甜酿",
    "creator_uid": 7062,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598511573",
    "length": 17
  },
  {
    "id": 6526,
    "uuid": "be2b6dff-d0c7-452c-bce0-feae5eb029cd",
    "hitokoto": "我自己的思考，都是起源于问题。而追寻问题的方法，总是起源于确信。",
    "type": "e",
    "from": "思考",
    "from_who": "GrayDeprave",
    "creator": "GrayDeprave",
    "creator_uid": 7291,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1601315779",
    "length": 32
  },
  {
    "id": 6530,
    "uuid": "6873af3e-ef52-4c6c-80c5-ce60fdd7dba9",
    "hitokoto": "我们就像小小的纸飞机，老师就是放飞我们的手。",
    "type": "e",
    "from": "潍坊四中",
    "from_who": "啟腾同学",
    "creator": "啟腾同学",
    "creator_uid": 6896,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599917965",
    "length": 22
  },
  {
    "id": 6537,
    "uuid": "fbd320e1-b5a6-4766-baf2-5d401fcc7aaa",
    "hitokoto": "如果有一天我也提起笔，或许是因为做创作比做读者更杀渴。",
    "type": "e",
    "from": "原创",
    "from_who": "见你时澜青，不见时生春",
    "creator": "见你时澜青，不见时生春",
    "creator_uid": 7133,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1599382519",
    "length": 27
  },
  {
    "id": 6540,
    "uuid": "bf536ef9-f7a4-4eb7-aecb-f76bb53951d8",
    "hitokoto": "天会晴，雨会停。",
    "type": "e",
    "from": "原创",
    "from_who": "初见",
    "creator": "初X见",
    "creator_uid": 7058,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598701463",
    "length": 8
  },
  {
    "id": 6551,
    "uuid": "f886c07d-e042-448b-bd95-a2a2e91f3780",
    "hitokoto": "我怎么能倒下，我身后空无一人。",
    "type": "e",
    "from": "原创",
    "from_who": "hasty",
    "creator": "hasty",
    "creator_uid": 4575,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1598692161",
    "length": 15
  },
  {
    "id": 6600,
    "uuid": "4d1afffd-dc42-41f6-94d4-7c023b37df7e",
    "hitokoto": "自与你相识起，我便觉得你与众不同。",
    "type": "e",
    "from": "Alex",
    "from_who": "Alex",
    "creator": "Alex",
    "creator_uid": 7501,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603337964",
    "length": 17
  },
  {
    "id": 6612,
    "uuid": "8778b563-da21-4c8c-9ab1-383637a7935a",
    "hitokoto": "当你决定抛硬币的时候，就绝不要一次决定结果。毕竟，与其说相信命运，不过是命运恰巧停在了那个路口而已。",
    "type": "e",
    "from": "网络",
    "from_who": null,
    "creator": "寸惑",
    "creator_uid": 7579,
    "reviewer": 5198,
    "commit_from": "web",
    "created_at": "1603852808",
    "length": 50
  },
  {
    "id": 6614,
    "uuid": "308efb4c-ef95-4ff2-a502-8f6b756eb2ea",
    "hitokoto": "每个人的身上都有太阳，重要的是如何让它发光。",
    "type": "e",
    "from": "原创",
    "from_who": "Seddy",
    "creator": "Seddy",
    "creator_uid": 7542,
    "reviewer": 6844,
    "commit_from": "web",
    "created_at": "1603552831",
    "length": 22
  },
  {
    "id": 6616,
    "uuid": "2e98fe35-e10a-43b8-b8af-65bc0d519698",
    "hitokoto": "说你是人，却过完牛的一生。",
    "type": "e",
    "from": "原创",
    "from_who": "致明",
    "creator": "傅里叶今天不想展开",
    "creator_uid": 7533,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1603608454",
    "length": 13
  },
  {
    "id": 6660,
    "uuid": "057b08ca-5a21-47e0-8f49-f079224bc715",
    "hitokoto": "打到最后，应该就剩你自己，和，你为的人吧。",
    "type": "e",
    "from": "自创",
    "from_who": "聛",
    "creator": "Soiltary、K",
    "creator_uid": 3915,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1603792937",
    "length": 21
  },
  {
    "id": 6661,
    "uuid": "e28093f9-86ae-45de-aef8-85797b4310a7",
    "hitokoto": "梦想脱胎于现实，现实由梦想所化。",
    "type": "e",
    "from": "这个世界属于你",
    "from_who": "寸惑",
    "creator": "寸惑",
    "creator_uid": 7579,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1603931357",
    "length": 16
  },
  {
    "id": 6704,
    "uuid": "aaad423e-5a82-4af9-9043-3b251a49e420",
    "hitokoto": "真正体验过的喜欢，就是我期待你喜欢我，却不求你一定喜欢我，也不必我们要在一起。只愿在以后的以后，有人问起我，你喜欢过谁？我想起的人只有你。",
    "type": "e",
    "from": "原创",
    "from_who": "言无穷",
    "creator": "愿心中有爱",
    "creator_uid": 7690,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604905751",
    "length": 69
  },
  {
    "id": 6705,
    "uuid": "63b834bf-cb2e-4d4c-8a9e-2b4582b2a12a",
    "hitokoto": "往事匆匆，但愿你也能感动。",
    "type": "e",
    "from": "Lyrics",
    "from_who": "又诗几行",
    "creator": "CaptX",
    "creator_uid": 7698,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604976969",
    "length": 13
  },
  {
    "id": 6706,
    "uuid": "c2050532-5d0d-4742-a1ea-b6d0f3da6a9d",
    "hitokoto": "努力没用的话，那谁还能区分天才？",
    "type": "e",
    "from": "Game character lines",
    "from_who": "又诗几行",
    "creator": "CaptX",
    "creator_uid": 7698,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1604977260",
    "length": 16
  },
  {
    "id": 6717,
    "uuid": "dcdee695-4dec-4cd8-aba1-b9062b54b7dd",
    "hitokoto": "没有罪恶哪闻正理，没有伤痕何见凯旋，离情碎梦，谈什么出尘离染？",
    "type": "e",
    "from": "原创",
    "from_who": "Phoenix凰",
    "creator": "Phoenix凰",
    "creator_uid": 7716,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605106906",
    "length": 31
  },
  {
    "id": 6718,
    "uuid": "1647ec7b-613e-495f-b508-2c97a18b554b",
    "hitokoto": "都说星空昊天罔极，可以抹去一切伤痕，可面对阴晦时的星空，我感受到的只有萧条和凄惨，究竟是我太善于发现流年的黯淡，还是不得不去发现那些令人堕泪的残梦？",
    "type": "e",
    "from": "原创",
    "from_who": "Phoenix凰",
    "creator": "Phoenix凰",
    "creator_uid": 7716,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605106933",
    "length": 74
  },
  {
    "id": 6719,
    "uuid": "df861627-6600-49f5-b18d-05cc6e63be38",
    "hitokoto": "即便变成玩物，我也不会忘记，在虚空中的落寞和辜负，不同的是，我现在可以麻木不仁。",
    "type": "e",
    "from": "原创",
    "from_who": "Phoenix凰",
    "creator": "Phoenix凰",
    "creator_uid": 7716,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605106964",
    "length": 40
  },
  {
    "id": 6720,
    "uuid": "bee9aa17-df16-4865-937f-d7446935f09b",
    "hitokoto": "兰花，是随风而动，却弯曲下垂，虽是晶莹剔透，但也是撑霆裂月，终有一天会污浊色腥，很像那个折了翼的天使。",
    "type": "e",
    "from": "原创",
    "from_who": "Phoenix凰",
    "creator": "Phoenix凰",
    "creator_uid": 7716,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605107004",
    "length": 51
  },
  {
    "id": 6721,
    "uuid": "63410191-a397-42c5-a7a2-b3baebe4c73a",
    "hitokoto": "那狰狞牢笼，是暴虐，是消极，是深渊的召唤，每一次想要解脱却被死亡之手抓住，恶与煞逐渐交织成凄凉。",
    "type": "e",
    "from": "原创",
    "from_who": "Phoenix凰",
    "creator": "Phoenix凰",
    "creator_uid": 7716,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605107021",
    "length": 48
  },
  {
    "id": 6722,
    "uuid": "26b6c84a-072b-4cd2-bf6f-324ceb27c20b",
    "hitokoto": "人生总是聚少离多，我至今仍然无法习惯。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "eaea",
    "creator_uid": 304,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605229145",
    "length": 19
  },
  {
    "id": 6731,
    "uuid": "73403b83-3c9e-4933-93fe-05ad7f69af6d",
    "hitokoto": "年少时，当妈妈永久离开我的那一刻：往后的心脏又软又硬。",
    "type": "e",
    "from": "1987乡土小生",
    "from_who": "王烁焱",
    "creator": "王烁焱",
    "creator_uid": 1006,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605585078",
    "length": 27
  },
  {
    "id": 6732,
    "uuid": "91c22ae2-d21d-4967-850a-d41bc36753f4",
    "hitokoto": "从未给过我任何帮助，却想让我展翅高飞？",
    "type": "e",
    "from": "原创",
    "from_who": "Vikey安凝柠",
    "creator": "Vikey安凝柠",
    "creator_uid": 7775,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605619758",
    "length": 19
  },
  {
    "id": 6733,
    "uuid": "40c90b05-2331-41dd-ac9e-c15d7bc7c0bd",
    "hitokoto": "我已在这可怕的控制欲中溺毙。",
    "type": "e",
    "from": "随感",
    "from_who": "Vikey安凝柠",
    "creator": "Vikey安凝柠",
    "creator_uid": 7775,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605619884",
    "length": 14
  },
  {
    "id": 6734,
    "uuid": "00760622-14c8-4cdc-bbeb-4ce7ffa3fa81",
    "hitokoto": "真是的，明明第一次做人，却默契的装作了第二次的模样。",
    "type": "e",
    "from": "随感",
    "from_who": "寸惑",
    "creator": "寸惑",
    "creator_uid": 7579,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605665169",
    "length": 26
  },
  {
    "id": 6735,
    "uuid": "1164fce0-c850-472e-a6f5-bf8449da4bb4",
    "hitokoto": "我們互相矜持，認為或許可能存在着的一點曖昧，初识想見你。帶來的是希望但也可以是欺騙。",
    "type": "e",
    "from": "原创",
    "from_who": "星星",
    "creator": "chenruizhi",
    "creator_uid": 7780,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605692727",
    "length": 42
  },
  {
    "id": 6736,
    "uuid": "fb7e5d04-531c-4332-a6e2-865965a7ffc1",
    "hitokoto": "他们只会看到他们想看到的，不会在意一些不起眼的小东西，所以他们会失败……",
    "type": "e",
    "from": "随写",
    "from_who": "绎泽",
    "creator": "666wyf",
    "creator_uid": 7782,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1605703661",
    "length": 36
  },
  {
    "id": 6744,
    "uuid": "64367535-542d-4080-bf0b-d802dbea4d9e",
    "hitokoto": "世界上是没有会消失的无影无踪的事物的，亲人也是，梦想也是。",
    "type": "e",
    "from": "我的一个梦",
    "from_who": "我",
    "creator": "Uka 忧咔",
    "creator_uid": 7825,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606058425",
    "length": 29
  },
  {
    "id": 6791,
    "uuid": "30cc780f-b116-4c50-b3f1-60c0f841a44b",
    "hitokoto": "你不是畏惧黑暗吗？那你为何还喜欢在黑暗潜行。",
    "type": "e",
    "from": "博客",
    "from_who": "御辞",
    "creator": "御辞",
    "creator_uid": 7886,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606564614",
    "length": 22
  },
  {
    "id": 6792,
    "uuid": "2a3bd5fb-00fe-4532-949a-b272d3aad415",
    "hitokoto": "我宁愿错过也不愿意相遇。",
    "type": "e",
    "from": "博客",
    "from_who": "御辞",
    "creator": "御辞",
    "creator_uid": 7886,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606564642",
    "length": 12
  },
  {
    "id": 6793,
    "uuid": "7777404f-492e-437f-9471-c4e3d61bce70",
    "hitokoto": "请不要带着不好的事情去做自己喜欢做的事情。",
    "type": "e",
    "from": "博客",
    "from_who": "御辞",
    "creator": "御辞",
    "creator_uid": 7886,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606564757",
    "length": 21
  },
  {
    "id": 6815,
    "uuid": "d84ef646-0abe-40fe-ac41-352967cc321f",
    "hitokoto": "你看她笑靥如花，恰似此间神话。",
    "type": "e",
    "from": "随感",
    "from_who": "渊鱼",
    "creator": "渊鱼",
    "creator_uid": 7901,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606664993",
    "length": 15
  },
  {
    "id": 6817,
    "uuid": "8cb9a01a-f86d-4e19-a6b3-d302739a9bee",
    "hitokoto": "故人一迁，如梦万载。",
    "type": "e",
    "from": "随感",
    "from_who": "月雩",
    "creator": "月雩",
    "creator_uid": 7917,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606906692",
    "length": 10
  },
  {
    "id": 6818,
    "uuid": "cb4afcfd-c68b-446f-8212-ded141a931ae",
    "hitokoto": "清潇薄暮雨，半烛下莲舟。蝉鸣微月影，独赏醉难求。",
    "type": "e",
    "from": "月下雨",
    "from_who": "月雩",
    "creator": "月雩",
    "creator_uid": 7917,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606907431",
    "length": 24
  },
  {
    "id": 6819,
    "uuid": "8926b203-5ff6-4c3d-b91b-7d92644418b9",
    "hitokoto": "天际沉月影，风兮万花行。漫卷大荒乱，苍冥守空寻。",
    "type": "e",
    "from": "掠",
    "from_who": "月雩",
    "creator": "月雩",
    "creator_uid": 7917,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606907459",
    "length": 24
  },
  {
    "id": 6820,
    "uuid": "f95d83d8-db94-45f7-b917-02edeb6ea954",
    "hitokoto": "灯火欲离失，轻影黯花湿。微浮半谋面，我与泪三痴！",
    "type": "e",
    "from": "离",
    "from_who": "月雩",
    "creator": "月雩",
    "creator_uid": 7917,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606907488",
    "length": 24
  },
  {
    "id": 6821,
    "uuid": "ca64886a-49f2-40f4-96b1-b7ae776c80a4",
    "hitokoto": "旧时轻寒友，醉与梦沙舟。月寒苦夜短，终岁望南洲。",
    "type": "e",
    "from": "望",
    "from_who": "月雩",
    "creator": "月雩",
    "creator_uid": 7917,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606907508",
    "length": 24
  },
  {
    "id": 6822,
    "uuid": "a524fb5b-4e64-42e7-bf0a-95f3b720572f",
    "hitokoto": "雾柳迷苍星，夜百闻梦云。潦中倒杯酒，终与化月灵。",
    "type": "e",
    "from": "星向有感",
    "from_who": "月雩",
    "creator": "月雩",
    "creator_uid": 7917,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606907583",
    "length": 24
  },
  {
    "id": 6825,
    "uuid": "e5bb9bc9-8a47-47ca-9456-42ff7583ced8",
    "hitokoto": "逃离这座城市一直都不是梦，缺少的是离开的勇气。",
    "type": "e",
    "from": "原创",
    "from_who": "鬼绿",
    "creator": "鬼绿",
    "creator_uid": 7928,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1606993331",
    "length": 23
  },
  {
    "id": 6893,
    "uuid": "b374af21-7c70-4a9b-b27a-3dc80ad09f86",
    "hitokoto": "错过了一次的人，始终会错过第二次。",
    "type": "e",
    "from": "原创",
    "from_who": "侠名",
    "creator": "星空下的约定",
    "creator_uid": 7959,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607432692",
    "length": 17
  },
  {
    "id": 6899,
    "uuid": "84e81a14-5961-4d19-b2b5-425a0d3fde28",
    "hitokoto": "夜幽幽，月优优，曲悠悠，吾忧忧。",
    "type": "e",
    "from": "原创",
    "from_who": "莽红尘觅知嘤",
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607670097",
    "length": 16
  },
  {
    "id": 6900,
    "uuid": "502ae3b6-2fa8-4120-a060-8ebe64dfe29a",
    "hitokoto": "早点脱单吧，我怕你孤独终老，却又长命百岁。",
    "type": "e",
    "from": "友人记",
    "from_who": "三行",
    "creator": "三行",
    "creator_uid": 7987,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607779530",
    "length": 21
  },
  {
    "id": 6901,
    "uuid": "d7451e05-37dc-43eb-aefd-6d0a906198b1",
    "hitokoto": "正因为拥有独立思考的能力，所以我们不再受制于“别人说什么”和“大家说什么”，而还可以说“我发现了什么”。",
    "type": "e",
    "from": "MySelf",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1607816296",
    "length": 52
  },
  {
    "id": 6906,
    "uuid": "fdf0bab1-7bcd-4aea-8cba-606f42292c52",
    "hitokoto": "理性和感性，在我看来，是两种不同价值观的碰撞。",
    "type": "e",
    "from": "Myself",
    "from_who": "Spectre™",
    "creator": "Spectre",
    "creator_uid": 7965,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608129312",
    "length": 23
  },
  {
    "id": 6909,
    "uuid": "ca22ecd0-89f8-43bd-a8fc-ab127236c46f",
    "hitokoto": "无为而无不为，以不变应万变。",
    "type": "e",
    "from": "原创",
    "from_who": "SquareBlock",
    "creator": "SquareBlock",
    "creator_uid": 7985,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608429374",
    "length": 14
  },
  {
    "id": 6910,
    "uuid": "3a819d4d-f753-4962-af5b-732530d727a4",
    "hitokoto": "「现在」永远是最坏的时候，永远期待美好的事情即将发生。",
    "type": "e",
    "from": "原创",
    "from_who": "SquareBlock",
    "creator": "SquareBlock",
    "creator_uid": 7985,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608429388",
    "length": 27
  },
  {
    "id": 6911,
    "uuid": "5cb0e232-85fd-41b0-a2db-80e679c8910f",
    "hitokoto": "平行线是很恐怖的，因为永远不会相交。相交线是最恐怖的，因为相交过后越行越远。",
    "type": "e",
    "from": "原创",
    "from_who": "SquareBlock",
    "creator": "SquareBlock",
    "creator_uid": 7985,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608429410",
    "length": 38
  },
  {
    "id": 6914,
    "uuid": "dab24f86-b963-4c5e-b7ca-d3f8983ed7e8",
    "hitokoto": "人何尝不像鳄鱼一样，留着眼泪做着违心的事。",
    "type": "e",
    "from": "原创",
    "from_who": "SquareBlock",
    "creator": "SquareBlock",
    "creator_uid": 7985,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608429644",
    "length": 21
  },
  {
    "id": 6916,
    "uuid": "58b76d76-fd23-40ac-bd25-bf686d1d5459",
    "hitokoto": "人一生的大部分时间都是平淡无奇的。这也是我们身体养精蓄锐的必要条件。因为只有身心在泛起涟漪的生活中得到充分的修正，才能圆满的迎接人生的下一次高峰。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608619446",
    "length": 73
  },
  {
    "id": 6918,
    "uuid": "7bf6b650-d79a-4adc-aa1f-31172dca6a71",
    "hitokoto": "夜幽幽，月优优，曲悠悠，吾忧忧。",
    "type": "e",
    "from": "原创",
    "from_who": "莽红尘觅知嘤",
    "creator": "莽红尘觅知嘤",
    "creator_uid": 5611,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1608625396",
    "length": 16
  },
  {
    "id": 6920,
    "uuid": "4b3b04e1-6200-451b-b087-1d57ac49e847",
    "hitokoto": "与其展望未来回味从前，不如过好当下的每一秒，去珍惜你所爱的、所恨的人，甚至是仅仅是擦肩而过的陌生人。",
    "type": "e",
    "from": "随感",
    "from_who": "xhduoduobaby",
    "creator": "xhduoduobaby",
    "creator_uid": 7398,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609060141",
    "length": 50
  },
  {
    "id": 6921,
    "uuid": "2c3cc358-44ce-4a97-9161-22decd6e939f",
    "hitokoto": "踏过一年，迎来一年。",
    "type": "e",
    "from": "无",
    "from_who": "南宫雨熈",
    "creator": "GoodChing",
    "creator_uid": 5257,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1609586971",
    "length": 10
  },
  {
    "id": 6930,
    "uuid": "c815434e-2f69-401f-9338-ba297f36e550",
    "hitokoto": "理想三旬浓烟下，奔赴山海与荒野。",
    "type": "e",
    "from": "生活",
    "from_who": "浓烟下",
    "creator": "浓烟下",
    "creator_uid": 8185,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610002722",
    "length": 16
  },
  {
    "id": 6932,
    "uuid": "c6a7aafa-8aab-479f-9937-90f1fa5a3469",
    "hitokoto": "所谓清洗，不过是把脏污从一个物体上移动到另一个物体上罢了。",
    "type": "e",
    "from": "原创",
    "from_who": "River",
    "creator": "River",
    "creator_uid": 7613,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610154743",
    "length": 29
  },
  {
    "id": 6933,
    "uuid": "ce62c97a-c2e0-4c81-93a9-e2a4b91ff671",
    "hitokoto": "世界上，最漫长的，无疑是等待。直到风带着芬芳，日落水塘。",
    "type": "e",
    "from": "晨风与阳",
    "from_who": "Moqzekun",
    "creator": "moqzekun",
    "creator_uid": 8209,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610201107",
    "length": 28
  },
  {
    "id": 6939,
    "uuid": "df030b46-b9cf-4a6b-b4c0-524e0291adf0",
    "hitokoto": "乐得浮生半日闲，一杯酒前细烟点。",
    "type": "e",
    "from": "自创",
    "from_who": "林萧",
    "creator": "林萧",
    "creator_uid": 8251,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610708917",
    "length": 16
  },
  {
    "id": 6940,
    "uuid": "0bd9177a-190b-474c-b133-12a37e564ffa",
    "hitokoto": "时光荏苒，也寻昨日回忆不断，哪怕留万般无奈，傲骨谁还在？",
    "type": "e",
    "from": "自创",
    "from_who": "林萧",
    "creator": "林萧",
    "creator_uid": 8251,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610709631",
    "length": 28
  },
  {
    "id": 6941,
    "uuid": "4b27e9f7-8bc6-44da-b189-505c8518fdf5",
    "hitokoto": "如果一支团队里的成员并非完全的志同道合，那么请记住：群体的志愿必将以个人的折中作为代价。",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1610758428",
    "length": 44
  },
  {
    "id": 6945,
    "uuid": "a90d7580-7692-4131-b8bd-ae3b03252366",
    "hitokoto": "今天没有月亮，月亮在我怀里。",
    "type": "e",
    "from": "苏晏.",
    "from_who": null,
    "creator": "晏.",
    "creator_uid": 8286,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611151848",
    "length": 14
  },
  {
    "id": 6966,
    "uuid": "03e5936d-6d26-4394-9bcd-52de5a557c5d",
    "hitokoto": "要是心情郁闷的时候，用手托腮就好，手臂会因为帮上忙而开心的。",
    "type": "e",
    "from": "随感",
    "from_who": "Litten",
    "creator": "BlueHeart0621",
    "creator_uid": 8312,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611458997",
    "length": 30
  },
  {
    "id": 6981,
    "uuid": "442473d5-0067-4c87-a770-4ac9f29547a4",
    "hitokoto": "巷子里的猫很自由，却没有归宿，围墙里的狗，有归宿终身都得低头，人生这道选择题，怎么选都有遗憾......",
    "type": "e",
    "from": "我的世界",
    "from_who": "乔治の一天",
    "creator": "乔治的一天",
    "creator_uid": 8520,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613548822",
    "length": 52
  },
  {
    "id": 6982,
    "uuid": "2c524d53-e3b2-4745-9d66-800d18262ace",
    "hitokoto": "有的人沉迷过去，是因为他还不知道自己的未来是多么远大。",
    "type": "e",
    "from": "碎碎念",
    "from_who": "Yek",
    "creator": "yek",
    "creator_uid": 8348,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611747677",
    "length": 27
  },
  {
    "id": 6985,
    "uuid": "60d17185-3ac5-4095-b509-19b6e8257fc1",
    "hitokoto": "别磨蹭，只有现在自己才能改变自己的未来！",
    "type": "e",
    "from": "灵感",
    "from_who": "无名者",
    "creator": "四方霸主",
    "creator_uid": 8349,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611824053",
    "length": 20
  },
  {
    "id": 6987,
    "uuid": "0ee192ff-d872-4dd7-b867-d0d8bf021c03",
    "hitokoto": "我是风筝，而你是那放风筝的人，我对你既有一丝牵挂，却又无时不在奋力逃走。",
    "type": "e",
    "from": "林熙原创集",
    "from_who": "林熙",
    "creator": "林熙",
    "creator_uid": 8364,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611835457",
    "length": 36
  },
  {
    "id": 6990,
    "uuid": "7b0fd33f-0564-40c5-b0b4-a8c070220165",
    "hitokoto": "每次对一个人很好，最后换来的不过是自己身价的卑微。",
    "type": "e",
    "from": "随想",
    "from_who": "以沫",
    "creator": "epicmo",
    "creator_uid": 6557,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1611896751",
    "length": 25
  },
  {
    "id": 6992,
    "uuid": "c99fa775-29b1-4b1a-8762-86641317cc32",
    "hitokoto": "时空可能不会阻隔我们，但时间一定会让我们天各一方。",
    "type": "e",
    "from": "原创",
    "from_who": "无事献殷勤",
    "creator": "无事献殷勤",
    "creator_uid": 8384,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612098916",
    "length": 25
  },
  {
    "id": 7002,
    "uuid": "b81bc4a3-53d6-4379-a34a-5b51309f4aae",
    "hitokoto": "每个细节只需要再好一点点，最终结果将会更加完美。",
    "type": "e",
    "from": "个人对周星驰视频的总结",
    "from_who": "再好一点点",
    "creator": "再好一点点",
    "creator_uid": 8403,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612258887",
    "length": 24
  },
  {
    "id": 7011,
    "uuid": "772d87da-d1d9-4233-9576-c32e043dcdee",
    "hitokoto": "别错把工具当成目的。",
    "type": "e",
    "from": "子公",
    "from_who": "子公",
    "creator": "wsll子公",
    "creator_uid": 6971,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612325502",
    "length": 10
  },
  {
    "id": 7012,
    "uuid": "d06fefa8-f28b-4da2-98cf-df1c85b2ec0b",
    "hitokoto": "如果TA过得好，就算没有在一起，我也会开心，对吗？——我一直骗着自己。",
    "type": "e",
    "from": "原创",
    "from_who": "夏彦深见",
    "creator": "深见",
    "creator_uid": 8420,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612349685",
    "length": 35
  },
  {
    "id": 7014,
    "uuid": "e352ddd1-8f1d-437d-934a-dc996ba11324",
    "hitokoto": "当你看着镜子的时候，镜子里的你也在看着你自己。",
    "type": "e",
    "from": "随笔",
    "from_who": "曹博睿cbr",
    "creator": "曹博睿",
    "creator_uid": 8043,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612354884",
    "length": 23
  },
  {
    "id": 7016,
    "uuid": "38170778-fbe8-4036-a99c-4e6eb168c7e5",
    "hitokoto": "自己一直在劝他人不要这样不要那样，结果到头来，堕落的人是自己。",
    "type": "e",
    "from": "别了，劝说家",
    "from_who": "糖很苦",
    "creator": "没等到你",
    "creator_uid": 8423,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612364901",
    "length": 31
  },
  {
    "id": 7021,
    "uuid": "961b00c7-a650-46f1-b01c-519e7afa2d2d",
    "hitokoto": "读不出隐含的意思，囊括了永恒的变化，越是想要理解，就飘得越远——如同轻盈的丝线，飘渺、绚丽、交织、缠绕，不断地改变，不断地前进——这就是所谓思想。",
    "type": "e",
    "from": "随笔",
    "from_who": null,
    "creator": "286799714",
    "creator_uid": 8426,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1612662812",
    "length": 73
  },
  {
    "id": 7028,
    "uuid": "070eeb24-92c6-4d8c-ad13-558b8246beda",
    "hitokoto": "蝶类的鳞翅映射的幻象总是无以复加的华丽，如沤珠漌艳。",
    "type": "e",
    "from": "celeste",
    "from_who": null,
    "creator": "Celeste",
    "creator_uid": 8455,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613209965",
    "length": 26
  },
  {
    "id": 7029,
    "uuid": "87072151-ac60-4e50-8179-38ef1994aff1",
    "hitokoto": "圆满你的过去，活在当下有全然的觉悟，放下怨恨有信心，有力量，对你有信心。因为你就是我，我就是你。",
    "type": "e",
    "from": "超意识突破",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613367412",
    "length": 48
  },
  {
    "id": 7034,
    "uuid": "b2a0df4b-ee7b-41e1-a972-086461f3b318",
    "hitokoto": "人若是失去了情感，泯灭了希望，那和一团只有逻辑的人工智能有什么区别？",
    "type": "e",
    "from": "原创",
    "from_who": "pokon548",
    "creator": "pokon548",
    "creator_uid": 4761,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613372547",
    "length": 34
  },
  {
    "id": 7035,
    "uuid": "0abd23d6-44df-4539-b2e5-aa0fe609dd5d",
    "hitokoto": "当我说“否认痛苦和折磨”时，我并不是说寻找幸福和快乐，而是寻找清净。",
    "type": "e",
    "from": "超意识突破",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613369253",
    "length": 34
  },
  {
    "id": 7036,
    "uuid": "37a1d973-b292-40b9-b098-50b67fc78593",
    "hitokoto": "展示你强大的力量，即使它看起来像是在妄想面前的傲慢；妄想正试图给你洗脑，让你遭受折磨和痛苦。",
    "type": "e",
    "from": "超意识突破",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613369147",
    "length": 46
  },
  {
    "id": 7037,
    "uuid": "27cd291e-1b26-46a1-86e2-d0ee2befe2e4",
    "hitokoto": "梦想家是把他的想象变成现实的人。他从不感到疲倦，并且继续鼓舞人心，坚持自己的梦想，并把它变成现实。",
    "type": "e",
    "from": "强大的认知",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613368687",
    "length": 49
  },
  {
    "id": 7038,
    "uuid": "4fddc00d-b444-4712-a4bc-158cb4cde48f",
    "hitokoto": "妄想就是你有意识得决定毁灭自己！",
    "type": "e",
    "from": "强大的认知",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613367819",
    "length": 16
  },
  {
    "id": 7039,
    "uuid": "462aa355-4bc7-47e5-91a4-2109aa51d39f",
    "hitokoto": "如果你有意识地选择你内在的认知，你所显化的能力和能量是无法想象的。",
    "type": "e",
    "from": "强大的认知",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1613368815",
    "length": 33
  },
  {
    "id": 7053,
    "uuid": "65a75a80-1d58-4d9b-986f-723e1ac0c5ec",
    "hitokoto": "人类最大的潜力就是痛苦过后依然前行，向着心中的光。",
    "type": "e",
    "from": "原创",
    "from_who": "金yin",
    "creator": "金yin",
    "creator_uid": 8544,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613737791",
    "length": 25
  },
  {
    "id": 7058,
    "uuid": "e1b902e5-f539-4680-8563-668a5d843dc9",
    "hitokoto": "如果将你的生命比喻为一座建筑物，你对自己和别人说的话就像是这座建筑物的地基。它必须是没有尘埃和锈蚀的。换句话说，它必须摆脱无意识的模式。",
    "type": "e",
    "from": "与你的四大内在力量相遇",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613828509",
    "length": 68
  },
  {
    "id": 7060,
    "uuid": "83f9b71e-6f6f-4619-a87e-8163cf5ea03b",
    "hitokoto": "感觉的力量教导你如何通过责任感将生命提升到另一个层次。",
    "type": "e",
    "from": "与你的四大内在力量相遇",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613828179",
    "length": 27
  },
  {
    "id": 7061,
    "uuid": "d0cd1c09-4e29-45d4-9ae2-72332adc1ee6",
    "hitokoto": "当你理解到人生最大的回馈是你与别人共享你的生命时，你将真正地享受生活的力量。",
    "type": "e",
    "from": "与你的四大内在力量相遇",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613828220",
    "length": 38
  },
  {
    "id": 7062,
    "uuid": "77076578-4d41-493d-9cb7-36545a345e6f",
    "hitokoto": "当你发现你思想的力量时，你的思想将专注于人际关系、教育、财务及人生并在这些领域达到成功。",
    "type": "e",
    "from": "与你的四大内在力量相遇",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613828150",
    "length": 44
  },
  {
    "id": 7063,
    "uuid": "96457915-caff-4f3e-bff1-05ba1833a9d8",
    "hitokoto": "无论你对自己或对别人说过什么，让它成为你的生命，履行它，就是真正的一致性。",
    "type": "e",
    "from": "与你的四大内在力量相遇",
    "from_who": "尼希亚南达",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613828731",
    "length": 37
  },
  {
    "id": 7073,
    "uuid": "f422c24f-9151-4e13-8d47-0409bc9ad19b",
    "hitokoto": "我们找到了一个晶莹绚丽，却又稍纵即逝的东西。我们称它为永恒。",
    "type": "e",
    "from": "Kyanite",
    "from_who": null,
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1613912249",
    "length": 30
  },
  {
    "id": 7074,
    "uuid": "7e1435a6-bf71-45bf-93d9-de576b3e340c",
    "hitokoto": "生命不是一支短暂的蜡烛，它是一个明亮的火炬。让它在你的生活中尽可能明亮的燃烧吧！",
    "type": "e",
    "from": "分享",
    "from_who": "伙伴",
    "creator": "南京智慧宝座【凯拉萨的尼希亚南达】",
    "creator_uid": 8510,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1614002009",
    "length": 40
  },
  {
    "id": 7077,
    "uuid": "ceddfb05-93a6-40c8-bb25-df4a33f2f59d",
    "hitokoto": "很多人在你的生命中只存在那么一瞬，或许你会为自己遗忘了她的容貌而捶胸顿足，但，记住一个再也不会出现的人，又有什么意义呢？",
    "type": "e",
    "from": "原创",
    "from_who": "Knight-423",
    "creator": "Knight-423",
    "creator_uid": 8572,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1614070425",
    "length": 60
  },
  {
    "id": 7085,
    "uuid": "d1aca3f8-f6ea-4ef8-ac7c-7e312d9399cc",
    "hitokoto": "身处谷底有谁能分清我在哪片迷雾里。",
    "type": "e",
    "from": "随笔",
    "from_who": "夜杏",
    "creator": "夜杏",
    "creator_uid": 8664,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1614957996",
    "length": 17
  },
  {
    "id": 7086,
    "uuid": "8aa19f15-738d-4262-8f6a-0fb30f8acb19",
    "hitokoto": "我曾因她置身光明，却又因她堕于崖底。",
    "type": "e",
    "from": "随笔",
    "from_who": "夜杏",
    "creator": "夜杏",
    "creator_uid": 8664,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1614958078",
    "length": 18
  },
  {
    "id": 7087,
    "uuid": "37fa0c87-0b04-49aa-9509-c7f520f51d6f",
    "hitokoto": "千篇一律的面具背后尽是伪善的人心。",
    "type": "e",
    "from": "随笔",
    "from_who": "夜杏",
    "creator": "夜杏",
    "creator_uid": 8664,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1614958130",
    "length": 17
  },
  {
    "id": 7088,
    "uuid": "d5540ba6-2e69-43bc-8d73-d19bd3e255b4",
    "hitokoto": "我最想的，就是好好活着。",
    "type": "e",
    "from": "Que",
    "from_who": "Que",
    "creator": "Que",
    "creator_uid": 8670,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615006231",
    "length": 12
  },
  {
    "id": 7090,
    "uuid": "0ea4322d-94ad-4209-8b4a-0d825a2bfc06",
    "hitokoto": "人生路漫长度，江河东流不息。",
    "type": "e",
    "from": "江上悦峰",
    "from_who": "江上悦峰",
    "creator": "爱民",
    "creator_uid": 8738,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615643999",
    "length": 14
  },
  {
    "id": 7093,
    "uuid": "e35a83ef-0399-41c6-aada-3b22e94aa82b",
    "hitokoto": "保护者，必然也是施暴者。人们总是认为自己所守护的正义，是需要保护的。而对于与相较于自己的正义所相反的正义，则施予加害。",
    "type": "e",
    "from": "《路·碌·录》",
    "from_who": "天翔",
    "creator": "TN XG",
    "creator_uid": 7060,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615653062",
    "length": 59
  },
  {
    "id": 7094,
    "uuid": "6c413398-adce-43e0-8e4c-1200f4fd2bf7",
    "hitokoto": "因为缺少珍惜，才有失之交臂的遗憾。把它作为陌不相识的两个人一秒间的擦肩而过吧。",
    "type": "e",
    "from": "《路·碌·录》",
    "from_who": "TNXG",
    "creator": "TN XG",
    "creator_uid": 7060,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615653098",
    "length": 39
  },
  {
    "id": 7095,
    "uuid": "a64943da-021b-4e83-8d31-217a88eda477",
    "hitokoto": "或许就像现在这样，孤独、寂寞。但我们依旧有着美好的明天。",
    "type": "e",
    "from": "《路·碌·录》",
    "from_who": "TNXG",
    "creator": "TN XG",
    "creator_uid": 7060,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615653132",
    "length": 28
  },
  {
    "id": 7096,
    "uuid": "372309e5-1477-4570-a995-953b2859b1c4",
    "hitokoto": "就像飞蛾扑火，就像虫子扎进深坑。但飞蛾并不觉得灰暗，至少它享受了短暂的光明。且小虫并不觉得悲伤，至少它享受了片刻的安稳。",
    "type": "e",
    "from": "《路·碌·录》",
    "from_who": "TNXG",
    "creator": "TN XG",
    "creator_uid": 7060,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1615653168",
    "length": 60
  },
  {
    "id": 7100,
    "uuid": "80fbdb1b-1a66-4ce1-a041-e1038368e6f1",
    "hitokoto": "只去看沿途的风景而不关注道路的末尾，就很有可能在终点前掉到坑里。",
    "type": "e",
    "from": "无",
    "from_who": "某个Dr.",
    "creator": "Doctor",
    "creator_uid": 8776,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616181252",
    "length": 32
  },
  {
    "id": 7101,
    "uuid": "1ce3aeda-affb-4a7a-84fa-4c3bda195a91",
    "hitokoto": "你所厌烦的普通，也许是他生命中最珍贵的平凡。",
    "type": "e",
    "from": "Human",
    "from_who": "Human",
    "creator": "雄鹰展翅",
    "creator_uid": 7520,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616257639",
    "length": 22
  },
  {
    "id": 7103,
    "uuid": "7dea35ca-218a-4478-83e0-b63f030cb4ec",
    "hitokoto": "万般世故难欢乐，一程风景作银河。",
    "type": "e",
    "from": "流求议事堂",
    "from_who": "清岷",
    "creator": "長安城根喚朱雀",
    "creator_uid": 8788,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616343234",
    "length": 16
  },
  {
    "id": 7104,
    "uuid": "0c342eb2-f921-4f31-9e78-40a7dc06ae0e",
    "hitokoto": "不喜欢什么都是理由，喜欢什么都不是理由。",
    "type": "e",
    "from": "木子吻雨叚",
    "from_who": "木子吻雨叚",
    "creator": "木子吻雨叚",
    "creator_uid": 8810,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616568718",
    "length": 20
  },
  {
    "id": 7105,
    "uuid": "fd27fb54-05b8-4c0d-bc2e-1222b1dce466",
    "hitokoto": "无求一生光辉，唯望斗志不断。",
    "type": "e",
    "from": "流求议事堂",
    "from_who": "清岷",
    "creator": "長安城根喚朱雀",
    "creator_uid": 8788,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616661496",
    "length": 14
  },
  {
    "id": 7107,
    "uuid": "ae9b1c11-33b8-425d-822c-d355bd3761df",
    "hitokoto": "等风来，希望雨别下。",
    "type": "e",
    "from": "森木志",
    "from_who": "森木志",
    "creator": "森木志",
    "creator_uid": 8792,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1616401368",
    "length": 10
  },
  {
    "id": 7112,
    "uuid": "ecd7eb82-2ef5-4f23-8e24-ee58a5715ef6",
    "hitokoto": "天上的风一定很大，把满团的月光吹散了，化为萤火，洒满了蓝紫的夜。",
    "type": "e",
    "from": "《星月夜》",
    "from_who": null,
    "creator": "翩翩辞归",
    "creator_uid": 8978,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1618112176",
    "length": 32
  },
  {
    "id": 7113,
    "uuid": "fe2389c3-e628-480a-87fa-d2cd41d4cc86",
    "hitokoto": "我想，当风吹过的时候，我可以拥抱这个世界。",
    "type": "e",
    "from": "随笔",
    "from_who": "落雨成声",
    "creator": "落雨成声",
    "creator_uid": 8982,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1618134924",
    "length": 21
  },
  {
    "id": 7115,
    "uuid": "95d0340a-dea1-436f-ba93-f461f33c4132",
    "hitokoto": "未来还有亿亿年，不要因为挫折否定自己，也不要因为挫折放弃前行。",
    "type": "e",
    "from": "网络博客",
    "from_who": "dzzzb",
    "creator": "dzzzb",
    "creator_uid": 8853,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1618571618",
    "length": 31
  },
  {
    "id": 7118,
    "uuid": "f46a284b-84ad-465a-93cc-1a74f165aaca",
    "hitokoto": "这世上本无绝对的对与错，所谓的错，或许只是对的另一种执着。",
    "type": "e",
    "from": "原创",
    "from_who": "荒眸",
    "creator": "林萧",
    "creator_uid": 8251,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1618844915",
    "length": 29
  },
  {
    "id": 7129,
    "uuid": "24e6b82b-eb3b-4231-acc8-5cd2f5d18515",
    "hitokoto": "和自己的心站在一起，而不是恐惧、悲伤、失落、无力、愤怒、掩饰。勇敢。",
    "type": "e",
    "from": "勇敢的心",
    "from_who": "南京智慧宝座",
    "creator": "南京智慧宝座",
    "creator_uid": 8510,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614004434",
    "length": 34
  },
  {
    "id": 7131,
    "uuid": "d620e424-9147-4f0a-95ea-9c3cd40cda3e",
    "hitokoto": "当雪崩发生时，没有一片雪花，不在浪迹天涯。",
    "type": "e",
    "from": "Kyanite",
    "from_who": "Kyanite",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614086677",
    "length": 21
  },
  {
    "id": 7151,
    "uuid": "fb8145cf-e36c-4fe2-86f8-66ee9c4ada3c",
    "hitokoto": "在流沙上建造高塔，在海水中付出耕耘。",
    "type": "e",
    "from": "Kyanite",
    "from_who": null,
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620048260",
    "length": 18
  },
  {
    "id": 7152,
    "uuid": "73871f6e-2379-441e-b34d-7e8d330e5bd2",
    "hitokoto": "君子当自强方成事。",
    "type": "e",
    "from": "道义",
    "from_who": "朴素",
    "creator": "Pusu",
    "creator_uid": 6298,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620107242",
    "length": 9
  },
  {
    "id": 7153,
    "uuid": "92d84ee6-d17c-4137-8ca3-d95e56bc770e",
    "hitokoto": "你不努力，你得到的一切一定会被夺走！",
    "type": "e",
    "from": "Posherlunch",
    "from_who": "Posherlunch",
    "creator": "Posherlunch",
    "creator_uid": 8610,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614354562",
    "length": 18
  },
  {
    "id": 7154,
    "uuid": "b0bbe987-02a3-4360-b445-27fe2c336d46",
    "hitokoto": "死亡本身并不可怕，可怕的是它成为了唯一的选择；生命本身并不可贵，可贵的是它能够迸发出的无限力量。",
    "type": "e",
    "from": "Mi",
    "from_who": "Mi",
    "creator": "Mi",
    "creator_uid": 7310,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614396826",
    "length": 48
  },
  {
    "id": 7158,
    "uuid": "d63bcceb-9bb4-451a-ab36-d036cb8856ee",
    "hitokoto": "时针一圈一圈回到了起点，可岁月一天一天变成了从前。",
    "type": "e",
    "from": "孤叶",
    "from_who": "孤叶",
    "creator": "LLeaf",
    "creator_uid": 8622,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614487441",
    "length": 25
  },
  {
    "id": 7163,
    "uuid": "485b5b8d-e9e4-4b71-9656-9a87b2d9c3b6",
    "hitokoto": "当晚睡规律起来，就不算熬夜了。",
    "type": "e",
    "from": "ZainCheung",
    "from_who": "ZainCheung",
    "creator": "ZainCheung",
    "creator_uid": 8617,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614525071",
    "length": 15
  },
  {
    "id": 7164,
    "uuid": "f4e6643c-6397-47a3-9211-a7723c8a5b71",
    "hitokoto": "今天你要是不做，你明天还是得做。",
    "type": "e",
    "from": "MengCheng1015",
    "from_who": "MengCheng1015",
    "creator": "MengCheng1015",
    "creator_uid": 8437,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614611924",
    "length": 16
  },
  {
    "id": 7165,
    "uuid": "8fccf5cd-b453-4f2c-b006-7dbcd9f60452",
    "hitokoto": "读书只盼天数，工作只盼月数。",
    "type": "e",
    "from": "LD2045",
    "from_who": "LD2045",
    "creator": "MengCheng1015",
    "creator_uid": 8437,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614612382",
    "length": 14
  },
  {
    "id": 7172,
    "uuid": "cd4e19a7-d10f-45fb-ab82-341b950fcb9e",
    "hitokoto": "生命犹如水逝，而逝水终在海，死去犹如月落，而落月不离天。",
    "type": "e",
    "from": "Kyanite",
    "from_who": "Kyanite",
    "creator": "Kyanite",
    "creator_uid": 8042,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1614946418",
    "length": 28
  },
  {
    "id": 7198,
    "uuid": "471e3a2e-e802-46c1-9e56-16a17b7e9e3b",
    "hitokoto": "永远坚信，黎明就在眼前。",
    "type": "e",
    "from": "澈亦",
    "from_who": "澈亦",
    "creator": "澈亦",
    "creator_uid": 8678,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615038807",
    "length": 12
  },
  {
    "id": 7206,
    "uuid": "754ea585-fa0f-4d6c-b345-129f6270fddd",
    "hitokoto": "我写了一首诗，我不敢写的是你的名字。",
    "type": "e",
    "from": "光之帝皇侠",
    "from_who": "光之帝皇侠",
    "creator": "我家猫叫茄子",
    "creator_uid": 8821,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616722367",
    "length": 18
  },
  {
    "id": 7208,
    "uuid": "87a364f2-1d31-4224-92b9-102315eb110e",
    "hitokoto": "人生路漫长渡，江河东流不息。",
    "type": "e",
    "from": "江上悦峰",
    "from_who": "江上悦峰",
    "creator": "爱民",
    "creator_uid": 8738,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1615647064",
    "length": 14
  },
  {
    "id": 7209,
    "uuid": "c8eeaa0b-78a5-4536-90cb-454ade34763f",
    "hitokoto": "见死不救的不一定是恶人，救死扶伤的不一定是好人。",
    "type": "e",
    "from": "某个Dr.",
    "from_who": "某个Dr.",
    "creator": "Doctor",
    "creator_uid": 8776,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1616180445",
    "length": 24
  },
  {
    "id": 7224,
    "uuid": "3c280de7-d709-4b25-b722-78d0d56b31c6",
    "hitokoto": "免费的馈赠往往标明了无形的价格。",
    "type": "e",
    "from": "亚亚努阿",
    "from_who": "亚亚努阿",
    "creator": "亚亚努阿",
    "creator_uid": 8848,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617029389",
    "length": 16
  },
  {
    "id": 7225,
    "uuid": "746ba691-5103-4b13-88e6-b11ffc215fe6",
    "hitokoto": "人类最大的敌人是傲慢，其次是无知。",
    "type": "e",
    "from": "亚亚努阿",
    "from_who": "亚亚努阿",
    "creator": "亚亚努阿",
    "creator_uid": 8848,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617029737",
    "length": 17
  },
  {
    "id": 7228,
    "uuid": "9b7b8447-ca40-4308-8103-50c2c0738e75",
    "hitokoto": "那年，一定很美吧。",
    "type": "e",
    "from": "我们",
    "from_who": "幻空",
    "creator": "MukingIce",
    "creator_uid": 9213,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620399073",
    "length": 9
  },
  {
    "id": 7229,
    "uuid": "caa9f3a4-9da2-448c-9692-82c0b40b3c41",
    "hitokoto": "如果你自认是一位普通人，那么你就错了。",
    "type": "e",
    "from": "轻灯",
    "from_who": "幻空",
    "creator": "MukingIce",
    "creator_uid": 9213,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620398855",
    "length": 19
  },
  {
    "id": 7230,
    "uuid": "08c0095f-7c05-496b-8ec8-76ce2db61660",
    "hitokoto": "请别怕黑暗，你自带光环！",
    "type": "e",
    "from": "原创",
    "from_who": "Mi",
    "creator": "Mi",
    "creator_uid": 7310,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620522496",
    "length": 12
  },
  {
    "id": 7262,
    "uuid": "c8903cc0-eda0-4dd2-b0d6-37c93751cb44",
    "hitokoto": "缓缓流下的时光，照进你的眼睛，流进你的心里，印在你的笑里。",
    "type": "e",
    "from": "原创",
    "from_who": "一只叫一行的喵",
    "creator": "一只叫一行的喵",
    "creator_uid": 9261,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620878501",
    "length": 29
  },
  {
    "id": 7263,
    "uuid": "efc92c0f-3c35-4711-8abf-75532cd58a98",
    "hitokoto": "走过了人间风花雪月，看惯了世间爱恨情仇，却依旧捱不过短暂的寂寞。",
    "type": "e",
    "from": "原创",
    "from_who": "一只叫一行的喵",
    "creator": "一只叫一行的喵",
    "creator_uid": 9261,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620878633",
    "length": 32
  },
  {
    "id": 7264,
    "uuid": "889ac9b8-3022-4356-98f6-b3bdd9f2ec1d",
    "hitokoto": "绘守御之明信兮，书香随之丰年。",
    "type": "e",
    "from": "原创",
    "from_who": "一只叫一行的喵",
    "creator": "一只叫一行的喵",
    "creator_uid": 9261,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1620879173",
    "length": 15
  },
  {
    "id": 7304,
    "uuid": "9ebe5b0b-bf9c-45b7-b971-f6d1622c45f9",
    "hitokoto": "个人的一生都可以用来逐梦、体验各种未知，而不是一天重复了几十年。",
    "type": "e",
    "from": "RS-Nocsi--博客论坛",
    "from_who": "Abyss",
    "creator": "Abyss",
    "creator_uid": 8803,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1616847150",
    "length": 32
  },
  {
    "id": 7307,
    "uuid": "32391904-48d7-4355-804b-24dd0b4d7fa3",
    "hitokoto": "最遗憾的事情莫过于，我喜欢上你之后你不再喜欢我了。",
    "type": "e",
    "from": "原创",
    "from_who": "Voyage.",
    "creator": "Voyage.",
    "creator_uid": 8919,
    "reviewer": 9975,
    "commit_from": "web",
    "created_at": "1617703934",
    "length": 25
  },
  {
    "id": 7328,
    "uuid": "4d897880-50f0-44ef-8c7c-67cc7b9709bb",
    "hitokoto": "珍藏于心底的时光，是记忆深处最美的花。",
    "type": "e",
    "from": "原创",
    "from_who": "沐云湘夕",
    "creator": "沐云湘夕",
    "creator_uid": 9275,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1621637562",
    "length": 19
  },
  {
    "id": 7333,
    "uuid": "a0cd80e2-78b9-4df7-8abe-2a41a4f53f6e",
    "hitokoto": "我们生活在三维空间，我们生存在这个世界，但最终我们活成的都是自己的位面体。",
    "type": "e",
    "from": "生活",
    "from_who": "chirs zero",
    "creator": "chris zero",
    "creator_uid": 9415,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622297326",
    "length": 37
  },
  {
    "id": 7343,
    "uuid": "c117e966-8517-4fa3-b432-4bae802d889b",
    "hitokoto": "眼里要有光！",
    "type": "e",
    "from": "走，向前",
    "from_who": "Dfkuaid",
    "creator": "Dfkuaid",
    "creator_uid": 8704,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622199412",
    "length": 6
  },
  {
    "id": 7345,
    "uuid": "bfb4d87f-e512-485e-a286-2ffdfa687d30",
    "hitokoto": "月光的银边把广袤的夜空烫出个洞，里头塞满了少年的梦想。",
    "type": "e",
    "from": "月亮",
    "from_who": "余川",
    "creator": "余川",
    "creator_uid": 9450,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622945846",
    "length": 27
  },
  {
    "id": 7346,
    "uuid": "98ec4a6a-f341-472c-b33b-9963128941ab",
    "hitokoto": "如果可以的话，我也想成为这个世界中特殊的存在。",
    "type": "e",
    "from": "随想",
    "from_who": "”·躲猫猫＿.",
    "creator": "”·躲猫猫＿.",
    "creator_uid": 9459,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623053786",
    "length": 23
  },
  {
    "id": 7349,
    "uuid": "1964314d-37ec-4d8b-83ab-432efecba76a",
    "hitokoto": "得意不尽欢，失意心倍空，假意难割舍，真情总多变。",
    "type": "e",
    "from": "原创",
    "from_who": "抱月",
    "creator": "抱月",
    "creator_uid": 9483,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623341786",
    "length": 24
  },
  {
    "id": 7350,
    "uuid": "9352f723-26a7-40e5-94bd-444ebb66ded4",
    "hitokoto": "我们活在三维空间，我们生存在这个世界 ，但我们最终活成的都是我们自己的位面体。",
    "type": "e",
    "from": "生活",
    "from_who": "chris zero",
    "creator": "chris zero",
    "creator_uid": 9415,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1622559840",
    "length": 39
  },
  {
    "id": 7359,
    "uuid": "be35bf42-25b6-46b8-84e8-87f150706fc9",
    "hitokoto": "上帝伸出了决定命运了手指，我拼死反抗，却也欣然接受。",
    "type": "e",
    "from": "原创",
    "from_who": "命运",
    "creator": "命运",
    "creator_uid": 9526,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1623948432",
    "length": 26
  },
  {
    "id": 7377,
    "uuid": "52385222-0f8d-495c-913d-c87e5e241ddd",
    "hitokoto": "时间是最暴虐的存在，它能够毁掉一切。",
    "type": "e",
    "from": "我",
    "from_who": null,
    "creator": "孤独的人啊",
    "creator_uid": 9636,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625459547",
    "length": 18
  },
  {
    "id": 7379,
    "uuid": "4432c823-425c-49b1-b7a6-4f0b556d4914",
    "hitokoto": "相遇不一定有结果，但一定有意义。",
    "type": "e",
    "from": "原创",
    "from_who": "楠枫",
    "creator": "楠枫",
    "creator_uid": 3474,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617505973",
    "length": 16
  },
  {
    "id": 7386,
    "uuid": "eb51ac20-0f3a-44d6-be4a-c908e78ef03b",
    "hitokoto": "在放弃之前，成功的可能性永远不会归零。",
    "type": "e",
    "from": "原创",
    "from_who": "北城不夏",
    "creator": "亭外花",
    "creator_uid": 9661,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1625675072",
    "length": 19
  },
  {
    "id": 7393,
    "uuid": "9781e027-64c4-4be9-990b-3903b547f4ca",
    "hitokoto": "有时候你的视觉就是一场雨，我的伞不配对暴雨有所期待。",
    "type": "e",
    "from": "原创",
    "from_who": "二兄",
    "creator": "二兄",
    "creator_uid": 8896,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617527098",
    "length": 26
  },
  {
    "id": 7394,
    "uuid": "2add783a-2b5e-46d6-9e88-4ddd7986cb72",
    "hitokoto": "没有了希求，不再有祈望。",
    "type": "e",
    "from": "原创",
    "from_who": "二兄",
    "creator": "二兄",
    "creator_uid": 8896,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1617527222",
    "length": 12
  },
  {
    "id": 7398,
    "uuid": "149e6e26-cb9c-48b6-a241-12ae252b152d",
    "hitokoto": "新王把利剑刺入旧王的胸膛，将旧王的冠冕摘下而戴在自己的头上。",
    "type": "e",
    "from": "原创",
    "from_who": "孤独的人啊",
    "creator": "孤独的人啊",
    "creator_uid": 9636,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625804333",
    "length": 30
  },
  {
    "id": 7404,
    "uuid": "4890484c-7e38-4a26-a126-32c3e7a35cee",
    "hitokoto": "幸福的轮廓，大概是圆形吧；那痛苦呢？",
    "type": "e",
    "from": "原创",
    "from_who": "linkey2011",
    "creator": "key lin",
    "creator_uid": 2340,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1625069691",
    "length": 18
  },
  {
    "id": 7418,
    "uuid": "38f2e90f-8125-43a8-b1fe-b94e98578bdc",
    "hitokoto": "自信起来，你能做到任何事。",
    "type": "e",
    "from": "原创",
    "from_who": "HONTARG",
    "creator": "jigeshuohua",
    "creator_uid": 10371,
    "reviewer": 1,
    "commit_from": "web",
    "created_at": "1632714795",
    "length": 13
  },
  {
    "id": 7419,
    "uuid": "fed0926d-bb4c-4d74-917a-e68f1a7b1796",
    "hitokoto": "下坡路固然好走，可也许就再也上不来了。",
    "type": "e",
    "from": "Enthon聪明的小脑袋瓜",
    "from_who": "Enthon",
    "creator": "Enthon",
    "creator_uid": 9768,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626502061",
    "length": 19
  },
  {
    "id": 7420,
    "uuid": "33dd4c25-b432-4030-84c8-88d1c3edf1e2",
    "hitokoto": "金子与钻石都不是唯一的，可你却是。",
    "type": "e",
    "from": "Enthon聪明的小脑袋瓜",
    "from_who": "Enthon",
    "creator": "Enthon",
    "creator_uid": 9768,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626502335",
    "length": 17
  },
  {
    "id": 7421,
    "uuid": "89d1a409-0496-4184-b95f-141abb432d82",
    "hitokoto": "当丁达尔效应出现时，光便有了形状。",
    "type": "e",
    "from": "原创",
    "from_who": "未知",
    "creator": "Czz",
    "creator_uid": 9794,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626685821",
    "length": 17
  },
  {
    "id": 7422,
    "uuid": "c45a761c-8d23-4d25-8702-e8112f97ad5e",
    "hitokoto": "雾里浓云处，寻前路。",
    "type": "e",
    "from": "原创",
    "from_who": "Voyage.",
    "creator": "Voyage.",
    "creator_uid": 8919,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1617703845",
    "length": 10
  },
  {
    "id": 7428,
    "uuid": "6c32ec00-32a2-4c47-99ff-e43bc87dcda6",
    "hitokoto": "每个人都是生命中的过路的人，而我也在路途中。",
    "type": "e",
    "from": "冻符「Minus-K」",
    "from_who": "非科学のカッパ",
    "creator": "非科学のカッパ",
    "creator_uid": 8394,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1618144303",
    "length": 22
  },
  {
    "id": 7429,
    "uuid": "a66a75a4-44ea-42e4-8489-be2c5c03d84b",
    "hitokoto": "没有真正的快乐，除非找到……你爱的那个人。",
    "type": "e",
    "from": "随写",
    "from_who": "绎泽",
    "creator": "666wyf",
    "creator_uid": 7782,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1618487714",
    "length": 21
  },
  {
    "id": 7445,
    "uuid": "041987dd-e347-4d50-b948-60010b741cbf",
    "hitokoto": "你所有的大张旗鼓地表达，只是想换来一个能注意你的人。",
    "type": "e",
    "from": "自卑胆小且无用的慕瑾",
    "from_who": "MJEnvieBelle",
    "creator": "慕瑾",
    "creator_uid": 7588,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619436655",
    "length": 26
  },
  {
    "id": 7447,
    "uuid": "e539fda5-654c-4b25-9de1-c4174ccd8a67",
    "hitokoto": "穿川晓月皎明雾，烟起云涌润一花。",
    "type": "e",
    "from": "雾月夜",
    "from_who": "Heriko Deltana",
    "creator": "Heriko Deltana",
    "creator_uid": 9134,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619612103",
    "length": 16
  },
  {
    "id": 7449,
    "uuid": "7709f5ef-ddaf-4413-963e-2042280756d2",
    "hitokoto": "本来阴郁的一天，似乎看到一缕阳光破云而出。",
    "type": "e",
    "from": "网易云音乐",
    "from_who": "寂风",
    "creator": "寂风",
    "creator_uid": 9140,
    "reviewer": 1044,
    "commit_from": "web",
    "created_at": "1619689396",
    "length": 21
  },
  {
    "id": 7452,
    "uuid": "c6f88af3-6a43-4f5d-9ac3-f3b6be238187",
    "hitokoto": "青春，其实在与现实的接受与妥协时就结束了​",
    "type": "e",
    "from": "Naya",
    "from_who": "柳柳",
    "creator": "Naya",
    "creator_uid": 7785,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626896856",
    "length": 21
  },
  {
    "id": 7454,
    "uuid": "07e46ec3-d8f8-4cb5-a017-3a7018405ec0",
    "hitokoto": "信仰与孤独·真正的财富是一种思维方式.",
    "type": "e",
    "from": "QQ签名",
    "from_who": "草堂设计",
    "creator": "Little 胡",
    "creator_uid": 9837,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1626929396",
    "length": 19
  },
  {
    "id": 7460,
    "uuid": "0efce864-d999-46d4-aa0e-08de3720e7e3",
    "hitokoto": "这座城市里有很多人，但我对这些人无话可说；我的心里有很多话，但我的这些话，无人可说。",
    "type": "e",
    "from": "原创",
    "from_who": "长安",
    "creator": "长安",
    "creator_uid": 9881,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627286906",
    "length": 42
  },
  {
    "id": 7464,
    "uuid": "2d8a6bec-58a3-49c0-88d7-51315171bb42",
    "hitokoto": "燐灯三千燃长夜，烛照天门千山雪。",
    "type": "e",
    "from": "烛火千年",
    "from_who": "烛火千年",
    "creator": "烛火千年",
    "creator_uid": 9931,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627626058",
    "length": 16
  },
  {
    "id": 7470,
    "uuid": "0f7929fa-f4b9-4556-aaaf-16190e3df78c",
    "hitokoto": "忌寒北雁离难挽。",
    "type": "e",
    "from": "《源初幻想》",
    "from_who": "鹤空流乂",
    "creator": "鹤空流乂",
    "creator_uid": 9962,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627910759",
    "length": 8
  },
  {
    "id": 7473,
    "uuid": "57108a5e-212f-4d1a-bce2-ea27c4b137d7",
    "hitokoto": "愿你晴雨无伤。",
    "type": "e",
    "from": "《源初幻想》",
    "from_who": "鹤空流乂",
    "creator": "鹤空流乂",
    "creator_uid": 9962,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627963043",
    "length": 7
  },
  {
    "id": 7474,
    "uuid": "0467d7cf-bca2-4cee-81ab-0b0640e51069",
    "hitokoto": "她拨弄琴弦，扬起潮汐。",
    "type": "e",
    "from": "原创",
    "from_who": "我",
    "creator": "鸢尾",
    "creator_uid": 9969,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1627968443",
    "length": 11
  },
  {
    "id": 7481,
    "uuid": "37b65a26-093d-4573-8809-49053cc2f62f",
    "hitokoto": "十几岁的年纪里，谁都不是谁的一生。",
    "type": "e",
    "from": "生活",
    "from_who": null,
    "creator": "慕凯viel",
    "creator_uid": 10019,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628321717",
    "length": 17
  },
  {
    "id": 7482,
    "uuid": "6989d546-7f28-4774-a24f-83f32714f688",
    "hitokoto": "我们奔跑在曲折的时空，过去与未来发生交折。",
    "type": "e",
    "from": "原创",
    "from_who": null,
    "creator": "城",
    "creator_uid": 10085,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1628759026",
    "length": 21
  },
  {
    "id": 7493,
    "uuid": "802b3f74-f10e-4c16-9acb-c16eaf5f910b",
    "hitokoto": "时岁可忆流年，久别仍知归途。",
    "type": "e",
    "from": "《源初幻想》",
    "from_who": "鹤空流乂",
    "creator": "鹤空流乂",
    "creator_uid": 9962,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629255244",
    "length": 14
  },
  {
    "id": 7494,
    "uuid": "7a9dd985-0dd8-44f9-9a2c-ea77764b371c",
    "hitokoto": "不弄丢自己，是爱情的底线。",
    "type": "e",
    "from": "落叶",
    "from_who": "落叶",
    "creator": "落叶",
    "creator_uid": 10190,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629717228",
    "length": 13
  },
  {
    "id": 7497,
    "uuid": "08181217-1ad7-412c-b88c-5eb28a65c9e9",
    "hitokoto": "天流浅云，海泛清浪。",
    "type": "e",
    "from": "《源初幻想》",
    "from_who": "鹤空流乂",
    "creator": "鹤空流乂",
    "creator_uid": 9962,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1629420909",
    "length": 10
  },
  {
    "id": 7507,
    "uuid": "ec5e0897-9af3-4585-8032-05610888eb8e",
    "hitokoto": "努力到无能为力，拼搏到感动自己。",
    "type": "e",
    "from": "作者本人",
    "from_who": "忆",
    "creator": "忆",
    "creator_uid": 10268,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1630293654",
    "length": 16
  },
  {
    "id": 7510,
    "uuid": "259b1cdf-9788-43f0-9c64-fb4e6187cd15",
    "hitokoto": "我可以孑然一身，但不能心无所属。",
    "type": "e",
    "from": "呼呼呼呼兔",
    "from_who": "呼呼呼呼兔",
    "creator": "呼呼呼呼兔",
    "creator_uid": 10332,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1630853927",
    "length": 16
  },
  {
    "id": 7514,
    "uuid": "52ed8376-9db5-424f-8d21-ab89a71cc4ac",
    "hitokoto": "付出就会有收获，这收获不一定就是结果，也可以是经过。",
    "type": "e",
    "from": "原创",
    "from_who": "ants",
    "creator": "ants",
    "creator_uid": 10460,
    "reviewer": 4756,
    "commit_from": "web",
    "created_at": "1632415534",
    "length": 26
  }
]